import { defineComponent as A, ref as y, openBlock as d, createElementBlock as h, normalizeClass as P, createElementVNode as l, toDisplayString as k, normalizeStyle as pe, renderSlot as U, pushScopeId as ne, popScopeId as re, useSlots as Ot, unref as H, createCommentVNode as F, withDirectives as Ye, Fragment as R, renderList as X, createTextVNode as ue, computed as Me, onMounted as Ae, onUnmounted as Ie, mergeProps as Wt, createVNode as ae, withCtx as se, provide as Yt, inject as et, resolveComponent as wn, createBlock as ct, watch as $e, isRef as kn, readonly as yn, toRef as kt, h as Cn, resolveDirective as qt, watchEffect as mt, createStaticVNode as Ge, shallowRef as Dn, reactive as Aa, resolveDynamicComponent as Sa } from "vue";
const La = (r) => (ne("data-v-4e2849c3"), r = r(), re(), r), $n = { class: "aeb-accordion__heading" }, En = /* @__PURE__ */ La(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "6",
  viewBox: "0 0 10 6",
  width: "10",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M0.999999 1L4.92929 4.92929C4.96834 4.96834 5.03166 4.96834 5.07071 4.92929L9 1",
    stroke: "#27303E",
    "stroke-linecap": "round",
    "stroke-width": "2"
  })
], -1)), Mn = [
  En
], Tn = /* @__PURE__ */ La(() => /* @__PURE__ */ l("div", { class: "aeb-accordion__stub-padding" }, null, -1)), xn = {
  name: "aeb-accordion"
}, Fn = /* @__PURE__ */ A({
  ...xn,
  props: {
    header: {}
  },
  setup(r) {
    const e = y(!1), t = y();
    return (n, a) => {
      var i;
      return d(), h("div", {
        class: P([{ "aeb-accordion--open": e.value }, "aeb-accordion"])
      }, [
        l("div", {
          class: P([{ "aeb-accordion__header--open": e.value }, "aeb-accordion__header"]),
          onClick: a[0] || (a[0] = (s) => e.value = !e.value)
        }, [
          l("span", $n, k(n.header), 1),
          l("div", {
            class: P([{ "aeb-accordion__arrow-icon--open": e.value }, "aeb-accordion__arrow-icon"])
          }, Mn, 2)
        ], 2),
        l("div", {
          ref_key: "contentRef",
          ref: t,
          style: pe({
            height: e.value ? ((i = t.value) == null ? void 0 : i.scrollHeight) + "px" : 0
          }),
          class: "aeb-accordion__content"
        }, [
          U(n.$slots, "default", {}, void 0, !0),
          Tn
        ], 4)
      ], 2);
    };
  }
}), B = (r, e) => {
  const t = r.__vccOpts || r;
  for (const [n, a] of e)
    t[n] = a;
  return t;
}, Pn = /* @__PURE__ */ B(Fn, [["__scopeId", "data-v-4e2849c3"]]), An = {
  name: "aeb-action-bar"
}, Sn = /* @__PURE__ */ A({
  ...An,
  props: {
    zIndex: {},
    isOpen: { type: Boolean }
  },
  setup(r) {
    return (e, t) => (d(), h("div", {
      class: P([{ "aeb-action-bar--open": e.isOpen }, "aeb-action-bar"]),
      style: pe({ zIndex: e.zIndex })
    }, [
      U(e.$slots, "default", {}, void 0, !0)
    ], 6));
  }
}), Ln = /* @__PURE__ */ B(Sn, [["__scopeId", "data-v-74a26211"]]), On = ["disabled"], Bn = {
  key: 0,
  class: "button__icon--left-wrapper"
}, In = ["src"], Rn = ["src"], Vn = {
  name: "aeb-button"
}, Nn = /* @__PURE__ */ A({
  ...Vn,
  props: {
    variant: { default: "primary" },
    size: { default: "medium" },
    iconSource: { default: () => ({
      left: "",
      right: ""
    }) },
    warning: { type: Boolean, default: !1 },
    fill: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(r, { emit: e }) {
    const t = e, n = Ot();
    return (a, i) => (d(), h("button", {
      onClick: i[0] || (i[0] = (s) => t("click")),
      disabled: a.disabled,
      class: P(["button", [
        "button-" + a.variant,
        "button-size-" + a.size,
        {
          "button-warning": a.warning,
          "button-icon-only": !H(n).default && a.iconSource,
          "button-fill": a.fill
        }
      ]])
    }, [
      a.iconSource.left ? (d(), h("span", Bn, [
        l("img", {
          class: "button__icon button__icon--left",
          src: a.iconSource.left,
          alt: "left-icon"
        }, null, 8, In)
      ])) : F("", !0),
      U(a.$slots, "default", {}, void 0, !0),
      a.iconSource.right ? (d(), h("img", {
        key: 1,
        class: "button__icon button__icon--right",
        src: a.iconSource.right,
        alt: "right-icon"
      }, null, 8, Rn)) : F("", !0)
    ], 10, On));
  }
}), Ue = /* @__PURE__ */ B(Nn, [["__scopeId", "data-v-231f003e"]]), Hn = {
  key: 2,
  class: "primary-button__arrow-down"
}, Yn = {
  name: "aeb-button-old"
}, Un = /* @__PURE__ */ A({
  ...Yn,
  props: {
    label: { default: "" },
    solid: { type: Boolean, default: !0 },
    fill: { type: Boolean, default: !1 },
    showIcon: { type: Boolean, default: !1 },
    iconSource: { default: "" },
    disabledIconSource: { default: "" },
    hoveredIconSource: { default: "" },
    showDropdown: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    hoverClass: { default: "" },
    leftIcon: { type: Boolean, default: !0 },
    rightIcon: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(r, { emit: e }) {
    const t = e, n = y(!1);
    return (a, i) => (d(), h("div", {
      class: P([[
        {
          "primary-button--solid": a.solid,
          "primary-button--fill": a.fill,
          "primary-button--solid--disabled": a.solid && a.disabled,
          "primary-button--disabled": !a.solid && a.disabled
        },
        a.hoverClass
      ], "primary-button"]),
      onClick: i[0] || (i[0] = (s) => t("click")),
      onMouseleave: i[1] || (i[1] = (s) => n.value = !1),
      onMouseover: i[2] || (i[2] = (s) => n.value = !0)
    }, [
      a.label || a.showDropdown || a.showIcon ? (d(), h("div", {
        key: 0,
        class: P([{
          "primary-button__label-wrapper--single": !a.showIcon && !a.showDropdown
        }, "primary-button__label-wrapper"])
      }, [
        a.showIcon && a.leftIcon ? (d(), h("div", {
          key: 0,
          class: P([{ "primary-button__label-image--left": a.label !== "" }, "primary-button__label-image"]),
          style: pe({
            backgroundImage: "url(" + (n.value && a.hoveredIconSource ? a.hoveredIconSource : a.disabled && a.disabledIconSource ? a.disabledIconSource : a.iconSource) + ")"
          })
        }, null, 6)) : F("", !0),
        l("div", null, k(a.label), 1),
        a.showIcon && a.rightIcon ? (d(), h("div", {
          key: 1,
          class: P([{ "primary-button__label-image--right": a.label !== "" }, "primary-button__label-image"]),
          style: pe({
            backgroundImage: "url(" + (n.value && a.hoveredIconSource ? a.hoveredIconSource : a.iconSource) + ")"
          })
        }, null, 6)) : F("", !0),
        a.showDropdown ? (d(), h("div", Hn)) : F("", !0)
      ], 2)) : (d(), h("div", {
        key: 1,
        class: P([a.hoverClass, "primary-button__label-wrapper"])
      }, [
        U(a.$slots, "default", {}, void 0, !0)
      ], 2))
    ], 34));
  }
}), Wn = /* @__PURE__ */ B(Un, [["__scopeId", "data-v-a101b4ae"]]), qn = (r) => (ne("data-v-dda166fc"), r = r(), re(), r), Gn = ["for"], jn = { class: "aeb-checkbox__container" }, Zn = ["id", "checked", "disabled", "name"], zn = /* @__PURE__ */ qn(() => /* @__PURE__ */ l("div", { class: "aeb-checkbox__indicator" }, [
  /* @__PURE__ */ l("svg", {
    width: "12",
    height: "8",
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.28571 8L0 4.15385L1.2 3.07692L4.28571 5.84615L10.8 0L12 1.07692L4.28571 8Z",
      fill: "white"
    })
  ])
], -1)), Qn = { class: "aeb-checkbox__label" }, Xn = {
  name: "aeb-checkbox"
}, Kn = /* @__PURE__ */ A({
  ...Xn,
  props: {
    id: {},
    name: {},
    checked: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 }
  },
  emits: ["change"],
  setup(r, { emit: e }) {
    const t = e, n = y(!1), a = (s) => {
      n.value = !n.value, t("change", s);
    }, i = (s) => {
      s.stopPropagation();
    };
    return (s, o) => (d(), h("div", {
      class: P(["aeb-checkbox", {
        "aeb-checkbox-checked": n.value,
        "aeb-checkbox-error": s.hasError,
        "aeb-checkbox-disabled": s.disabled
      }])
    }, [
      l("label", {
        for: s.id,
        class: "aeb-checkbox__layout"
      }, [
        l("div", jn, [
          l("input", {
            id: s.id,
            checked: n.value,
            disabled: s.disabled,
            name: s.name,
            hidden: "",
            type: "checkbox",
            onChange: o[0] || (o[0] = (u) => i(u)),
            onClick: o[1] || (o[1] = (u) => a(u))
          }, null, 40, Zn),
          zn,
          l("div", Qn, [
            U(s.$slots, "default", {}, void 0, !0)
          ])
        ])
      ], 8, Gn)
    ], 2));
  }
}), Jn = /* @__PURE__ */ B(Kn, [["__scopeId", "data-v-dda166fc"]]), er = (r) => (ne("data-v-a10a3cd1"), r = r(), re(), r), tr = ["for"], ar = { class: "aeb-checkbox-old-container" }, nr = ["id", "checked", "disabled", "name"], rr = /* @__PURE__ */ er(() => /* @__PURE__ */ l("div", { class: "aeb-checkbox-old-indicator" }, [
  /* @__PURE__ */ l("svg", {
    fill: "none",
    height: "22",
    viewBox: "0 0 22 22",
    width: "22",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ l("path", {
      "clip-rule": "evenodd",
      d: "M9 16L4 11.1923L5.4 9.84615L9 13.3077L16.6 6L18 7.34615L9 16V16Z",
      fill: "#EEEEEE",
      "fill-rule": "evenodd"
    })
  ])
], -1)), sr = { class: "aeb-checkbox-old-label" }, ir = {
  name: "aeb-checkbox-old"
}, or = /* @__PURE__ */ A({
  ...ir,
  props: {
    id: {},
    hasError: { type: Boolean },
    name: { default: void 0 },
    checked: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["change"],
  setup(r, { emit: e }) {
    const t = e, n = y(!1), a = (s) => {
      n.value = !n.value, t("change", s);
    }, i = (s) => {
      s.stopPropagation();
    };
    return (s, o) => (d(), h("div", {
      class: P({
        "aeb-checkbox-old-checked": n.value,
        "aeb-checkbox-old-disabled": s.disabled,
        "aeb-checkbox-old-error": s.hasError,
        "aeb-checkbox-old-checked-disabled": s.checked && s.disabled
      })
    }, [
      l("label", {
        for: s.id,
        class: "aeb-checkbox-old-layout"
      }, [
        l("div", ar, [
          l("input", {
            id: s.id,
            checked: n.value,
            disabled: s.disabled,
            name: s.name,
            hidden: "",
            type: "checkbox",
            onChange: o[0] || (o[0] = (u) => i(u)),
            onClick: o[1] || (o[1] = (u) => a(u))
          }, null, 40, nr),
          rr,
          l("div", sr, [
            U(s.$slots, "default", {}, void 0, !0)
          ])
        ])
      ], 8, tr)
    ], 2));
  }
}), ur = /* @__PURE__ */ B(or, [["__scopeId", "data-v-a10a3cd1"]]), dt = {
  beforeMount: (r, e) => {
    r.clickOutsideEvent = (t) => {
      r == t.target || r.contains(t.target) || e.value(t);
    }, document.addEventListener("click", r.clickOutsideEvent);
  },
  unmounted: (r) => {
    document.removeEventListener("click", r.clickOutsideEvent);
  }
}, lr = (r) => (ne("data-v-63080e05"), r = r(), re(), r), cr = { class: "aeb-code-input" }, dr = { class: "aeb-code-input__title" }, hr = { class: "aeb-code-input__tip" }, fr = ["maxLength", "value"], vr = {
  key: 0,
  className: "aeb-code-input__field-input-caret"
}, pr = {
  key: 0,
  class: "aeb-code-input__text-wrong"
}, mr = { key: 1 }, gr = /* @__PURE__ */ lr(() => /* @__PURE__ */ l("span", { class: "aeb-code-input__text-info" }, " Запросить повторную отправку можно через ", -1)), _r = { class: "aeb-code-input__text-time" }, br = {
  name: "aeb-code-input"
}, wr = /* @__PURE__ */ A({
  ...br,
  props: {
    title: {},
    tip: {},
    secondsUntilRetry: { default: 60 },
    codeLength: { default: 6 },
    hasError: { type: Boolean, default: !1 },
    codeCompleted: {},
    timeOut: {},
    resendClick: {}
  },
  setup(r) {
    const e = r, t = y(""), n = y(e.secondsUntilRetry), a = /^[0-9\b]+$/;
    function i(_) {
      t.value.length < e.codeLength && (_.key === "" || a.test(_.key)) && (t.value += _.key), _.key === "Backspace" && (t.value = t.value.substring(
        0,
        t.value.length - 1
      ));
    }
    function s(_) {
      var D;
      const b = ((D = _.clipboardData) == null ? void 0 : D.getData("text")) || "";
      a.test(b) && (t.value = b.substring(0, e.codeLength));
    }
    function o() {
      const _ = setInterval(() => {
        n.value < 1 ? clearInterval(_) : n.value -= 1;
      }, 1e3);
    }
    o();
    function u() {
      n.value = e.secondsUntilRetry, o();
    }
    function c() {
      g.value.focus(), f.value = !0;
    }
    function v() {
      f.value = !1;
    }
    const g = y(null), f = y(!1);
    return (_, b) => (d(), h("div", cr, [
      l("h1", dr, k(_.title), 1),
      l("span", hr, k(_.tip), 1),
      Ye((d(), h("div", {
        class: "aeb-code-input__field-wrapper",
        onClick: b[1] || (b[1] = (D) => c())
      }, [
        l("input", {
          ref_key: "inputRef",
          ref: g,
          class: "aeb-code-input__field",
          inputMode: "numeric",
          autoComplete: "one-time-code",
          maxLength: _.codeLength,
          value: t.value,
          onInput: b[0] || (b[0] = (D) => D.preventDefault()),
          onKeydown: i,
          onPaste: s
        }, null, 40, fr),
        (d(!0), h(R, null, X([...Array(_.codeLength)], (D, p) => (d(), h("span", {
          class: P(["aeb-code-input__field-input", [
            {
              "aeb-code-input__field-input--active": t.value.length === p && f.value,
              "aeb-code-input__field-input--has-error": _.hasError
            }
          ]])
        }, [
          ue(k(t.value[p]) + " ", 1),
          p === t.value.length && f.value ? (d(), h("div", vr)) : F("", !0)
        ], 2))), 256))
      ])), [
        [H(dt), v]
      ]),
      _.hasError ? (d(), h("span", pr, " Неверный код ")) : F("", !0),
      n.value > 0 ? (d(), h("div", mr, [
        gr,
        l("span", _r, k(n.value), 1)
      ])) : F("", !0),
      n.value ? F("", !0) : (d(), h("span", {
        key: 2,
        class: "aeb-code-input__text-again",
        onClick: u
      }, " Отправить код повторно "))
    ]));
  }
}), kr = /* @__PURE__ */ B(wr, [["__scopeId", "data-v-63080e05"]]), yr = {
  ref: "tooltipRef",
  class: "aeb-new-tooltip"
}, Cr = { class: "aeb-new-tooltip__container" }, Dr = {
  name: "aeb-tooltip-component"
}, Oa = /* @__PURE__ */ A({
  ...Dr,
  props: {
    content: { default: "" }
  },
  setup(r) {
    return (e, t) => (d(), h("div", yr, [
      l("div", Cr, [
        ue(k(e.content) + " ", 1),
        e.content ? F("", !0) : U(e.$slots, "default", { key: 0 })
      ])
    ], 512));
  }
}), $r = {
  name: "aeb-tooltip"
}, Ba = /* @__PURE__ */ A({
  ...$r,
  props: {
    content: { default: "" },
    position: { default: "top" },
    overflow: { type: Boolean, default: !1 }
  },
  setup(r) {
    const e = r;
    let t = !1;
    const n = y(), a = y(), i = Me(() => {
      var v;
      return (v = a == null ? void 0 : a.value) == null ? void 0 : v.$el;
    }), s = {
      right: (v, g) => {
        const f = v.top + v.height / 2, _ = g.offsetHeight / 2;
        return [
          v.left + v.width + 15,
          f - _
        ];
      },
      bottom: (v, g) => {
        const f = v.right - v.width / 2, _ = g.offsetWidth / 2;
        return [f - _, v.bottom + 15];
      },
      left: (v, g) => {
        const f = v.top + v.height / 2, _ = g.offsetHeight / 2;
        return [
          v.left - g.offsetWidth - 15,
          f - _
        ];
      },
      top: (v, g) => {
        const f = v.right - v.width / 2, _ = g.offsetWidth / 2;
        return [
          f - _,
          v.top - g.offsetHeight - 15
        ];
      }
    }, o = (v) => {
      t ? u() : (v.timeStamp, c());
    }, u = () => {
      t = !1, i.value.className = "aeb-new-tooltip";
    }, c = () => {
      var _, b;
      if (e.overflow && (n != null && n.value) && !(((_ = n == null ? void 0 : n.value) == null ? void 0 : _.scrollWidth) > n.value.offsetWidth))
        return;
      t = !0;
      const v = (b = n == null ? void 0 : n.value) == null ? void 0 : b.getBoundingClientRect(), [g, f] = s[e.position](
        v,
        i.value
      );
      i.value.className = `aeb-new-tooltip aeb-new-tooltip--open aeb-new-tooltip--${e.position}`, i.value.style.left = `${g}px`, i.value.style.top = `${f}px`;
    };
    return Ae(() => {
      var v, g, f;
      (v = n.value) == null || v.addEventListener("mouseenter", c), (g = n.value) == null || g.addEventListener("mouseleave", u), (f = n.value) == null || f.addEventListener("touchstart", o);
    }), Ie(() => {
      var v, g, f;
      (v = n.value) == null || v.removeEventListener("mouseenter", c), (g = n.value) == null || g.removeEventListener("mouseleave", u), (f = n.value) == null || f.removeEventListener("touchstart", o);
    }), (v, g) => (d(), h("div", Wt({
      ref_key: "elementRef",
      ref: n
    }, e), [
      U(v.$slots, "default"),
      ae(Oa, {
        ref_key: "tooltipProxyRef",
        ref: a,
        content: v.content
      }, {
        default: se(() => [
          U(v.$slots, "tooltip")
        ]),
        _: 3
      }, 8, ["content"])
    ], 16));
  }
}), Er = { class: "aeb-label" }, Mr = { class: "aeb-icon" }, Tr = {
  name: "aeb-form-field"
}, st = /* @__PURE__ */ A({
  ...Tr,
  props: {
    center: { type: Boolean },
    error: { type: Boolean },
    cssMod: { default: "none" }
  },
  setup(r, { expose: e }) {
    const t = y(!1), n = y("");
    return Yt("onFocus", () => t.value = !0), Yt("onBlur", () => t.value = !1), Yt("onInput", (i) => {
      const s = i.target;
      n.value = s == null ? void 0 : s.value;
    }), e({ resetValue: () => {
      n.value = "";
    } }), (i, s) => (d(), h("div", {
      class: P([{
        center: i.center,
        focused: t.value,
        "aeb-form-field--svoi": i.cssMod === "svoi",
        "has-value": n.value,
        error: i.error
      }, "aeb-form-field"])
    }, [
      U(i.$slots, "default"),
      l("div", Er, [
        U(i.$slots, "label")
      ]),
      l("div", Mr, [
        U(i.$slots, "icon")
      ])
    ], 2));
  }
}), xr = {
  name: "aeb-input"
}, bt = /* @__PURE__ */ A({
  ...xr,
  setup(r) {
    const e = et("onFocus", () => {
    }), t = et("onBlur", () => {
    }), n = et("onInput", (a) => a);
    return (a, i) => (d(), h("input", {
      class: "aeb-input",
      onBlur: i[0] || (i[0] = //@ts-ignore
      (...s) => H(t) && H(t)(...s)),
      onFocus: i[1] || (i[1] = //@ts-ignore
      (...s) => H(e) && H(e)(...s)),
      onInput: i[2] || (i[2] = (s) => H(n)(s))
    }, null, 32));
  }
}), Fr = {
  name: "aeb-textarea"
}, Ia = /* @__PURE__ */ A({
  ...Fr,
  setup(r) {
    const e = et("onFocus", () => {
    }), t = et("onBlur", () => {
    }), n = et("onInput", (a) => a);
    return (a, i) => (d(), h("textarea", {
      class: "aeb-input",
      onBlur: i[0] || (i[0] = //@ts-ignore
      (...s) => H(t) && H(t)(...s)),
      onFocus: i[1] || (i[1] = //@ts-ignore
      (...s) => H(e) && H(e)(...s)),
      onInput: i[2] || (i[2] = (s) => H(n)(s))
    }, null, 32));
  }
}), Bt = (r) => (ne("data-v-eb4f0997"), r = r(), re(), r), Pr = { class: "aeb-comment" }, Ar = { class: "aeb-comment__avatar-column" }, Sr = { class: "aeb-comment__avatar" }, Lr = ["src"], Or = {
  key: 1,
  class: "aeb-comment__initials"
}, Br = { class: "aeb-comment__comment-column" }, Ir = { class: "aeb-comment__author-wrapper" }, Rr = { class: "aeb-comment__author-group" }, Vr = /* @__PURE__ */ Bt(() => /* @__PURE__ */ l("div", { class: "aeb-comment__reply-icon" }, [
  /* @__PURE__ */ l("svg", {
    fill: "none",
    height: "8",
    viewBox: "0 0 10 8",
    width: "10",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ l("path", {
      d: "M4.68742 1.87519H3.7499V0.312666C3.7499 0.183289 3.67053 0.0676621 3.55052 0.0207864C3.43052 -0.0254644 3.29365 0.00703617 3.20614 0.102663L0.081095 3.54022C-0.0270317 3.65897 -0.0270317 3.84085 0.081095 3.96022L3.20614 7.39778C3.26677 7.46403 3.35115 7.50028 3.4374 7.50028C3.47552 7.50028 3.51365 7.4934 3.55052 7.47965C3.67053 7.43278 3.7499 7.31715 3.7499 7.18777V5.62525H4.61929C6.40307 5.62525 8.1306 6.26401 9.48437 7.42528C9.57624 7.50465 9.70812 7.52278 9.81812 7.47153C9.92937 7.4209 10 7.30965 10 7.18777C10 4.25835 7.61684 1.87519 4.68742 1.87519Z",
      fill: "#A3AAAE"
    })
  ])
], -1)), Nr = { class: "aeb-comment__reply-host" }, Hr = { class: "aeb-comment__author-name" }, Yr = /* @__PURE__ */ Bt(() => /* @__PURE__ */ l("div", { class: "aeb-comment__author-info" }, [
  /* @__PURE__ */ l("svg", {
    fill: "none",
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ l("path", {
      d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z",
      stroke: "#27303E"
    }),
    /* @__PURE__ */ l("path", {
      d: "M5.8125 6.3584C5.83529 5.78223 6.03874 5.31348 6.42285 4.95215C6.81022 4.59082 7.3457 4.41016 8.0293 4.41016C8.66732 4.41016 9.18652 4.58105 9.58691 4.92285C9.9873 5.26139 10.1875 5.69434 10.1875 6.22168C10.1875 6.92806 9.8457 7.48633 9.16211 7.89648C8.84961 8.08203 8.63639 8.25456 8.52246 8.41406C8.40853 8.57031 8.35156 8.77539 8.35156 9.0293V9.32715H7.34082L7.33594 8.93652C7.32292 8.59798 7.39128 8.3099 7.54102 8.07227C7.69401 7.83464 7.93978 7.61328 8.27832 7.4082C8.5778 7.22917 8.78613 7.05664 8.90332 6.89062C9.02051 6.72461 9.0791 6.51628 9.0791 6.26562C9.0791 5.98568 8.97819 5.75618 8.77637 5.57715C8.57454 5.39811 8.30762 5.30859 7.97559 5.30859C7.6403 5.30859 7.37012 5.40299 7.16504 5.5918C6.95996 5.7806 6.84603 6.03613 6.82324 6.3584H5.8125ZM7.85352 11.5879C7.67448 11.5879 7.52311 11.5277 7.39941 11.4072C7.27572 11.2868 7.21387 11.137 7.21387 10.958C7.21387 10.779 7.27572 10.6292 7.39941 10.5088C7.52311 10.3883 7.67448 10.3281 7.85352 10.3281C8.03581 10.3281 8.1888 10.3883 8.3125 10.5088C8.4362 10.6292 8.49805 10.779 8.49805 10.958C8.49805 11.137 8.4362 11.2868 8.3125 11.4072C8.1888 11.5277 8.03581 11.5879 7.85352 11.5879Z",
      fill: "#27303E"
    })
  ])
], -1)), Ur = { class: "aeb-comment__tooltip" }, Wr = { class: "aeb-comment__comment-wrapper" }, qr = { class: "aeb-comment__comment-header" }, Gr = { class: "aeb-comment__comment-txt" }, jr = { class: "aeb-comment__date-response" }, Zr = { class: "aeb-comment__comment-date" }, zr = { class: "aeb-comment__submit" }, Qr = /* @__PURE__ */ Bt(() => /* @__PURE__ */ l("div", { class: "aeb-comment__responses" }, "Ответы", -1)), Xr = { class: "aeb-comment__response-counter" }, Kr = /* @__PURE__ */ Bt(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "6",
  viewBox: "0 0 10 6",
  width: "10",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M0.999999 5L4.92929 1.07071C4.96834 1.03166 5.03166 1.03166 5.07071 1.07071L9 5",
    stroke: "#2F88F0",
    "stroke-linecap": "round",
    "stroke-width": "2"
  })
], -1)), Jr = [
  Kr
], es = {
  name: "aeb-comment"
}, ts = /* @__PURE__ */ A({
  ...es,
  props: {
    comment: {}
  },
  emits: ["response"],
  setup(r, { emit: e }) {
    const t = r, n = e, a = y(null), i = y(!1), s = y(!1), o = y(!1), u = y(!1), c = (p) => {
      o.value = !p.target.value;
    }, v = (p) => {
      u.value = !p.target.value;
    }, g = () => {
      i.value = !i.value;
    }, f = () => {
      s.value = !s.value;
    }, _ = (p) => {
      n("response", p);
    }, b = (p) => {
      p.preventDefault();
    }, D = () => {
      var w, E, C, Y, O, $, T;
      const p = (E = ((w = a.value) == null ? void 0 : w.elements).title) == null ? void 0 : E.value, m = (Y = ((C = a.value) == null ? void 0 : C.elements).content) == null ? void 0 : Y.value;
      o.value = !p, u.value = !m, !(!p || !m) && (n("response", {
        title: p,
        content: m,
        hash: (O = t.comment) == null ? void 0 : O.hash,
        parentHash: ($ = t.comment) == null ? void 0 : $.parentHash,
        parentName: (T = t.comment) == null ? void 0 : T.parentName,
        firstName: "Дмитрий",
        lastName: "Сахаров"
      }), s.value = !1);
    };
    return (p, m) => {
      var E, C, Y, O, $, T, j, fe, we, ke, L, ve, W, Q, me, Ze, Re;
      const w = wn("aeb-comment");
      return d(), h("div", Pr, [
        l("div", Ar, [
          l("div", Sr, [
            (E = p.comment) != null && E.avatar ? (d(), h("img", {
              key: 0,
              src: (C = p.comment) == null ? void 0 : C.avatar
            }, null, 8, Lr)) : (d(), h("div", Or, k((Y = p.comment) == null ? void 0 : Y.firstName.slice(0, 1)) + k((O = p.comment) == null ? void 0 : O.lastName.slice(0, 1)), 1))
          ])
        ]),
        l("div", Br, [
          l("div", Ir, [
            l("div", Rr, [
              ue(k(($ = p.comment) == null ? void 0 : $.group) + " ", 1),
              (T = p.comment) != null && T.parentName ? (d(), h(R, { key: 0 }, [
                Vr,
                l("span", Nr, k((j = p.comment) == null ? void 0 : j.parentName), 1)
              ], 64)) : F("", !0)
            ]),
            l("div", Hr, [
              ue(k((fe = p.comment) == null ? void 0 : fe.fullName) + " ", 1),
              ae(Ba, { position: "right" }, {
                tooltip: se(() => {
                  var ye;
                  return [
                    l("div", null, [
                      l("div", Ur, k((ye = p.comment) == null ? void 0 : ye.aboutAuthor), 1)
                    ])
                  ];
                }),
                default: se(() => [
                  Yr
                ]),
                _: 1
              })
            ])
          ]),
          l("div", Wr, [
            l("div", qr, k((we = p.comment) == null ? void 0 : we.title), 1),
            l("div", Gr, k((ke = p.comment) == null ? void 0 : ke.content), 1)
          ]),
          l("div", jr, [
            l("div", Zr, k((L = p.comment) == null ? void 0 : L.date), 1),
            l("div", {
              class: "aeb-comment__comment-response",
              onClick: f
            }, " Ответить ")
          ]),
          s.value ? (d(), h("form", {
            key: 0,
            ref_key: "form",
            ref: a,
            class: "aeb-comment__response-form",
            name: "responseForm",
            onSubmit: m[2] || (m[2] = (ye) => b(ye))
          }, [
            l("div", {
              class: P([{
                "aeb-comment__input--error": o.value
              }, "aeb-comment__input"])
            }, [
              ae(st, { error: o.value }, {
                label: se(() => [
                  ue("Заголовок комментария")
                ]),
                default: se(() => [
                  ae(bt, {
                    name: "title",
                    type: "text",
                    onInput: m[0] || (m[0] = (ye) => c(ye))
                  })
                ]),
                _: 1
              }, 8, ["error"])
            ], 2),
            l("div", {
              class: P([{
                "aeb-comment__input--error": u.value
              }, "aeb-comment__input"])
            }, [
              ae(st, { error: u.value }, {
                label: se(() => [
                  ue("Текст комментария")
                ]),
                default: se(() => [
                  ae(Ia, {
                    name: "content",
                    style: { height: "140px" },
                    onInput: m[1] || (m[1] = (ye) => v(ye))
                  })
                ]),
                _: 1
              }, 8, ["error"])
            ], 2),
            l("div", zr, [
              ae(Ue, { onClick: D }, {
                default: se(() => [
                  ue("Отправить")
                ]),
                _: 1
              })
            ])
          ], 544)) : F("", !0),
          (ve = p.comment) != null && ve.nestedComments && ((W = p.comment) != null && W.nestedComments.length) ? (d(), h("div", {
            key: 1,
            class: "aeb-comment__response-ctrls",
            onClick: g
          }, [
            Qr,
            l("div", Xr, k((Q = p.comment) == null ? void 0 : Q.nestedComments.length), 1),
            l("div", {
              class: P([{
                "aeb-comment__arrow-icon--active": i.value
              }, "aeb-comment__arrow-icon"])
            }, Jr, 2)
          ])) : F("", !0),
          (me = p.comment) != null && me.nestedComments && ((Ze = p.comment) != null && Ze.nestedComments.length) && i.value ? (d(!0), h(R, { key: 2 }, X((Re = p.comment) == null ? void 0 : Re.nestedComments, (ye, ze) => (d(), ct(w, {
            key: ze,
            comment: ye,
            onResponse: m[3] || (m[3] = (Ee) => _(Ee))
          }, null, 8, ["comment"]))), 128)) : F("", !0)
        ])
      ]);
    };
  }
}), as = /* @__PURE__ */ B(ts, [["__scopeId", "data-v-eb4f0997"]]), ht = (r) => (ne("data-v-331af776"), r = r(), re(), r), ns = { class: "credit-item-card__title" }, rs = { class: "credit-item-card__title-text" }, ss = { class: "credit-item-card__details-wrapper" }, is = { class: "credit-item-card__credit-details" }, os = {
  key: 0,
  class: "credit-item-card__credit-details-item"
}, us = /* @__PURE__ */ ht(() => /* @__PURE__ */ l("div", { class: "credit-item-card__credit-details-item-title" }, " Срок кредита ", -1)), ls = /* @__PURE__ */ ht(() => /* @__PURE__ */ l("div", { class: "credit-item-card__credit-details-item-separator" }, null, -1)), cs = { class: "credit-item-card__credit-details-item-value" }, ds = {
  key: 1,
  class: "credit-item-card__credit-details-item"
}, hs = /* @__PURE__ */ ht(() => /* @__PURE__ */ l("div", { class: "credit-item-card__credit-details-item-title" }, " Ставка ", -1)), fs = /* @__PURE__ */ ht(() => /* @__PURE__ */ l("div", { class: "credit-item-card__credit-details-item-separator" }, null, -1)), vs = { class: "credit-item-card__credit-details-item-value" }, ps = {
  key: 2,
  class: "credit-item-card__credit-details-item"
}, ms = /* @__PURE__ */ ht(() => /* @__PURE__ */ l("div", { class: "credit-item-card__credit-details-item-title" }, " Сумма кредита ", -1)), gs = /* @__PURE__ */ ht(() => /* @__PURE__ */ l("div", { class: "credit-item-card__credit-details-item-separator" }, null, -1)), _s = { class: "credit-item-card__credit-details-item-value" }, bs = { class: "credit-item-card__button-wrapper" }, ws = {
  name: "aeb-credit-item-card"
}, ks = /* @__PURE__ */ A({
  ...ws,
  props: {
    cardInfo: {}
  },
  emits: ["buttonClickEvent", "infoClickEvent"],
  setup(r, { emit: e }) {
    const t = e;
    return (n, a) => {
      var i, s, o, u, c, v, g, f, _, b, D, p, m, w, E, C, Y, O, $, T;
      return d(), h("div", {
        style: pe({
          backgroundImage: ((i = n.cardInfo) == null ? void 0 : i.image) && `url('/assets/images/product-cards/${n.cardInfo.image}')`,
          backgroundColor: (s = n.cardInfo) == null ? void 0 : s.backgroundColor
        }),
        class: "credit-item-card"
      }, [
        l("div", {
          class: "credit-item-card__info-icon",
          onClick: a[0] || (a[0] = (j) => t("infoClickEvent"))
        }),
        l("div", {
          class: "credit-item-card__title-wrapper",
          onClick: a[1] || (a[1] = (j) => t("buttonClickEvent"))
        }, [
          l("div", ns, "«" + k((o = n.cardInfo) == null ? void 0 : o.title) + "»", 1),
          l("div", rs, k((u = n.cardInfo) == null ? void 0 : u.caption), 1)
        ]),
        l("div", ss, [
          l("div", is, [
            (v = (c = n.cardInfo) == null ? void 0 : c.details) != null && v.time ? (d(), h("div", os, [
              us,
              ls,
              l("div", cs, " до " + k((f = (g = n.cardInfo) == null ? void 0 : g.details) == null ? void 0 : f.time) + " " + k((b = (_ = n.cardInfo) == null ? void 0 : _.details) == null ? void 0 : b.timeMeasure), 1)
            ])) : F("", !0),
            (p = (D = n.cardInfo) == null ? void 0 : D.details) != null && p.rate ? (d(), h("div", ds, [
              hs,
              fs,
              l("div", vs, k((w = (m = n.cardInfo) == null ? void 0 : m.details) == null ? void 0 : w.rate) + " % ", 1)
            ])) : F("", !0),
            (C = (E = n.cardInfo) == null ? void 0 : E.details) != null && C.amount ? (d(), h("div", ps, [
              ms,
              gs,
              l("div", _s, " до " + k((O = (Y = n.cardInfo) == null ? void 0 : Y.details) == null ? void 0 : O.amount) + " " + k((T = ($ = n.cardInfo) == null ? void 0 : $.details) == null ? void 0 : T.amountMeasure), 1)
            ])) : F("", !0)
          ])
        ]),
        l("div", bs, [
          ae(Ue, {
            onClick: a[2] || (a[2] = (j) => t("buttonClickEvent"))
          }, {
            default: se(() => [
              ue("Рассчитать кредит")
            ]),
            _: 1
          })
        ])
      ], 4);
    };
  }
}), ys = /* @__PURE__ */ B(ks, [["__scopeId", "data-v-331af776"]]);
function Le(r) {
  "@babel/helpers - typeof";
  return Le = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Le(r);
}
function le(r) {
  if (r === null || r === !0 || r === !1)
    return NaN;
  var e = Number(r);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function I(r, e) {
  if (e.length < r)
    throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function V(r) {
  I(1, arguments);
  var e = Object.prototype.toString.call(r);
  return r instanceof Date || Le(r) === "object" && e === "[object Date]" ? new Date(r.getTime()) : typeof r == "number" || e === "[object Number]" ? new Date(r) : ((typeof r == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Jt(r, e) {
  I(2, arguments);
  var t = V(r), n = le(e);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && t.setDate(t.getDate() + n), t);
}
function ea(r, e) {
  I(2, arguments);
  var t = V(r), n = le(e);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return t;
  var a = t.getDate(), i = new Date(t.getTime());
  i.setMonth(t.getMonth() + n + 1, 0);
  var s = i.getDate();
  return a >= s ? i : (t.setFullYear(i.getFullYear(), i.getMonth(), a), t);
}
function Cs(r, e) {
  I(2, arguments);
  var t = V(r).getTime(), n = le(e);
  return new Date(t + n);
}
var Ds = {};
function je() {
  return Ds;
}
function Gt(r, e) {
  var t, n, a, i, s, o, u, c;
  I(1, arguments);
  var v = je(), g = le((t = (n = (a = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && a !== void 0 ? a : v.weekStartsOn) !== null && n !== void 0 ? n : (u = v.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && t !== void 0 ? t : 0);
  if (!(g >= 0 && g <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = V(r), _ = f.getDay(), b = (_ < g ? 7 : 0) + _ - g;
  return f.setDate(f.getDate() - b), f.setHours(0, 0, 0, 0), f;
}
function $t(r) {
  var e = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
  return e.setUTCFullYear(r.getFullYear()), r.getTime() - e.getTime();
}
function it(r) {
  I(1, arguments);
  var e = V(r);
  return e.setHours(0, 0, 0, 0), e;
}
function $s(r, e) {
  I(2, arguments);
  var t = le(e), n = t * 7;
  return Jt(r, n);
}
function Et(r, e) {
  I(2, arguments);
  var t = le(e);
  return ea(r, t * 12);
}
function Ra(r, e, t) {
  I(2, arguments);
  var n = V(r == null ? void 0 : r.start).getTime(), a = V(r == null ? void 0 : r.end).getTime(), i = V(e == null ? void 0 : e.start).getTime(), s = V(e == null ? void 0 : e.end).getTime();
  if (!(n <= a && i <= s))
    throw new RangeError("Invalid interval");
  return t != null && t.inclusive ? n <= s && i <= a : n < s && i < a;
}
function fa(r, e) {
  I(2, arguments);
  var t = V(r), n = V(e), a = t.getTime() - n.getTime();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}
var Es = 6e4, Ms = 36e5, Ts = 1e3;
function Va(r, e) {
  I(2, arguments);
  var t = it(r), n = it(e);
  return t.getTime() === n.getTime();
}
function xs(r) {
  return I(1, arguments), r instanceof Date || Le(r) === "object" && Object.prototype.toString.call(r) === "[object Date]";
}
function We(r) {
  if (I(1, arguments), !xs(r) && typeof r != "number")
    return !1;
  var e = V(r);
  return !isNaN(Number(e));
}
var Fs = 6048e5;
function Ps(r, e, t) {
  I(2, arguments);
  var n = Gt(r, t), a = Gt(e, t), i = n.getTime() - $t(n), s = a.getTime() - $t(a);
  return Math.round((i - s) / Fs);
}
function As(r, e) {
  I(2, arguments);
  var t = V(r), n = V(e);
  return t.getFullYear() - n.getFullYear();
}
function Na(r) {
  I(1, arguments);
  var e = V(r);
  return e.setHours(23, 59, 59, 999), e;
}
function Ss(r, e) {
  I(2, arguments);
  var t = V(r), n = V(e), a = fa(t, n), i = Math.abs(As(t, n));
  t.setFullYear(1584), n.setFullYear(1584);
  var s = fa(t, n) === -a, o = a * (i - Number(s));
  return o === 0 ? 0 : o;
}
function Ha(r) {
  I(1, arguments);
  var e = V(r);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function va(r) {
  I(1, arguments);
  var e = V(r), t = /* @__PURE__ */ new Date(0);
  return t.setFullYear(e.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Ls(r) {
  I(1, arguments);
  var e = r || {}, t = V(e.start), n = V(e.end), a = n.getTime();
  if (!(t.getTime() <= a))
    throw new RangeError("Invalid interval");
  var i = [], s = t;
  for (s.setHours(0, 0, 0, 0), s.setMonth(0, 1); s.getTime() <= a; )
    i.push(V(s)), s.setFullYear(s.getFullYear() + 1);
  return i;
}
function Ya(r, e) {
  I(2, arguments);
  var t = le(e);
  return Cs(r, -t);
}
var Os = 864e5;
function Bs(r) {
  I(1, arguments);
  var e = V(r), t = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var n = e.getTime(), a = t - n;
  return Math.floor(a / Os) + 1;
}
function ot(r) {
  I(1, arguments);
  var e = 1, t = V(r), n = t.getUTCDay(), a = (n < e ? 7 : 0) + n - e;
  return t.setUTCDate(t.getUTCDate() - a), t.setUTCHours(0, 0, 0, 0), t;
}
function Ua(r) {
  I(1, arguments);
  var e = V(r), t = e.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var a = ot(n), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(t, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var s = ot(i);
  return e.getTime() >= a.getTime() ? t + 1 : e.getTime() >= s.getTime() ? t : t - 1;
}
function Is(r) {
  I(1, arguments);
  var e = Ua(r), t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(e, 0, 4), t.setUTCHours(0, 0, 0, 0);
  var n = ot(t);
  return n;
}
var Rs = 6048e5;
function Wa(r) {
  I(1, arguments);
  var e = V(r), t = ot(e).getTime() - Is(e).getTime();
  return Math.round(t / Rs) + 1;
}
function Oe(r, e) {
  var t, n, a, i, s, o, u, c;
  I(1, arguments);
  var v = je(), g = le((t = (n = (a = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && a !== void 0 ? a : v.weekStartsOn) !== null && n !== void 0 ? n : (u = v.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && t !== void 0 ? t : 0);
  if (!(g >= 0 && g <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = V(r), _ = f.getUTCDay(), b = (_ < g ? 7 : 0) + _ - g;
  return f.setUTCDate(f.getUTCDate() - b), f.setUTCHours(0, 0, 0, 0), f;
}
function ta(r, e) {
  var t, n, a, i, s, o, u, c;
  I(1, arguments);
  var v = V(r), g = v.getUTCFullYear(), f = je(), _ = le((t = (n = (a = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && a !== void 0 ? a : f.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = f.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && t !== void 0 ? t : 1);
  if (!(_ >= 1 && _ <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var b = /* @__PURE__ */ new Date(0);
  b.setUTCFullYear(g + 1, 0, _), b.setUTCHours(0, 0, 0, 0);
  var D = Oe(b, e), p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(g, 0, _), p.setUTCHours(0, 0, 0, 0);
  var m = Oe(p, e);
  return v.getTime() >= D.getTime() ? g + 1 : v.getTime() >= m.getTime() ? g : g - 1;
}
function Vs(r, e) {
  var t, n, a, i, s, o, u, c;
  I(1, arguments);
  var v = je(), g = le((t = (n = (a = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && a !== void 0 ? a : v.firstWeekContainsDate) !== null && n !== void 0 ? n : (u = v.locale) === null || u === void 0 || (c = u.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && t !== void 0 ? t : 1), f = ta(r, e), _ = /* @__PURE__ */ new Date(0);
  _.setUTCFullYear(f, 0, g), _.setUTCHours(0, 0, 0, 0);
  var b = Oe(_, e);
  return b;
}
var Ns = 6048e5;
function qa(r, e) {
  I(1, arguments);
  var t = V(r), n = Oe(t, e).getTime() - Vs(t, e).getTime();
  return Math.round(n / Ns) + 1;
}
function J(r, e) {
  for (var t = r < 0 ? "-" : "", n = Math.abs(r).toString(); n.length < e; )
    n = "0" + n;
  return t + n;
}
var Hs = {
  // Year
  y: function(e, t) {
    var n = e.getUTCFullYear(), a = n > 0 ? n : 1 - n;
    return J(t === "yy" ? a % 100 : a, t.length);
  },
  // Month
  M: function(e, t) {
    var n = e.getUTCMonth();
    return t === "M" ? String(n + 1) : J(n + 1, 2);
  },
  // Day of the month
  d: function(e, t) {
    return J(e.getUTCDate(), t.length);
  },
  // AM or PM
  a: function(e, t) {
    var n = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, t) {
    return J(e.getUTCHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H: function(e, t) {
    return J(e.getUTCHours(), t.length);
  },
  // Minute
  m: function(e, t) {
    return J(e.getUTCMinutes(), t.length);
  },
  // Second
  s: function(e, t) {
    return J(e.getUTCSeconds(), t.length);
  },
  // Fraction of second
  S: function(e, t) {
    var n = t.length, a = e.getUTCMilliseconds(), i = Math.floor(a * Math.pow(10, n - 3));
    return J(i, t.length);
  }
};
const Be = Hs;
var Je = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ys = {
  // Era
  G: function(e, t, n) {
    var a = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      var a = e.getUTCFullYear(), i = a > 0 ? a : 1 - a;
      return n.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Be.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, a) {
    var i = ta(e, a), s = i > 0 ? i : 1 - i;
    if (t === "YY") {
      var o = s % 100;
      return J(o, 2);
    }
    return t === "Yo" ? n.ordinalNumber(s, {
      unit: "year"
    }) : J(s, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    var n = Ua(e);
    return J(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    var n = e.getUTCFullYear();
    return J(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    var a = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(a);
      case "QQ":
        return J(a, 2);
      case "Qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    var a = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(a);
      case "qq":
        return J(a, 2);
      case "qo":
        return n.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    var a = e.getUTCMonth();
    switch (t) {
      case "M":
      case "MM":
        return Be.M(e, t);
      case "Mo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    var a = e.getUTCMonth();
    switch (t) {
      case "L":
        return String(a + 1);
      case "LL":
        return J(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, t, n, a) {
    var i = qa(e, a);
    return t === "wo" ? n.ordinalNumber(i, {
      unit: "week"
    }) : J(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    var a = Wa(e);
    return t === "Io" ? n.ordinalNumber(a, {
      unit: "week"
    }) : J(a, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Be.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    var a = Bs(e);
    return t === "Do" ? n.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : J(a, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    var a = e.getUTCDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, a) {
    var i = e.getUTCDay(), s = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(s);
      case "ee":
        return J(s, 2);
      case "eo":
        return n.ordinalNumber(s, {
          unit: "day"
        });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, a) {
    var i = e.getUTCDay(), s = (i - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(s);
      case "cc":
        return J(s, t.length);
      case "co":
        return n.ordinalNumber(s, {
          unit: "day"
        });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    var a = e.getUTCDay(), i = a === 0 ? 7 : a;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return J(i, t.length);
      case "io":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    var a = e.getUTCHours(), i = a / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    var a = e.getUTCHours(), i;
    switch (a === 12 ? i = Je.noon : a === 0 ? i = Je.midnight : i = a / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    var a = e.getUTCHours(), i;
    switch (a >= 17 ? i = Je.evening : a >= 12 ? i = Je.afternoon : a >= 4 ? i = Je.morning : i = Je.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      var a = e.getUTCHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return Be.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Be.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    var a = e.getUTCHours() % 12;
    return t === "Ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : J(a, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    var a = e.getUTCHours();
    return a === 0 && (a = 24), t === "ko" ? n.ordinalNumber(a, {
      unit: "hour"
    }) : J(a, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Be.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Be.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Be.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n, a) {
    var i = a._originalDate || e, s = i.getTimezoneOffset();
    if (s === 0)
      return "Z";
    switch (t) {
      case "X":
        return ma(s);
      case "XXXX":
      case "XX":
        return Ne(s);
      case "XXXXX":
      case "XXX":
      default:
        return Ne(s, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n, a) {
    var i = a._originalDate || e, s = i.getTimezoneOffset();
    switch (t) {
      case "x":
        return ma(s);
      case "xxxx":
      case "xx":
        return Ne(s);
      case "xxxxx":
      case "xxx":
      default:
        return Ne(s, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n, a) {
    var i = a._originalDate || e, s = i.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + pa(s, ":");
      case "OOOO":
      default:
        return "GMT" + Ne(s, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n, a) {
    var i = a._originalDate || e, s = i.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + pa(s, ":");
      case "zzzz":
      default:
        return "GMT" + Ne(s, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n, a) {
    var i = a._originalDate || e, s = Math.floor(i.getTime() / 1e3);
    return J(s, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n, a) {
    var i = a._originalDate || e, s = i.getTime();
    return J(s, t.length);
  }
};
function pa(r, e) {
  var t = r > 0 ? "-" : "+", n = Math.abs(r), a = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return t + String(a);
  var s = e || "";
  return t + String(a) + s + J(i, 2);
}
function ma(r, e) {
  if (r % 60 === 0) {
    var t = r > 0 ? "-" : "+";
    return t + J(Math.abs(r) / 60, 2);
  }
  return Ne(r, e);
}
function Ne(r, e) {
  var t = e || "", n = r > 0 ? "-" : "+", a = Math.abs(r), i = J(Math.floor(a / 60), 2), s = J(a % 60, 2);
  return n + i + t + s;
}
var ga = function(e, t) {
  switch (e) {
    case "P":
      return t.date({
        width: "short"
      });
    case "PP":
      return t.date({
        width: "medium"
      });
    case "PPP":
      return t.date({
        width: "long"
      });
    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}, Ga = function(e, t) {
  switch (e) {
    case "p":
      return t.time({
        width: "short"
      });
    case "pp":
      return t.time({
        width: "medium"
      });
    case "ppp":
      return t.time({
        width: "long"
      });
    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}, Us = function(e, t) {
  var n = e.match(/(P+)(p+)?/) || [], a = n[1], i = n[2];
  if (!i)
    return ga(e, t);
  var s;
  switch (a) {
    case "P":
      s = t.dateTime({
        width: "short"
      });
      break;
    case "PP":
      s = t.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      s = t.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      s = t.dateTime({
        width: "full"
      });
      break;
  }
  return s.replace("{{date}}", ga(a, t)).replace("{{time}}", Ga(i, t));
}, jt = {
  p: Ga,
  P: Us
}, Ws = ["D", "DD"], qs = ["YY", "YYYY"];
function ja(r) {
  return Ws.indexOf(r) !== -1;
}
function Za(r) {
  return qs.indexOf(r) !== -1;
}
function Mt(r, e, t) {
  if (r === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (r === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Gs = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, js = function(e, t, n) {
  var a, i = Gs[e];
  return typeof i == "string" ? a = i : t === 1 ? a = i.one : a = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
const Zs = js;
function tt(r) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.width ? String(e.width) : r.defaultWidth, n = r.formats[t] || r.formats[r.defaultWidth];
    return n;
  };
}
var zs = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Qs = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Xs = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ks = {
  date: tt({
    formats: zs,
    defaultWidth: "full"
  }),
  time: tt({
    formats: Qs,
    defaultWidth: "full"
  }),
  dateTime: tt({
    formats: Xs,
    defaultWidth: "full"
  })
};
const Js = Ks;
var ei = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ti = function(e, t, n, a) {
  return ei[e];
};
const ai = ti;
function Te(r) {
  return function(e, t) {
    var n = t != null && t.context ? String(t.context) : "standalone", a;
    if (n === "formatting" && r.formattingValues) {
      var i = r.defaultFormattingWidth || r.defaultWidth, s = t != null && t.width ? String(t.width) : i;
      a = r.formattingValues[s] || r.formattingValues[i];
    } else {
      var o = r.defaultWidth, u = t != null && t.width ? String(t.width) : r.defaultWidth;
      a = r.values[u] || r.values[o];
    }
    var c = r.argumentCallback ? r.argumentCallback(e) : e;
    return a[c];
  };
}
var ni = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, ri = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, si = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, ii = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, oi = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ui = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, li = function(e, t) {
  var n = Number(e), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, ci = {
  ordinalNumber: li,
  era: Te({
    values: ni,
    defaultWidth: "wide"
  }),
  quarter: Te({
    values: ri,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Te({
    values: si,
    defaultWidth: "wide"
  }),
  day: Te({
    values: ii,
    defaultWidth: "wide"
  }),
  dayPeriod: Te({
    values: oi,
    defaultWidth: "wide",
    formattingValues: ui,
    defaultFormattingWidth: "wide"
  })
};
const di = ci;
function xe(r) {
  return function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.width, a = n && r.matchPatterns[n] || r.matchPatterns[r.defaultMatchWidth], i = e.match(a);
    if (!i)
      return null;
    var s = i[0], o = n && r.parsePatterns[n] || r.parsePatterns[r.defaultParseWidth], u = Array.isArray(o) ? fi(o, function(g) {
      return g.test(s);
    }) : hi(o, function(g) {
      return g.test(s);
    }), c;
    c = r.valueCallback ? r.valueCallback(u) : u, c = t.valueCallback ? t.valueCallback(c) : c;
    var v = e.slice(s.length);
    return {
      value: c,
      rest: v
    };
  };
}
function hi(r, e) {
  for (var t in r)
    if (r.hasOwnProperty(t) && e(r[t]))
      return t;
}
function fi(r, e) {
  for (var t = 0; t < r.length; t++)
    if (e(r[t]))
      return t;
}
function za(r) {
  return function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.match(r.matchPattern);
    if (!n)
      return null;
    var a = n[0], i = e.match(r.parsePattern);
    if (!i)
      return null;
    var s = r.valueCallback ? r.valueCallback(i[0]) : i[0];
    s = t.valueCallback ? t.valueCallback(s) : s;
    var o = e.slice(a.length);
    return {
      value: s,
      rest: o
    };
  };
}
var vi = /^(\d+)(th|st|nd|rd)?/i, pi = /\d+/i, mi = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, gi = {
  any: [/^b/i, /^(a|c)/i]
}, _i = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, bi = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wi = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, ki = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, yi = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Ci = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Di = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, $i = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Ei = {
  ordinalNumber: za({
    matchPattern: vi,
    parsePattern: pi,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: xe({
    matchPatterns: mi,
    defaultMatchWidth: "wide",
    parsePatterns: gi,
    defaultParseWidth: "any"
  }),
  quarter: xe({
    matchPatterns: _i,
    defaultMatchWidth: "wide",
    parsePatterns: bi,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: xe({
    matchPatterns: wi,
    defaultMatchWidth: "wide",
    parsePatterns: ki,
    defaultParseWidth: "any"
  }),
  day: xe({
    matchPatterns: yi,
    defaultMatchWidth: "wide",
    parsePatterns: Ci,
    defaultParseWidth: "any"
  }),
  dayPeriod: xe({
    matchPatterns: Di,
    defaultMatchWidth: "any",
    parsePatterns: $i,
    defaultParseWidth: "any"
  })
};
const Mi = Ei;
var Ti = {
  code: "en-US",
  formatDistance: Zs,
  formatLong: Js,
  formatRelative: ai,
  localize: di,
  match: Mi,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const aa = Ti;
var xi = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Fi = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Pi = /^'([^]*?)'?$/, Ai = /''/g, Si = /[a-zA-Z]/;
function gt(r, e, t) {
  var n, a, i, s, o, u, c, v, g, f, _, b, D, p, m, w, E, C;
  I(2, arguments);
  var Y = String(e), O = je(), $ = (n = (a = t == null ? void 0 : t.locale) !== null && a !== void 0 ? a : O.locale) !== null && n !== void 0 ? n : aa, T = le((i = (s = (o = (u = t == null ? void 0 : t.firstWeekContainsDate) !== null && u !== void 0 ? u : t == null || (c = t.locale) === null || c === void 0 || (v = c.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && o !== void 0 ? o : O.firstWeekContainsDate) !== null && s !== void 0 ? s : (g = O.locale) === null || g === void 0 || (f = g.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(T >= 1 && T <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var j = le((_ = (b = (D = (p = t == null ? void 0 : t.weekStartsOn) !== null && p !== void 0 ? p : t == null || (m = t.locale) === null || m === void 0 || (w = m.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && D !== void 0 ? D : O.weekStartsOn) !== null && b !== void 0 ? b : (E = O.locale) === null || E === void 0 || (C = E.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && _ !== void 0 ? _ : 0);
  if (!(j >= 0 && j <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!$.localize)
    throw new RangeError("locale must contain localize property");
  if (!$.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var fe = V(r);
  if (!We(fe))
    throw new RangeError("Invalid time value");
  var we = $t(fe), ke = Ya(fe, we), L = {
    firstWeekContainsDate: T,
    weekStartsOn: j,
    locale: $,
    _originalDate: fe
  }, ve = Y.match(Fi).map(function(W) {
    var Q = W[0];
    if (Q === "p" || Q === "P") {
      var me = jt[Q];
      return me(W, $.formatLong);
    }
    return W;
  }).join("").match(xi).map(function(W) {
    if (W === "''")
      return "'";
    var Q = W[0];
    if (Q === "'")
      return Li(W);
    var me = Ys[Q];
    if (me)
      return !(t != null && t.useAdditionalWeekYearTokens) && Za(W) && Mt(W, e, String(r)), !(t != null && t.useAdditionalDayOfYearTokens) && ja(W) && Mt(W, e, String(r)), me(ke, W, $.localize, L);
    if (Q.match(Si))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Q + "`");
    return W;
  }).join("");
  return ve;
}
function Li(r) {
  var e = r.match(Pi);
  return e ? e[1].replace(Ai, "'") : r;
}
function Oi(r, e) {
  if (r == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && (r[t] = e[t]);
  return r;
}
function Bi(r) {
  I(1, arguments);
  var e = V(r), t = e.getDate();
  return t;
}
function Ii(r) {
  I(1, arguments);
  var e = V(r), t = e.getFullYear(), n = e.getMonth(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(t, n + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function Ri(r) {
  I(1, arguments);
  var e = V(r), t = e.getMonth();
  return t;
}
function Vi(r) {
  I(1, arguments);
  var e = V(r), t = e.getMonth();
  return e.setFullYear(e.getFullYear(), t + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function Ni(r, e) {
  return I(1, arguments), Ps(Vi(r), Ha(r), e) + 1;
}
function Qa(r) {
  return I(1, arguments), V(r).getFullYear();
}
function _a(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++)
    n[t] = r[t];
  return n;
}
function Hi(r, e) {
  if (r) {
    if (typeof r == "string")
      return _a(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return _a(r, e);
  }
}
function ba(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = Hi(r)) || e && r && typeof r.length == "number") {
      t && (r = t);
      var n = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, s = !1, o;
  return {
    s: function() {
      t = t.call(r);
    },
    n: function() {
      var c = t.next();
      return i = c.done, c;
    },
    e: function(c) {
      s = !0, o = c;
    },
    f: function() {
      try {
        !i && t.return != null && t.return();
      } finally {
        if (s)
          throw o;
      }
    }
  };
}
function x(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function Zt(r, e) {
  return Zt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Zt(r, e);
}
function Z(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(r, "prototype", {
    writable: !1
  }), e && Zt(r, e);
}
function Tt(r) {
  return Tt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Tt(r);
}
function Yi() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ui(r, e) {
  if (e && (Le(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return x(r);
}
function z(r) {
  var e = Yi();
  return function() {
    var n = Tt(r), a;
    if (e) {
      var i = Tt(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return Ui(this, a);
  };
}
function q(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Wi(r, e) {
  if (Le(r) !== "object" || r === null)
    return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e || "default");
    if (Le(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function Xa(r) {
  var e = Wi(r, "string");
  return Le(e) === "symbol" ? e : String(e);
}
function wa(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, Xa(n.key), n);
  }
}
function G(r, e, t) {
  return e && wa(r.prototype, e), t && wa(r, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function M(r, e, t) {
  return e = Xa(e), e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
var qi = 10, Ka = /* @__PURE__ */ function() {
  function r() {
    q(this, r), M(this, "priority", void 0), M(this, "subPriority", 0);
  }
  return G(r, [{
    key: "validate",
    value: function(t, n) {
      return !0;
    }
  }]), r;
}(), Gi = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t(n, a, i, s, o) {
    var u;
    return q(this, t), u = e.call(this), u.value = n, u.validateValue = a, u.setValue = i, u.priority = s, o && (u.subPriority = o), u;
  }
  return G(t, [{
    key: "validate",
    value: function(a, i) {
      return this.validateValue(a, this.value, i);
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return this.setValue(a, i, this.value, s);
    }
  }]), t;
}(Ka), ji = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", qi), M(x(n), "subPriority", -1), n;
  }
  return G(t, [{
    key: "set",
    value: function(a, i) {
      if (i.timestampIsSet)
        return a;
      var s = /* @__PURE__ */ new Date(0);
      return s.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), s.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), s;
    }
  }]), t;
}(Ka), K = /* @__PURE__ */ function() {
  function r() {
    q(this, r), M(this, "incompatibleTokens", void 0), M(this, "priority", void 0), M(this, "subPriority", void 0);
  }
  return G(r, [{
    key: "run",
    value: function(t, n, a, i) {
      var s = this.parse(t, n, a, i);
      return s ? {
        setter: new Gi(s.value, this.validate, this.set, this.priority, this.subPriority),
        rest: s.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(t, n, a) {
      return !0;
    }
  }]), r;
}(), Zi = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 140), M(x(n), "incompatibleTokens", ["R", "u", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return s.era(a, {
            width: "abbreviated"
          }) || s.era(a, {
            width: "narrow"
          });
        case "GGGGG":
          return s.era(a, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return s.era(a, {
            width: "wide"
          }) || s.era(a, {
            width: "abbreviated"
          }) || s.era(a, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return i.era = s, a.setUTCFullYear(s, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K), de = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Fe = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function he(r, e) {
  return r && {
    value: e(r.value),
    rest: r.rest
  };
}
function ie(r, e) {
  var t = e.match(r);
  return t ? {
    value: parseInt(t[0], 10),
    rest: e.slice(t[0].length)
  } : null;
}
function Pe(r, e) {
  var t = e.match(r);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  var n = t[1] === "+" ? 1 : -1, a = t[2] ? parseInt(t[2], 10) : 0, i = t[3] ? parseInt(t[3], 10) : 0, s = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: n * (a * Ms + i * Es + s * Ts),
    rest: e.slice(t[0].length)
  };
}
function Ja(r) {
  return ie(de.anyDigitsSigned, r);
}
function ce(r, e) {
  switch (r) {
    case 1:
      return ie(de.singleDigit, e);
    case 2:
      return ie(de.twoDigits, e);
    case 3:
      return ie(de.threeDigits, e);
    case 4:
      return ie(de.fourDigits, e);
    default:
      return ie(new RegExp("^\\d{1," + r + "}"), e);
  }
}
function xt(r, e) {
  switch (r) {
    case 1:
      return ie(de.singleDigitSigned, e);
    case 2:
      return ie(de.twoDigitsSigned, e);
    case 3:
      return ie(de.threeDigitsSigned, e);
    case 4:
      return ie(de.fourDigitsSigned, e);
    default:
      return ie(new RegExp("^-?\\d{1," + r + "}"), e);
  }
}
function na(r) {
  switch (r) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function en(r, e) {
  var t = e > 0, n = t ? e : 1 - e, a;
  if (n <= 50)
    a = r || 100;
  else {
    var i = n + 50, s = Math.floor(i / 100) * 100, o = r >= i % 100;
    a = r + s - (o ? 100 : 0);
  }
  return t ? a : 1 - a;
}
function tn(r) {
  return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
var zi = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 130), M(x(n), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      var o = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return he(ce(4, a), o);
        case "yo":
          return he(s.ordinalNumber(a, {
            unit: "year"
          }), o);
        default:
          return he(ce(i.length, a), o);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      var o = a.getUTCFullYear();
      if (s.isTwoDigitYear) {
        var u = en(s.year, o);
        return a.setUTCFullYear(u, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
      }
      var c = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
      return a.setUTCFullYear(c, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K), Qi = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 130), M(x(n), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      var o = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return he(ce(4, a), o);
        case "Yo":
          return he(s.ordinalNumber(a, {
            unit: "year"
          }), o);
        default:
          return he(ce(i.length, a), o);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(a, i, s, o) {
      var u = ta(a, o);
      if (s.isTwoDigitYear) {
        var c = en(s.year, u);
        return a.setUTCFullYear(c, 0, o.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), Oe(a, o);
      }
      var v = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
      return a.setUTCFullYear(v, 0, o.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), Oe(a, o);
    }
  }]), t;
}(K), Xi = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 130), M(x(n), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i) {
      return xt(i === "R" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      var o = /* @__PURE__ */ new Date(0);
      return o.setUTCFullYear(s, 0, 4), o.setUTCHours(0, 0, 0, 0), ot(o);
    }
  }]), t;
}(K), Ki = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 130), M(x(n), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i) {
      return xt(i === "u" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCFullYear(s, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K), Ji = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 120), M(x(n), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "Q":
        case "QQ":
          return ce(i.length, a);
        case "Qo":
          return s.ordinalNumber(a, {
            unit: "quarter"
          });
        case "QQQ":
          return s.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return s.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return s.quarter(a, {
            width: "wide",
            context: "formatting"
          }) || s.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCMonth((s - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K), eo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 120), M(x(n), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "q":
        case "qq":
          return ce(i.length, a);
        case "qo":
          return s.ordinalNumber(a, {
            unit: "quarter"
          });
        case "qqq":
          return s.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return s.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return s.quarter(a, {
            width: "wide",
            context: "standalone"
          }) || s.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCMonth((s - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K), to = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), M(x(n), "priority", 110), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      var o = function(c) {
        return c - 1;
      };
      switch (i) {
        case "M":
          return he(ie(de.month, a), o);
        case "MM":
          return he(ce(2, a), o);
        case "Mo":
          return he(s.ordinalNumber(a, {
            unit: "month"
          }), o);
        case "MMM":
          return s.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return s.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return s.month(a, {
            width: "wide",
            context: "formatting"
          }) || s.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCMonth(s, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K), ao = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 110), M(x(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      var o = function(c) {
        return c - 1;
      };
      switch (i) {
        case "L":
          return he(ie(de.month, a), o);
        case "LL":
          return he(ce(2, a), o);
        case "Lo":
          return he(s.ordinalNumber(a, {
            unit: "month"
          }), o);
        case "LLL":
          return s.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return s.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return s.month(a, {
            width: "wide",
            context: "standalone"
          }) || s.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCMonth(s, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K);
function no(r, e, t) {
  I(2, arguments);
  var n = V(r), a = le(e), i = qa(n, t) - a;
  return n.setUTCDate(n.getUTCDate() - i * 7), n;
}
var ro = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 100), M(x(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "w":
          return ie(de.week, a);
        case "wo":
          return s.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return ce(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, s, o) {
      return Oe(no(a, s, o), o);
    }
  }]), t;
}(K);
function so(r, e) {
  I(2, arguments);
  var t = V(r), n = le(e), a = Wa(t) - n;
  return t.setUTCDate(t.getUTCDate() - a * 7), t;
}
var io = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 100), M(x(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "I":
          return ie(de.week, a);
        case "Io":
          return s.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return ce(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return ot(so(a, s));
    }
  }]), t;
}(K), oo = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], uo = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], lo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 90), M(x(n), "subPriority", 1), M(x(n), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "d":
          return ie(de.date, a);
        case "do":
          return s.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return ce(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var s = a.getUTCFullYear(), o = tn(s), u = a.getUTCMonth();
      return o ? i >= 1 && i <= uo[u] : i >= 1 && i <= oo[u];
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCDate(s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K), co = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 90), M(x(n), "subpriority", 1), M(x(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "D":
        case "DD":
          return ie(de.dayOfYear, a);
        case "Do":
          return s.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return ce(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      var s = a.getUTCFullYear(), o = tn(s);
      return o ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCMonth(0, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K);
function ra(r, e, t) {
  var n, a, i, s, o, u, c, v;
  I(2, arguments);
  var g = je(), f = le((n = (a = (i = (s = t == null ? void 0 : t.weekStartsOn) !== null && s !== void 0 ? s : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && i !== void 0 ? i : g.weekStartsOn) !== null && a !== void 0 ? a : (c = g.locale) === null || c === void 0 || (v = c.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var _ = V(r), b = le(e), D = _.getUTCDay(), p = b % 7, m = (p + 7) % 7, w = (m < f ? 7 : 0) + b - D;
  return _.setUTCDate(_.getUTCDate() + w), _;
}
var ho = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 90), M(x(n), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return s.day(a, {
            width: "wide",
            context: "formatting"
          }) || s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, s, o) {
      return a = ra(a, s, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K), fo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 90), M(x(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s, o) {
      var u = function(v) {
        var g = Math.floor((v - 1) / 7) * 7;
        return (v + o.weekStartsOn + 6) % 7 + g;
      };
      switch (i) {
        case "e":
        case "ee":
          return he(ce(i.length, a), u);
        case "eo":
          return he(s.ordinalNumber(a, {
            unit: "day"
          }), u);
        case "eee":
          return s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return s.day(a, {
            width: "wide",
            context: "formatting"
          }) || s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, s, o) {
      return a = ra(a, s, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K), vo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 90), M(x(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s, o) {
      var u = function(v) {
        var g = Math.floor((v - 1) / 7) * 7;
        return (v + o.weekStartsOn + 6) % 7 + g;
      };
      switch (i) {
        case "c":
        case "cc":
          return he(ce(i.length, a), u);
        case "co":
          return he(s.ordinalNumber(a, {
            unit: "day"
          }), u);
        case "ccc":
          return s.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(a, {
            width: "short",
            context: "standalone"
          }) || s.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return s.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return s.day(a, {
            width: "short",
            context: "standalone"
          }) || s.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return s.day(a, {
            width: "wide",
            context: "standalone"
          }) || s.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(a, {
            width: "short",
            context: "standalone"
          }) || s.day(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(a, i, s, o) {
      return a = ra(a, s, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K);
function po(r, e) {
  I(2, arguments);
  var t = le(e);
  t % 7 === 0 && (t = t - 7);
  var n = 1, a = V(r), i = a.getUTCDay(), s = t % 7, o = (s + 7) % 7, u = (o < n ? 7 : 0) + t - i;
  return a.setUTCDate(a.getUTCDate() + u), a;
}
var mo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 90), M(x(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      var o = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (i) {
        case "i":
        case "ii":
          return ce(i.length, a);
        case "io":
          return s.ordinalNumber(a, {
            unit: "day"
          });
        case "iii":
          return he(s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiiii":
          return he(s.day(a, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiiiii":
          return he(s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiii":
        default:
          return he(s.day(a, {
            width: "wide",
            context: "formatting"
          }) || s.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(a, {
            width: "short",
            context: "formatting"
          }) || s.day(a, {
            width: "narrow",
            context: "formatting"
          }), o);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a = po(a, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), t;
}(K), go = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 80), M(x(n), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return s.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCHours(na(s), 0, 0, 0), a;
    }
  }]), t;
}(K), _o = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 80), M(x(n), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return s.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCHours(na(s), 0, 0, 0), a;
    }
  }]), t;
}(K), bo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 80), M(x(n), "incompatibleTokens", ["a", "b", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return s.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCHours(na(s), 0, 0, 0), a;
    }
  }]), t;
}(K), wo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 70), M(x(n), "incompatibleTokens", ["H", "K", "k", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "h":
          return ie(de.hour12h, a);
        case "ho":
          return s.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return ce(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      var o = a.getUTCHours() >= 12;
      return o && s < 12 ? a.setUTCHours(s + 12, 0, 0, 0) : !o && s === 12 ? a.setUTCHours(0, 0, 0, 0) : a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), t;
}(K), ko = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 70), M(x(n), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "H":
          return ie(de.hour23h, a);
        case "Ho":
          return s.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return ce(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), t;
}(K), yo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 70), M(x(n), "incompatibleTokens", ["h", "H", "k", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "K":
          return ie(de.hour11h, a);
        case "Ko":
          return s.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return ce(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      var o = a.getUTCHours() >= 12;
      return o && s < 12 ? a.setUTCHours(s + 12, 0, 0, 0) : a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), t;
}(K), Co = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 70), M(x(n), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "k":
          return ie(de.hour24h, a);
        case "ko":
          return s.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return ce(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      var o = s <= 24 ? s % 24 : s;
      return a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), t;
}(K), Do = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 60), M(x(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "m":
          return ie(de.minute, a);
        case "mo":
          return s.ordinalNumber(a, {
            unit: "minute"
          });
        default:
          return ce(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCMinutes(s, 0, 0), a;
    }
  }]), t;
}(K), $o = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 50), M(x(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i, s) {
      switch (i) {
        case "s":
          return ie(de.second, a);
        case "so":
          return s.ordinalNumber(a, {
            unit: "second"
          });
        default:
          return ce(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCSeconds(s, 0), a;
    }
  }]), t;
}(K), Eo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 30), M(x(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i) {
      var s = function(u) {
        return Math.floor(u * Math.pow(10, -i.length + 3));
      };
      return he(ce(i.length, a), s);
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return a.setUTCMilliseconds(s), a;
    }
  }]), t;
}(K), Mo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 10), M(x(n), "incompatibleTokens", ["t", "T", "x"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "X":
          return Pe(Fe.basicOptionalMinutes, a);
        case "XX":
          return Pe(Fe.basic, a);
        case "XXXX":
          return Pe(Fe.basicOptionalSeconds, a);
        case "XXXXX":
          return Pe(Fe.extendedOptionalSeconds, a);
        case "XXX":
        default:
          return Pe(Fe.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return i.timestampIsSet ? a : new Date(a.getTime() - s);
    }
  }]), t;
}(K), To = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 10), M(x(n), "incompatibleTokens", ["t", "T", "X"]), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a, i) {
      switch (i) {
        case "x":
          return Pe(Fe.basicOptionalMinutes, a);
        case "xx":
          return Pe(Fe.basic, a);
        case "xxxx":
          return Pe(Fe.basicOptionalSeconds, a);
        case "xxxxx":
          return Pe(Fe.extendedOptionalSeconds, a);
        case "xxx":
        default:
          return Pe(Fe.extended, a);
      }
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return i.timestampIsSet ? a : new Date(a.getTime() - s);
    }
  }]), t;
}(K), xo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 40), M(x(n), "incompatibleTokens", "*"), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a) {
      return Ja(a);
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return [new Date(s * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), t;
}(K), Fo = /* @__PURE__ */ function(r) {
  Z(t, r);
  var e = z(t);
  function t() {
    var n;
    q(this, t);
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    return n = e.call.apply(e, [this].concat(i)), M(x(n), "priority", 20), M(x(n), "incompatibleTokens", "*"), n;
  }
  return G(t, [{
    key: "parse",
    value: function(a) {
      return Ja(a);
    }
  }, {
    key: "set",
    value: function(a, i, s) {
      return [new Date(s), {
        timestampIsSet: !0
      }];
    }
  }]), t;
}(K), Po = {
  G: new Zi(),
  y: new zi(),
  Y: new Qi(),
  R: new Xi(),
  u: new Ki(),
  Q: new Ji(),
  q: new eo(),
  M: new to(),
  L: new ao(),
  w: new ro(),
  I: new io(),
  d: new lo(),
  D: new co(),
  E: new ho(),
  e: new fo(),
  c: new vo(),
  i: new mo(),
  a: new go(),
  b: new _o(),
  B: new bo(),
  h: new wo(),
  H: new ko(),
  K: new yo(),
  k: new Co(),
  m: new Do(),
  s: new $o(),
  S: new Eo(),
  X: new Mo(),
  x: new To(),
  t: new xo(),
  T: new Fo()
}, Ao = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, So = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Lo = /^'([^]*?)'?$/, Oo = /''/g, Bo = /\S/, Io = /[a-zA-Z]/;
function zt(r, e, t, n) {
  var a, i, s, o, u, c, v, g, f, _, b, D, p, m, w, E, C, Y;
  I(3, arguments);
  var O = String(r), $ = String(e), T = je(), j = (a = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : T.locale) !== null && a !== void 0 ? a : aa;
  if (!j.match)
    throw new RangeError("locale must contain match property");
  var fe = le((s = (o = (u = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (v = n.locale) === null || v === void 0 || (g = v.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && u !== void 0 ? u : T.firstWeekContainsDate) !== null && o !== void 0 ? o : (f = T.locale) === null || f === void 0 || (_ = f.options) === null || _ === void 0 ? void 0 : _.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
  if (!(fe >= 1 && fe <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var we = le((b = (D = (p = (m = n == null ? void 0 : n.weekStartsOn) !== null && m !== void 0 ? m : n == null || (w = n.locale) === null || w === void 0 || (E = w.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && p !== void 0 ? p : T.weekStartsOn) !== null && D !== void 0 ? D : (C = T.locale) === null || C === void 0 || (Y = C.options) === null || Y === void 0 ? void 0 : Y.weekStartsOn) !== null && b !== void 0 ? b : 0);
  if (!(we >= 0 && we <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if ($ === "")
    return O === "" ? V(t) : /* @__PURE__ */ new Date(NaN);
  var ke = {
    firstWeekContainsDate: fe,
    weekStartsOn: we,
    locale: j
  }, L = [new ji()], ve = $.match(So).map(function(oe) {
    var ee = oe[0];
    if (ee in jt) {
      var _e = jt[ee];
      return _e(oe, j.formatLong);
    }
    return oe;
  }).join("").match(Ao), W = [], Q = ba(ve), me;
  try {
    var Ze = function() {
      var ee = me.value;
      !(n != null && n.useAdditionalWeekYearTokens) && Za(ee) && Mt(ee, $, r), !(n != null && n.useAdditionalDayOfYearTokens) && ja(ee) && Mt(ee, $, r);
      var _e = ee[0], Ke = Po[_e];
      if (Ke) {
        var ca = Ke.incompatibleTokens;
        if (Array.isArray(ca)) {
          var da = W.find(function(ha) {
            return ca.includes(ha.token) || ha.token === _e;
          });
          if (da)
            throw new RangeError("The format string mustn't contain `".concat(da.fullToken, "` and `").concat(ee, "` at the same time"));
        } else if (Ke.incompatibleTokens === "*" && W.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(ee, "` and any other token at the same time"));
        W.push({
          token: _e,
          fullToken: ee
        });
        var Ht = Ke.run(O, ee, j.match, ke);
        if (!Ht)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        L.push(Ht.setter), O = Ht.rest;
      } else {
        if (_e.match(Io))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + _e + "`");
        if (ee === "''" ? ee = "'" : _e === "'" && (ee = Ro(ee)), O.indexOf(ee) === 0)
          O = O.slice(ee.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (Q.s(); !(me = Q.n()).done; ) {
      var Re = Ze();
      if (Le(Re) === "object")
        return Re.v;
    }
  } catch (oe) {
    Q.e(oe);
  } finally {
    Q.f();
  }
  if (O.length > 0 && Bo.test(O))
    return /* @__PURE__ */ new Date(NaN);
  var ye = L.map(function(oe) {
    return oe.priority;
  }).sort(function(oe, ee) {
    return ee - oe;
  }).filter(function(oe, ee, _e) {
    return _e.indexOf(oe) === ee;
  }).map(function(oe) {
    return L.filter(function(ee) {
      return ee.priority === oe;
    }).sort(function(ee, _e) {
      return _e.subPriority - ee.subPriority;
    });
  }).map(function(oe) {
    return oe[0];
  }), ze = V(t);
  if (isNaN(ze.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var Ee = Ya(ze, $t(ze)), vt = {}, Ve = ba(ye), wt;
  try {
    for (Ve.s(); !(wt = Ve.n()).done; ) {
      var Qe = wt.value;
      if (!Qe.validate(Ee, ke))
        return /* @__PURE__ */ new Date(NaN);
      var Xe = Qe.set(Ee, vt, ke);
      Array.isArray(Xe) ? (Ee = Xe[0], Oi(vt, Xe[1])) : Ee = Xe;
    }
  } catch (oe) {
    Ve.e(oe);
  } finally {
    Ve.f();
  }
  return Ee;
}
function Ro(r) {
  return r.match(Lo)[1].replace(Oo, "'");
}
function Vo(r, e) {
  I(2, arguments);
  var t = V(r), n = V(e);
  return t.getFullYear() === n.getFullYear() && t.getMonth() === n.getMonth();
}
function No(r) {
  return I(1, arguments), Va(r, Date.now());
}
function Ho(r, e) {
  I(2, arguments);
  var t = V(r), n = le(e), a = t.getFullYear(), i = t.getDate(), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(a, n, 15), s.setHours(0, 0, 0, 0);
  var o = Ii(s);
  return t.setMonth(n, Math.min(i, o)), t;
}
function Yo(r, e) {
  I(2, arguments);
  var t = le(e);
  return ea(r, -t);
}
function Qt(r, e) {
  I(2, arguments);
  var t = le(e);
  return Et(r, -t);
}
function ka(r, e, t) {
  I(2, arguments);
  var n = Oe(r, t), a = Oe(e, t);
  return n.getTime() === a.getTime();
}
function pt(r, e) {
  if (r.one !== void 0 && e === 1)
    return r.one;
  var t = e % 10, n = e % 100;
  return t === 1 && n !== 11 ? r.singularNominative.replace("{{count}}", String(e)) : t >= 2 && t <= 4 && (n < 10 || n > 20) ? r.singularGenitive.replace("{{count}}", String(e)) : r.pluralGenitive.replace("{{count}}", String(e));
}
function ge(r) {
  return function(e, t) {
    return t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? r.future ? pt(r.future, e) : "через " + pt(r.regular, e) : r.past ? pt(r.past, e) : pt(r.regular, e) + " назад" : pt(r.regular, e);
  };
}
var Uo = {
  lessThanXSeconds: ge({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: ge({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: function(e, t) {
    return t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты";
  },
  lessThanXMinutes: ge({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: ge({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: ge({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: ge({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: ge({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: ge({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: ge({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: ge({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: ge({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: ge({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: ge({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: ge({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: ge({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, Wo = function(e, t, n) {
  return Uo[e](t, n);
};
const qo = Wo;
var Go = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, jo = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Zo = {
  any: "{{date}}, {{time}}"
}, zo = {
  date: tt({
    formats: Go,
    defaultWidth: "full"
  }),
  time: tt({
    formats: jo,
    defaultWidth: "full"
  }),
  dateTime: tt({
    formats: Zo,
    defaultWidth: "any"
  })
};
const Qo = zo;
var sa = ["воскресенье", "понедельник", "вторник", "среду", "четверг", "пятницу", "субботу"];
function Xo(r) {
  var e = sa[r];
  switch (r) {
    case 0:
      return "'в прошлое " + e + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + e + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + e + " в' p";
  }
}
function ya(r) {
  var e = sa[r];
  return r === 2 ? "'во " + e + " в' p" : "'в " + e + " в' p";
}
function Ko(r) {
  var e = sa[r];
  switch (r) {
    case 0:
      return "'в следующее " + e + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + e + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + e + " в' p";
  }
}
var Jo = {
  lastWeek: function(e, t, n) {
    var a = e.getUTCDay();
    return ka(e, t, n) ? ya(a) : Xo(a);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: function(e, t, n) {
    var a = e.getUTCDay();
    return ka(e, t, n) ? ya(a) : Ko(a);
  },
  other: "P"
}, eu = function(e, t, n, a) {
  var i = Jo[e];
  return typeof i == "function" ? i(t, n, a) : i;
};
const tu = eu;
var au = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, nu = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, ru = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв.", "фев.", "март", "апр.", "май", "июнь", "июль", "авг.", "сент.", "окт.", "нояб.", "дек."],
  wide: ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"]
}, su = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: ["янв.", "фев.", "мар.", "апр.", "мая", "июн.", "июл.", "авг.", "сент.", "окт.", "нояб.", "дек."],
  wide: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"]
}, iu = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"]
}, ou = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, uu = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, lu = function(e, t) {
  var n = Number(e), a = t == null ? void 0 : t.unit, i;
  return a === "date" ? i = "-е" : a === "week" || a === "minute" || a === "second" ? i = "-я" : i = "-й", n + i;
}, cu = {
  ordinalNumber: lu,
  era: Te({
    values: au,
    defaultWidth: "wide"
  }),
  quarter: Te({
    values: nu,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Te({
    values: ru,
    defaultWidth: "wide",
    formattingValues: su,
    defaultFormattingWidth: "wide"
  }),
  day: Te({
    values: iu,
    defaultWidth: "wide"
  }),
  dayPeriod: Te({
    values: ou,
    defaultWidth: "any",
    formattingValues: uu,
    defaultFormattingWidth: "wide"
  })
};
const du = cu;
var hu = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, fu = /\d+/i, vu = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, pu = {
  any: [/^д/i, /^н/i]
}, mu = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, gu = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, _u = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, bu = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
}, wu = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, ku = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, yu = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, Cu = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, Du = {
  ordinalNumber: za({
    matchPattern: hu,
    parsePattern: fu,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: xe({
    matchPatterns: vu,
    defaultMatchWidth: "wide",
    parsePatterns: pu,
    defaultParseWidth: "any"
  }),
  quarter: xe({
    matchPatterns: mu,
    defaultMatchWidth: "wide",
    parsePatterns: gu,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: xe({
    matchPatterns: _u,
    defaultMatchWidth: "wide",
    parsePatterns: bu,
    defaultParseWidth: "any"
  }),
  day: xe({
    matchPatterns: wu,
    defaultMatchWidth: "wide",
    parsePatterns: ku,
    defaultParseWidth: "any"
  }),
  dayPeriod: xe({
    matchPatterns: yu,
    defaultMatchWidth: "wide",
    parsePatterns: Cu,
    defaultParseWidth: "any"
  })
};
const $u = Du;
var Eu = {
  code: "ru",
  formatDistance: qo,
  formatLong: Qo,
  formatRelative: tu,
  localize: du,
  match: $u,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const Ft = Eu, Mu = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"], Tu = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь"
], Pt = (r, e) => !We(r) || !We(e) ? !1 : Ra(
  {
    start: Qt(r, 9999),
    end: it(r)
  },
  {
    start: it(e),
    end: Na(e)
  }
), At = (r, e) => !We(r) || !We(e) ? !1 : Ra(
  {
    start: Jt(it(r), 1),
    end: Et(r, 9999)
  },
  {
    start: it(e),
    end: Na(e)
  }
), St = (r, e) => !We(r) || !We(e) ? !1 : Va(r, e), xu = (r, e) => Ls({
  start: r,
  end: e
}).map((t) => Qa(t)), Fu = (r, e, t) => {
  const n = $s(r, t);
  return [...new Array(7)].map((a) => n).map((a, i) => Jt(a, i)).map((a) => Vo(e, a) ? a : null);
}, yt = (r) => {
  const e = Ni(r), t = Ha(r), n = Gt(t, { locale: Ft });
  return [...new Array(e + 1)].map((a, i) => {
    const s = Fu(n, t, i);
    return s.filter((o) => !!o).length ? s : null;
  }).filter((a) => !!a);
}, Pu = (r, e) => Ho(new Date(e, 0, 1), r), Au = (r) => new Date(r, 0, 1), Ca = (r) => zt(r, "dd.MM.yyyy", /* @__PURE__ */ new Date()), Da = (r) => gt(r, "dd.MM.yyyy"), Su = { class: "aeb-datepicker-month__week" }, Lu = { class: "aeb-datepicker-month__week" }, Ou = ["onClick"], Bu = {
  key: 1,
  class: "aeb-datepicker-month__day aeb-datepicker-month__day--stub"
}, Iu = {
  name: "aeb-datepicker-month"
}, Ru = /* @__PURE__ */ A({
  ...Iu,
  props: {
    month: { type: Array },
    date: { type: Date, required: !0 },
    minDate: { type: Date, required: !0 },
    maxDate: { type: Date, required: !0 },
    excludedDates: { type: Array, default: () => [] }
  },
  emits: ["setDate"],
  setup(r, { emit: e }) {
    const t = r, n = e, a = (c) => Pt(t.minDate, c) || At(t.maxDate, c) || i(c), i = (c) => !!t.excludedDates.filter((v) => St(v, c)).length, s = (c) => St(t.date, c), o = (c) => {
      a(c) || n("setDate", c);
    }, u = Mu;
    return (c, v) => (d(), h(R, null, [
      l("div", Su, [
        (d(!0), h(R, null, X(H(u), (g) => (d(), h("div", {
          key: g,
          class: "aeb-datepicker-month__day aeb-datepicker-month__day--weekd"
        }, k(g), 1))), 128))
      ]),
      (d(!0), h(R, null, X(r.month, (g) => (d(), h("div", Lu, [
        (d(!0), h(R, null, X(g, (f) => (d(), h(R, null, [
          f ? (d(), h("div", {
            key: 0,
            class: P([{
              "aeb-datepicker-month__day--today": H(No)(f),
              "aeb-datepicker-month__day--picked": s(f),
              "aeb-datepicker-month__day--disabled": a(f)
            }, "aeb-datepicker-month__day"]),
            onClick: (_) => o(f)
          }, k(f ? `${H(Bi)(f)}` : ""), 11, Ou)) : (d(), h("div", Bu))
        ], 64))), 256))
      ]))), 256))
    ], 64));
  }
}), an = /* @__PURE__ */ B(Ru, [["__scopeId", "data-v-a60fde64"]]), Vu = ["onClick"], Nu = ["onClick"], Hu = {
  name: "aeb-datepicker-tiles"
}, Yu = /* @__PURE__ */ A({
  ...Hu,
  props: {
    date: Date,
    isMonths: { type: Boolean, default: !1 },
    isYears: { type: Boolean, default: !1 },
    year: Number,
    month: Number,
    minYear: { type: Date, required: !0 },
    maxYear: { type: Date, required: !0 },
    minDate: { type: Date, required: !0 },
    maxDate: { type: Date, required: !0 },
    woDays: { type: Boolean, default: !1 }
  },
  emits: ["setYear", "setMonth"],
  setup(r, { emit: e }) {
    const t = r, n = e, a = y(null), i = xu(t.minYear, t.maxYear).reverse(), s = (f) => {
      n("setMonth", f);
    }, o = (f) => {
      n("setYear", f);
    }, u = (f) => t.woDays ? Pt(t.minDate, new Date(t.year, f)) || At(t.maxDate, new Date(t.year, f)) : !1, c = (f) => t.woDays ? Pt(t.minDate, new Date(f, 11, 31)) || At(t.maxDate, new Date(f, 0)) : !1, v = () => {
      if (t.isMonths)
        return;
      const f = Math.abs(
        Ss(va(t.date), va(t.maxYear))
      ), _ = 54, b = Math.floor(f / 3), D = 6;
      a.value && (a.value.scrollTop = _ * b + b - D);
    };
    $e(
      () => t.isYears,
      () => setTimeout(v)
    );
    const g = Tu;
    return (f, _) => (d(), h("div", {
      ref_key: "containerRef",
      ref: a,
      class: "aeb-datepicker-tiles"
    }, [
      l("div", {
        class: P([{ "aeb-datepicker-tiles__scroll--months": r.isMonths }, "aeb-datepicker-tiles__scroll"])
      }, [
        (d(!0), h(R, null, X(H(i), (b) => (d(), h("div", {
          key: b,
          class: P([{
            "aeb-datepicker-tiles__tile--active": b === r.year,
            "aeb-datepicker-tiles__tile--disabled": c(b)
          }, "aeb-datepicker-tiles__tile"]),
          style: pe({ display: r.isMonths ? "none" : "flex" }),
          onClick: (D) => o(b)
        }, k(b), 15, Vu))), 128)),
        (d(!0), h(R, null, X(H(g), (b, D) => (d(), h("div", {
          key: D,
          class: P([{
            "aeb-datepicker-tiles__tile--active": D === r.month,
            "aeb-datepicker-tiles__tile--disabled": u(D)
          }, "aeb-datepicker-tiles__tile"]),
          style: pe({ display: r.isMonths ? "flex" : "none" }),
          onClick: (p) => s(D)
        }, k(b), 15, Nu))), 128))
      ], 2)
    ], 512));
  }
}), Xt = /* @__PURE__ */ B(Yu, [["__scopeId", "data-v-20776d48"]]), It = (r) => (ne("data-v-e6901679"), r = r(), re(), r), Uu = { class: "aeb-datepicker-core__controls" }, Wu = /* @__PURE__ */ It(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 9 16",
  width: "9",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M8 1L1.35355 7.64645C1.15829 7.84171 1.15829 8.15829 1.35355 8.35355L8 15",
    stroke: "#27303E",
    "stroke-linecap": "round",
    "stroke-width": "2"
  })
], -1)), qu = [
  Wu
], Gu = /* @__PURE__ */ It(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "6",
  viewBox: "0 0 10 6",
  width: "10",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M9 1L5.07071 4.92929C5.03166 4.96834 4.96834 4.96834 4.92929 4.92929L1 1",
    stroke: "#27303E",
    "stroke-linecap": "round",
    "stroke-width": "2"
  })
], -1)), ju = [
  Gu
], Zu = /* @__PURE__ */ It(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "6",
  viewBox: "0 0 10 6",
  width: "10",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M9 1L5.07071 4.92929C5.03166 4.96834 4.96834 4.96834 4.92929 4.92929L1 1",
    stroke: "#27303E",
    "stroke-linecap": "round",
    "stroke-width": "2"
  })
], -1)), zu = [
  Zu
], Qu = /* @__PURE__ */ It(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 9 16",
  width: "9",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M8 1L1.35355 7.64645C1.15829 7.84171 1.15829 8.15829 1.35355 8.35355L8 15",
    stroke: "#27303E",
    "stroke-linecap": "round",
    "stroke-width": "2"
  })
], -1)), Xu = [
  Qu
], Ku = { class: "aeb-datepicker-core__calendar" }, Ju = {
  name: "aeb-datepicker-core"
}, el = /* @__PURE__ */ A({
  ...Ju,
  props: {
    date: { type: Date, required: !0 },
    minDate: { type: Date, required: !0 },
    maxDate: { type: Date, required: !0 },
    excludedDates: { type: Array, required: !0 },
    minYear: { type: Date, required: !0 },
    maxYear: { type: Date, required: !0 },
    withBackground: { type: Boolean, default: !1 },
    align: { type: String, default: "right" },
    withoutDays: { type: Boolean, default: !1 }
  },
  emits: [
    "onDateChange",
    "woDaysMonth",
    "woDaysYear",
    "woDaysMonthSubInc"
  ],
  setup(r, { expose: e, emit: t }) {
    const n = r, a = t, i = y(yt(n.date)), s = y(), o = Me(() => gt(b(), "LLLL", { locale: Ft })), u = Me(() => gt(b(), "yyyy", { locale: Ft })), c = y(Ri(n.date)), v = y(Qa(n.date)), g = Me(() => Au(v.value)), f = y(!!n.withoutDays), _ = y(!1), b = () => i.value[0].filter((T) => T)[0], D = () => {
      const T = b();
      c.value === 11 ? (c.value = 0, v.value = v.value + 1) : c.value = c.value + 1, i.value = yt(ea(T, 1)), n.withoutDays && a("woDaysMonthSubInc", !0);
    }, p = () => {
      const T = b();
      c.value === 0 ? (c.value = 11, v.value -= 1) : c.value -= 1, i.value = yt(Yo(T, 1)), n.withoutDays && a("woDaysMonthSubInc", !1);
    }, m = () => {
      const T = Pu(c.value, v.value);
      i.value = yt(T);
    }, w = (T, j) => {
      if (n.withoutDays) {
        a("woDaysMonth", [T, j]), c.value = T, m();
        return;
      }
      c.value = T, f.value = !1, m();
    }, E = (T, j) => {
      if (n.withoutDays) {
        a("woDaysYear", [T, j]), v.value = T, m();
        return;
      }
      v.value = T, _.value = !1, m();
    };
    e({ setAll: (T, j) => {
      c.value = T, v.value = j, m(), n.withoutDays || (f.value = !1, _.value = !1);
    } });
    const Y = () => {
      n.withoutDays && f.value || (_.value && (_.value = !1), f.value = !f.value);
    }, O = () => {
      n.withoutDays && _.value || (f.value && (f.value = !1), _.value = !_.value);
    }, $ = (T) => {
      a("onDateChange", T);
    };
    return (T, j) => (d(), h("div", {
      ref_key: "coreRef",
      ref: s,
      class: P([{
        "aeb-datepicker-core--with-background": r.withBackground,
        "aeb-datepicker-core--left": r.align === "left",
        "aeb-datepicker-core--right": r.align === "right"
      }, "aeb-datepicker-core"])
    }, [
      l("div", Uu, [
        l("div", {
          class: "aeb-datepicker-core__arrow",
          onClick: p
        }, qu),
        l("div", {
          class: "aeb-datepicker-core__btn aeb-datepicker-core__btn--month",
          onClick: Y
        }, [
          ue(k(o.value) + " ", 1),
          l("div", {
            class: P([{
              "aeb-datepicker-core__arrow-icon--active": f.value
            }, "aeb-datepicker-core__arrow-icon"])
          }, ju, 2)
        ]),
        l("div", {
          class: "aeb-datepicker-core__btn",
          onClick: O
        }, [
          ue(k(u.value) + " ", 1),
          l("div", {
            class: P([{
              "aeb-datepicker-core__arrow-icon--active": _.value
            }, "aeb-datepicker-core__arrow-icon"])
          }, zu, 2)
        ]),
        l("div", {
          class: "aeb-datepicker-core__arrow aeb-datepicker-core__arrow--right",
          onClick: D
        }, Xu)
      ]),
      l("div", Ku, [
        l("div", {
          style: pe({
            display: !_.value && !f.value ? "block" : "none"
          })
        }, [
          ae(an, {
            date: r.date,
            excludedDates: r.excludedDates,
            maxDate: r.maxDate,
            minDate: r.minDate,
            month: i.value,
            onSetDate: $
          }, null, 8, ["date", "excludedDates", "maxDate", "minDate", "month"])
        ], 4),
        l("div", {
          style: pe({ display: _.value ? "block" : "none" })
        }, [
          ae(Xt, {
            date: g.value,
            isYears: _.value,
            maxDate: r.maxDate,
            maxYear: r.maxYear,
            minDate: r.minDate,
            minYear: r.minYear,
            woDays: r.withoutDays,
            year: v.value,
            onSetYear: E
          }, null, 8, ["date", "isYears", "maxDate", "maxYear", "minDate", "minYear", "woDays", "year"])
        ], 4),
        l("div", {
          style: pe({ display: f.value ? "block" : "none" })
        }, [
          ae(Xt, {
            isMonths: f.value,
            maxDate: r.maxDate,
            maxYear: r.maxYear,
            minDate: r.minDate,
            minYear: r.minYear,
            month: c.value,
            woDays: r.withoutDays,
            year: v.value,
            onSetMonth: w
          }, null, 8, ["isMonths", "maxDate", "maxYear", "minDate", "minYear", "month", "woDays", "year"])
        ], 4)
      ])
    ], 2));
  }
}), nn = /* @__PURE__ */ B(el, [["__scopeId", "data-v-e6901679"]]);
function ut(r, e) {
  if (r == null)
    return {};
  var t = {}, n = Object.keys(r), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(e.indexOf(a) >= 0) && (t[a] = r[a]);
  return t;
}
function N(r) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new N.InputMask(r, e);
}
class te {
  /** Inserted symbols */
  /** Can skip chars */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  constructor(e) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      skip: !1,
      tailShift: 0
    }, e);
  }
  /**
    Aggregate changes
    @returns {ChangeDetails} `this`
  */
  aggregate(e) {
    return this.rawInserted += e.rawInserted, this.skip = this.skip || e.skip, this.inserted += e.inserted, this.tailShift += e.tailShift, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
}
N.ChangeDetails = te;
function at(r) {
  return typeof r == "string" || r instanceof String;
}
const S = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function tl(r) {
  switch (r) {
    case S.LEFT:
      return S.FORCE_LEFT;
    case S.RIGHT:
      return S.FORCE_RIGHT;
    default:
      return r;
  }
}
function Ut(r) {
  return r.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
}
function _t(r) {
  return Array.isArray(r) ? r : [r, new te()];
}
function Lt(r, e) {
  if (e === r)
    return !0;
  var t = Array.isArray(e), n = Array.isArray(r), a;
  if (t && n) {
    if (e.length != r.length)
      return !1;
    for (a = 0; a < e.length; a++)
      if (!Lt(e[a], r[a]))
        return !1;
    return !0;
  }
  if (t != n)
    return !1;
  if (e && r && typeof e == "object" && typeof r == "object") {
    var i = e instanceof Date, s = r instanceof Date;
    if (i && s)
      return e.getTime() == r.getTime();
    if (i != s)
      return !1;
    var o = e instanceof RegExp, u = r instanceof RegExp;
    if (o && u)
      return e.toString() == r.toString();
    if (o != u)
      return !1;
    var c = Object.keys(e);
    for (a = 0; a < c.length; a++)
      if (!Object.prototype.hasOwnProperty.call(r, c[a]))
        return !1;
    for (a = 0; a < c.length; a++)
      if (!Lt(r[c[a]], e[c[a]]))
        return !1;
    return !0;
  } else if (e && r && typeof e == "function" && typeof r == "function")
    return e.toString() === r.toString();
  return !1;
}
class al {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(e, t, n, a) {
    for (this.value = e, this.cursorPos = t, this.oldValue = n, this.oldSelection = a; this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
  }
  /**
    Start changing position
    @readonly
  */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /**
    Inserted symbols count
    @readonly
  */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /**
    Inserted symbols
    @readonly
  */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /**
    Removed symbols count
    @readonly
  */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /**
    Removed symbols
    @readonly
  */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /**
    Unchanged head symbols
    @readonly
  */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /**
    Unchanged tail symbols
    @readonly
  */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /**
    Remove direction
    @readonly
  */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? S.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? S.RIGHT : S.LEFT;
  }
}
class Se {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 ? arguments[2] : void 0;
    this.value = e, this.from = t, this.stop = n;
  }
  toString() {
    return this.value;
  }
  extend(e) {
    this.value += String(e);
  }
  appendTo(e) {
    return e.append(this.toString(), {
      tail: !0
    }).aggregate(e._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  unshift(e) {
    if (!this.value.length || e != null && this.from >= e)
      return "";
    const t = this.value[0];
    return this.value = this.value.slice(1), t;
  }
  shift() {
    if (!this.value.length)
      return "";
    const e = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), e;
  }
}
class be {
  // $Shape<MaskedOptions>; TODO after fix https://github.com/facebook/flow/issues/4773
  /** @type {Mask} */
  /** */
  // $FlowFixMe no ideas
  /** Transforms value before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing in the end of editing */
  /** Format typed value to string */
  /** Parse strgin to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(e) {
    this._value = "", this._update(Object.assign({}, be.DEFAULTS, e)), this.isInitialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(e) {
    Object.keys(e).length && this.withValueRefresh(this._update.bind(this, e));
  }
  /**
    Sets new options
    @protected
  */
  _update(e) {
    Object.assign(this, e);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value
    };
  }
  set state(e) {
    this._value = e._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  /** */
  get value() {
    return this._value;
  }
  set value(e) {
    this.resolve(e);
  }
  /** Resolve new value */
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      input: !0
    };
    return this.reset(), this.append(e, t, ""), this.doCommit(), this.value;
  }
  /** */
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(e) {
    this.reset(), this.append(e, {}, ""), this.doCommit();
  }
  /** */
  get typedValue() {
    return this.doParse(this.value);
  }
  set typedValue(e) {
    this.value = this.doFormat(e);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.value.length, {
      raw: !0
    });
  }
  set rawInputValue(e) {
    this.reset(), this.append(e, {
      raw: !0
    }, ""), this.doCommit();
  }
  get displayValue() {
    return this.value;
  }
  /** */
  get isComplete() {
    return !0;
  }
  /** */
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(e, t) {
    return e;
  }
  totalInputPositions() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return Math.min(this.value.length, t - e);
  }
  /** Extracts value in range considering flags */
  extractInput() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return this.value.slice(e, t);
  }
  /** Extracts tail in range */
  extractTail() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return new Se(this.extractInput(e, t), e);
  }
  /** Appends tail */
  // $FlowFixMe no ideas
  appendTail(e) {
    return at(e) && (e = new Se(String(e))), e.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(e) {
    return e ? (this._value += e, new te({
      inserted: e,
      rawInserted: e
    })) : new te();
  }
  /** Appends char */
  _appendChar(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
    const a = this.state;
    let i;
    if ([e, i] = _t(this.doPrepare(e, t)), i = i.aggregate(this._appendCharRaw(e, t)), i.inserted) {
      let s, o = this.doValidate(t) !== !1;
      if (o && n != null) {
        const u = this.state;
        this.overwrite === !0 && (s = n.state, n.unshift(this.value.length - i.tailShift));
        let c = this.appendTail(n);
        o = c.rawInserted === n.toString(), !(o && c.inserted) && this.overwrite === "shift" && (this.state = u, s = n.state, n.shift(), c = this.appendTail(n), o = c.rawInserted === n.toString()), o && c.inserted && (this.state = u);
      }
      o || (i = new te(), this.state = a, n && s && (n.state = s));
    }
    return i;
  }
  /** Appends optional placeholder at end */
  _appendPlaceholder() {
    return new te();
  }
  /** Appends optional eager placeholder at end */
  _appendEager() {
    return new te();
  }
  /** Appends symbols considering flags */
  // $FlowFixMe no ideas
  append(e, t, n) {
    if (!at(e))
      throw new Error("value should be string");
    const a = new te(), i = at(n) ? new Se(String(n)) : n;
    t != null && t.tail && (t._beforeTailState = this.state);
    for (let s = 0; s < e.length; ++s) {
      const o = this._appendChar(e[s], t, i);
      if (!o.rawInserted && !this.doSkipInvalid(e[s], t, i))
        break;
      a.aggregate(o);
    }
    return (this.eager === !0 || this.eager === "append") && t !== null && t !== void 0 && t.input && e && a.aggregate(this._appendEager()), i != null && (a.tailShift += this.appendTail(i).tailShift), a;
  }
  /** */
  remove() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return this._value = this.value.slice(0, e) + this.value.slice(t), new te();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(e) {
    if (this._refreshing || !this.isInitialized)
      return e();
    this._refreshing = !0;
    const t = this.rawInputValue, n = this.value, a = e();
    return this.rawInputValue = t, this.value && this.value !== n && n.indexOf(this.value) === 0 && this.append(n.slice(this.value.length), {}, ""), delete this._refreshing, a;
  }
  /** */
  runIsolated(e) {
    if (this._isolated || !this.isInitialized)
      return e(this);
    this._isolated = !0;
    const t = this.state, n = e(this);
    return this.state = t, delete this._isolated, n;
  }
  /** */
  doSkipInvalid(e) {
    return this.skipInvalid;
  }
  /**
    Prepares string before mask processing
    @protected
  */
  doPrepare(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return this.prepare ? this.prepare(e, this, t) : e;
  }
  /**
    Validates if value is acceptable
    @protected
  */
  doValidate(e) {
    return (!this.validate || this.validate(this.value, this, e)) && (!this.parent || this.parent.doValidate(e));
  }
  /**
    Does additional processing in the end of editing
    @protected
  */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  /** */
  doFormat(e) {
    return this.format ? this.format(e, this) : e;
  }
  /** */
  doParse(e) {
    return this.parse ? this.parse(e, this) : e;
  }
  /** */
  splice(e, t, n, a) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      input: !0
    };
    const s = e + t, o = this.extractTail(s), u = this.eager === !0 || this.eager === "remove";
    let c;
    u && (a = tl(a), c = this.extractInput(0, s, {
      raw: !0
    }));
    let v = e;
    const g = new te();
    if (a !== S.NONE && (v = this.nearestInputPos(e, t > 1 && e !== 0 && !u ? S.NONE : a), g.tailShift = v - e), g.aggregate(this.remove(v)), u && a !== S.NONE && c === this.rawInputValue)
      if (a === S.FORCE_LEFT) {
        let f;
        for (; c === this.rawInputValue && (f = this.value.length); )
          g.aggregate(new te({
            tailShift: -1
          })).aggregate(this.remove(f - 1));
      } else
        a === S.FORCE_RIGHT && o.unshift();
    return g.aggregate(this.append(n, i, o));
  }
  maskEquals(e) {
    return this.mask === e;
  }
  typedValueEquals(e) {
    const t = this.typedValue;
    return e === t || be.EMPTY_VALUES.includes(e) && be.EMPTY_VALUES.includes(t) || this.doFormat(e) === this.doFormat(this.typedValue);
  }
}
be.DEFAULTS = {
  format: String,
  parse: (r) => r,
  skipInvalid: !0
};
be.EMPTY_VALUES = [void 0, null, ""];
N.Masked = be;
function rn(r) {
  if (r == null)
    throw new Error("mask property should be defined");
  return r instanceof RegExp ? N.MaskedRegExp : at(r) ? N.MaskedPattern : r instanceof Date || r === Date ? N.MaskedDate : r instanceof Number || typeof r == "number" || r === Number ? N.MaskedNumber : Array.isArray(r) || r === Array ? N.MaskedDynamic : N.Masked && r.prototype instanceof N.Masked ? r : r instanceof N.Masked ? r.constructor : r instanceof Function ? N.MaskedFunction : (console.warn("Mask not found for mask", r), N.Masked);
}
function qe(r) {
  if (N.Masked && r instanceof N.Masked)
    return r;
  r = Object.assign({}, r);
  const e = r.mask;
  if (N.Masked && e instanceof N.Masked)
    return e;
  const t = rn(e);
  if (!t)
    throw new Error("Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.");
  return new t(r);
}
N.createMask = qe;
const nl = ["parent", "isOptional", "placeholderChar", "displayChar", "lazy", "eager"], rl = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class sn {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    const {
      parent: t,
      isOptional: n,
      placeholderChar: a,
      displayChar: i,
      lazy: s,
      eager: o
    } = e, u = ut(e, nl);
    this.masked = qe(u), Object.assign(this, {
      parent: t,
      isOptional: n,
      placeholderChar: a,
      displayChar: i,
      lazy: s,
      eager: o
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return e === 0 && t >= 1 ? (this.isFilled = !1, this.masked.remove(e, t)) : new te();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.isFilled)
      return new te();
    const n = this.masked.state, a = this.masked._appendChar(e, t);
    return a.inserted && this.doValidate(t) === !1 && (a.inserted = a.rawInserted = "", this.masked.state = n), !a.inserted && !this.isOptional && !this.lazy && !t.input && (a.inserted = this.placeholderChar), a.skip = !a.inserted && !this.isOptional, this.isFilled = !!a.inserted, a;
  }
  append() {
    return this.masked.append(...arguments);
  }
  _appendPlaceholder() {
    const e = new te();
    return this.isFilled || this.isOptional || (this.isFilled = !0, e.inserted = this.placeholderChar), e;
  }
  _appendEager() {
    return new te();
  }
  extractTail() {
    return this.masked.extractTail(...arguments);
  }
  appendTail() {
    return this.masked.appendTail(...arguments);
  }
  extractInput() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, n = arguments.length > 2 ? arguments[2] : void 0;
    return this.masked.extractInput(e, t, n);
  }
  nearestInputPos(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : S.NONE;
    const n = 0, a = this.value.length, i = Math.min(Math.max(e, n), a);
    switch (t) {
      case S.LEFT:
      case S.FORCE_LEFT:
        return this.isComplete ? i : n;
      case S.RIGHT:
      case S.FORCE_RIGHT:
        return this.isComplete ? i : a;
      case S.NONE:
      default:
        return i;
    }
  }
  totalInputPositions() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    return this.value.slice(e, t).length;
  }
  doValidate() {
    return this.masked.doValidate(...arguments) && (!this.parent || this.parent.doValidate(...arguments));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(e) {
    this.masked.state = e.masked, this.isFilled = e.isFilled;
  }
}
class on {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    Object.assign(this, e), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
    return this._value = this._value.slice(0, e) + this._value.slice(t), this._value || (this._isRawInput = !1), new te();
  }
  nearestInputPos(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : S.NONE;
    const n = 0, a = this._value.length;
    switch (t) {
      case S.LEFT:
      case S.FORCE_LEFT:
        return n;
      case S.NONE:
      case S.RIGHT:
      case S.FORCE_RIGHT:
      default:
        return a;
    }
  }
  totalInputPositions() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
    return this._isRawInput ? t - e : 0;
  }
  extractInput() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
    return (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).raw && this._isRawInput && this._value.slice(e, t) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = new te();
    if (this.isFilled)
      return n;
    const a = this.eager === !0 || this.eager === "append", s = this.char === e && (this.isUnmasking || t.input || t.raw) && (!t.raw || !a) && !t.tail;
    return s && (n.rawInserted = this.char), this._value = n.inserted = this.char, this._isRawInput = s && (t.raw || t.input), n;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const e = new te();
    return this.isFilled || (this._value = e.inserted = this.char), e;
  }
  extractTail() {
    return arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, new Se("");
  }
  // $FlowFixMe no ideas
  appendTail(e) {
    return at(e) && (e = new Se(String(e))), e.appendTo(this);
  }
  append(e, t, n) {
    const a = this._appendChar(e[0], t);
    return n != null && (a.tailShift += this.appendTail(n).tailShift), a;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _isRawInput: this._isRawInput
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
}
const sl = ["chunks"];
class He {
  /** */
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    this.chunks = e, this.from = t;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  // $FlowFixMe no ideas
  extend(e) {
    if (!String(e))
      return;
    at(e) && (e = new Se(String(e)));
    const t = this.chunks[this.chunks.length - 1], n = t && // if stops are same or tail has no stop
    (t.stop === e.stop || e.stop == null) && // if tail chunk goes just after last chunk
    e.from === t.from + t.toString().length;
    if (e instanceof Se)
      n ? t.extend(e.toString()) : this.chunks.push(e);
    else if (e instanceof He) {
      if (e.stop == null) {
        let a;
        for (; e.chunks.length && e.chunks[0].stop == null; )
          a = e.chunks.shift(), a.from += e.from, this.extend(a);
      }
      e.toString() && (e.stop = e.blockIndex, this.chunks.push(e));
    }
  }
  appendTo(e) {
    if (!(e instanceof N.MaskedPattern))
      return new Se(this.toString()).appendTo(e);
    const t = new te();
    for (let n = 0; n < this.chunks.length && !t.skip; ++n) {
      const a = this.chunks[n], i = e._mapPosToBlock(e.value.length), s = a.stop;
      let o;
      if (s != null && // if block not found or stop is behind lastBlock
      (!i || i.index <= s)) {
        if (a instanceof He || // for continuous block also check if stop is exist
        e._stops.indexOf(s) >= 0) {
          const u = e._appendPlaceholder(s);
          t.aggregate(u);
        }
        o = a instanceof He && e._blocks[s];
      }
      if (o) {
        const u = o.appendTail(a);
        u.skip = !1, t.aggregate(u), e._value += u.inserted;
        const c = a.toString().slice(u.rawInserted.length);
        c && t.aggregate(e.append(c, {
          tail: !0
        }));
      } else
        t.aggregate(e.append(a.toString(), {
          tail: !0
        }));
    }
    return t;
  }
  get state() {
    return {
      chunks: this.chunks.map((e) => e.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(e) {
    const {
      chunks: t
    } = e, n = ut(e, sl);
    Object.assign(this, n), this.chunks = t.map((a) => {
      const i = "chunks" in a ? new He() : new Se();
      return i.state = a, i;
    });
  }
  unshift(e) {
    if (!this.chunks.length || e != null && this.from >= e)
      return "";
    const t = e != null ? e - this.from : e;
    let n = 0;
    for (; n < this.chunks.length; ) {
      const a = this.chunks[n], i = a.unshift(t);
      if (a.toString()) {
        if (!i)
          break;
        ++n;
      } else
        this.chunks.splice(n, 1);
      if (i)
        return i;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length)
      return "";
    let e = this.chunks.length - 1;
    for (; 0 <= e; ) {
      const t = this.chunks[e], n = t.shift();
      if (t.toString()) {
        if (!n)
          break;
        --e;
      } else
        this.chunks.splice(e, 1);
      if (n)
        return n;
    }
    return "";
  }
}
class il {
  constructor(e, t) {
    this.masked = e, this._log = [];
    const {
      offset: n,
      index: a
    } = e._mapPosToBlock(t) || (t < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    ));
    this.offset = n, this.index = a, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const e = this._log.pop();
    return this.state = e, e;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.value.length));
  }
  _pushLeft(e) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((t = this.block) === null || t === void 0 ? void 0 : t.value.length) || 0) {
      var t;
      if (e())
        return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(e) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
      if (e())
        return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, S.FORCE_LEFT), this.offset !== 0))
        return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, S.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, S.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, S.FORCE_RIGHT), this.offset !== this.block.value.length))
        return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, S.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, S.NONE), !0;
    });
  }
}
class ol extends be {
  /**
    @override
    @param {Object} opts
  */
  _update(e) {
    e.mask && (e.validate = (t) => t.search(e.mask) >= 0), super._update(e);
  }
}
N.MaskedRegExp = ol;
const ul = ["_blocks"];
class Ce extends be {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.definitions = Object.assign({}, rl, e.definitions), super(Object.assign({}, Ce.DEFAULTS, e));
  }
  /**
    @override
    @param {Object} opts
  */
  _update() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.definitions = Object.assign({}, this.definitions, e.definitions), super._update(e), this._rebuildMask();
  }
  /** */
  _rebuildMask() {
    const e = this.definitions;
    this._blocks = [], this._stops = [], this._maskedBlocks = {};
    let t = this.mask;
    if (!t || !e)
      return;
    let n = !1, a = !1;
    for (let o = 0; o < t.length; ++o) {
      var i, s;
      if (this.blocks) {
        const f = t.slice(o), _ = Object.keys(this.blocks).filter((D) => f.indexOf(D) === 0);
        _.sort((D, p) => p.length - D.length);
        const b = _[0];
        if (b) {
          const D = qe(Object.assign({
            parent: this,
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite
          }, this.blocks[b]));
          D && (this._blocks.push(D), this._maskedBlocks[b] || (this._maskedBlocks[b] = []), this._maskedBlocks[b].push(this._blocks.length - 1)), o += b.length - 1;
          continue;
        }
      }
      let u = t[o], c = u in e;
      if (u === Ce.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (u === "{" || u === "}") {
        n = !n;
        continue;
      }
      if (u === "[" || u === "]") {
        a = !a;
        continue;
      }
      if (u === Ce.ESCAPE_CHAR) {
        if (++o, u = t[o], !u)
          break;
        c = !1;
      }
      const v = (i = e[u]) !== null && i !== void 0 && i.mask && !(((s = e[u]) === null || s === void 0 ? void 0 : s.mask.prototype) instanceof N.Masked) ? e[u] : {
        mask: e[u]
      }, g = c ? new sn(Object.assign({
        parent: this,
        isOptional: a,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar
      }, v)) : new on({
        char: u,
        eager: this.eager,
        isUnmasking: n
      });
      this._blocks.push(g);
    }
  }
  /**
    @override
  */
  get state() {
    return Object.assign({}, super.state, {
      _blocks: this._blocks.map((e) => e.state)
    });
  }
  set state(e) {
    const {
      _blocks: t
    } = e, n = ut(e, ul);
    this._blocks.forEach((a, i) => a.state = t[i]), super.state = n;
  }
  /**
    @override
  */
  reset() {
    super.reset(), this._blocks.forEach((e) => e.reset());
  }
  /**
    @override
  */
  get isComplete() {
    return this._blocks.every((e) => e.isComplete);
  }
  /**
    @override
  */
  get isFilled() {
    return this._blocks.every((e) => e.isFilled);
  }
  get isFixed() {
    return this._blocks.every((e) => e.isFixed);
  }
  get isOptional() {
    return this._blocks.every((e) => e.isOptional);
  }
  /**
    @override
  */
  doCommit() {
    this._blocks.forEach((e) => e.doCommit()), super.doCommit();
  }
  /**
    @override
  */
  get unmaskedValue() {
    return this._blocks.reduce((e, t) => e += t.unmaskedValue, "");
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  /**
    @override
  */
  get value() {
    return this._blocks.reduce((e, t) => e += t.value, "");
  }
  set value(e) {
    super.value = e;
  }
  get displayValue() {
    return this._blocks.reduce((e, t) => e += t.displayValue, "");
  }
  /**
    @override
  */
  appendTail(e) {
    return super.appendTail(e).aggregate(this._appendPlaceholder());
  }
  /**
    @override
  */
  _appendEager() {
    var e;
    const t = new te();
    let n = (e = this._mapPosToBlock(this.value.length)) === null || e === void 0 ? void 0 : e.index;
    if (n == null)
      return t;
    this._blocks[n].isFilled && ++n;
    for (let a = n; a < this._blocks.length; ++a) {
      const i = this._blocks[a]._appendEager();
      if (!i.inserted)
        break;
      t.aggregate(i);
    }
    return t;
  }
  /**
    @override
  */
  _appendCharRaw(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this._mapPosToBlock(this.value.length), a = new te();
    if (!n)
      return a;
    for (let o = n.index; ; ++o) {
      var i, s;
      const u = this._blocks[o];
      if (!u)
        break;
      const c = u._appendChar(e, Object.assign({}, t, {
        _beforeTailState: (i = t._beforeTailState) === null || i === void 0 || (s = i._blocks) === null || s === void 0 ? void 0 : s[o]
      })), v = c.skip;
      if (a.aggregate(c), v || c.rawInserted)
        break;
    }
    return a;
  }
  /**
    @override
  */
  extractTail() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    const n = new He();
    return e === t || this._forEachBlocksInRange(e, t, (a, i, s, o) => {
      const u = a.extractTail(s, o);
      u.stop = this._findStopBefore(i), u.from = this._blockStartPos(i), u instanceof He && (u.blockIndex = i), n.extend(u);
    }), n;
  }
  /**
    @override
  */
  extractInput() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (e === t)
      return "";
    let a = "";
    return this._forEachBlocksInRange(e, t, (i, s, o, u) => {
      a += i.extractInput(o, u, n);
    }), a;
  }
  _findStopBefore(e) {
    let t;
    for (let n = 0; n < this._stops.length; ++n) {
      const a = this._stops[n];
      if (a <= e)
        t = a;
      else
        break;
    }
    return t;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(e) {
    const t = new te();
    if (this.lazy && e == null)
      return t;
    const n = this._mapPosToBlock(this.value.length);
    if (!n)
      return t;
    const a = n.index, i = e ?? this._blocks.length;
    return this._blocks.slice(a, i).forEach((s) => {
      if (!s.lazy || e != null) {
        const o = s._blocks != null ? [s._blocks.length] : [], u = s._appendPlaceholder(...o);
        this._value += u.inserted, t.aggregate(u);
      }
    }), t;
  }
  /** Finds block in pos */
  _mapPosToBlock(e) {
    let t = "";
    for (let n = 0; n < this._blocks.length; ++n) {
      const a = this._blocks[n], i = t.length;
      if (t += a.value, e <= t.length)
        return {
          index: n,
          offset: e - i
        };
    }
  }
  /** */
  _blockStartPos(e) {
    return this._blocks.slice(0, e).reduce((t, n) => t += n.value.length, 0);
  }
  /** */
  _forEachBlocksInRange(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, n = arguments.length > 2 ? arguments[2] : void 0;
    const a = this._mapPosToBlock(e);
    if (a) {
      const i = this._mapPosToBlock(t), s = i && a.index === i.index, o = a.offset, u = i && s ? i.offset : this._blocks[a.index].value.length;
      if (n(this._blocks[a.index], a.index, o, u), i && !s) {
        for (let c = a.index + 1; c < i.index; ++c)
          n(this._blocks[c], c, 0, this._blocks[c].value.length);
        n(this._blocks[i.index], i.index, 0, i.offset);
      }
    }
  }
  /**
    @override
  */
  remove() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    const n = super.remove(e, t);
    return this._forEachBlocksInRange(e, t, (a, i, s, o) => {
      n.aggregate(a.remove(s, o));
    }), n;
  }
  /**
    @override
  */
  nearestInputPos(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : S.NONE;
    if (!this._blocks.length)
      return 0;
    const n = new il(this, e);
    if (t === S.NONE)
      return n.pushRightBeforeInput() || (n.popState(), n.pushLeftBeforeInput()) ? n.pos : this.value.length;
    if (t === S.LEFT || t === S.FORCE_LEFT) {
      if (t === S.LEFT) {
        if (n.pushRightBeforeFilled(), n.ok && n.pos === e)
          return e;
        n.popState();
      }
      if (n.pushLeftBeforeInput(), n.pushLeftBeforeRequired(), n.pushLeftBeforeFilled(), t === S.LEFT) {
        if (n.pushRightBeforeInput(), n.pushRightBeforeRequired(), n.ok && n.pos <= e || (n.popState(), n.ok && n.pos <= e))
          return n.pos;
        n.popState();
      }
      return n.ok ? n.pos : t === S.FORCE_LEFT ? 0 : (n.popState(), n.ok || (n.popState(), n.ok) ? n.pos : 0);
    }
    return t === S.RIGHT || t === S.FORCE_RIGHT ? (n.pushRightBeforeInput(), n.pushRightBeforeRequired(), n.pushRightBeforeFilled() ? n.pos : t === S.FORCE_RIGHT ? this.value.length : (n.popState(), n.ok || (n.popState(), n.ok) ? n.pos : this.nearestInputPos(e, S.LEFT))) : e;
  }
  /**
    @override
  */
  totalInputPositions() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, n = 0;
    return this._forEachBlocksInRange(e, t, (a, i, s, o) => {
      n += a.totalInputPositions(s, o);
    }), n;
  }
  /** Get block by name */
  maskedBlock(e) {
    return this.maskedBlocks(e)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(e) {
    const t = this._maskedBlocks[e];
    return t ? t.map((n) => this._blocks[n]) : [];
  }
}
Ce.DEFAULTS = {
  lazy: !0,
  placeholderChar: "_"
};
Ce.STOP_CHAR = "`";
Ce.ESCAPE_CHAR = "\\";
Ce.InputDefinition = sn;
Ce.FixedDefinition = on;
N.MaskedPattern = Ce;
class Dt extends Ce {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  /** */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  /**
    @override
  */
  _update(e) {
    e = Object.assign({
      to: this.to || 0,
      from: this.from || 0,
      maxLength: this.maxLength || 0
    }, e);
    let t = String(e.to).length;
    e.maxLength != null && (t = Math.max(t, e.maxLength)), e.maxLength = t;
    const n = String(e.from).padStart(t, "0"), a = String(e.to).padStart(t, "0");
    let i = 0;
    for (; i < a.length && a[i] === n[i]; )
      ++i;
    e.mask = a.slice(0, i).replace(/0/g, "\\0") + "0".repeat(t - i), super._update(e);
  }
  /**
    @override
  */
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(e) {
    let t = "", n = "";
    const [, a, i] = e.match(/^(\D*)(\d*)(\D*)/) || [];
    return i && (t = "0".repeat(a.length) + i, n = "9".repeat(a.length) + i), t = t.padEnd(this.maxLength, "0"), n = n.padEnd(this.maxLength, "9"), [t, n];
  }
  // TODO str is a single char everytime
  /**
    @override
  */
  doPrepare(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n;
    if ([e, n] = _t(super.doPrepare(e.replace(/\D/g, ""), t)), !this.autofix || !e)
      return e;
    const a = String(this.from).padStart(this.maxLength, "0"), i = String(this.to).padStart(this.maxLength, "0");
    let s = this.value + e;
    if (s.length > this.maxLength)
      return "";
    const [o, u] = this.boundaries(s);
    return Number(u) < this.from ? a[s.length - 1] : Number(o) > this.to ? this.autofix === "pad" && s.length < this.maxLength ? ["", n.aggregate(this.append(a[s.length - 1] + e, t))] : i[s.length - 1] : e;
  }
  /**
    @override
  */
  doValidate() {
    const e = this.value;
    if (e.search(/[^0]/) === -1 && e.length <= this._matchFrom)
      return !0;
    const [n, a] = this.boundaries(e);
    return this.from <= Number(a) && Number(n) <= this.to && super.doValidate(...arguments);
  }
}
N.MaskedRange = Dt;
class lt extends Ce {
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** */
  /**
    @param {Object} opts
  */
  constructor(e) {
    super(Object.assign({}, lt.DEFAULTS, e));
  }
  /**
    @override
  */
  _update(e) {
    e.mask === Date && delete e.mask, e.pattern && (e.mask = e.pattern);
    const t = e.blocks;
    e.blocks = Object.assign({}, lt.GET_DEFAULT_BLOCKS()), e.min && (e.blocks.Y.from = e.min.getFullYear()), e.max && (e.blocks.Y.to = e.max.getFullYear()), e.min && e.max && e.blocks.Y.from === e.blocks.Y.to && (e.blocks.m.from = e.min.getMonth() + 1, e.blocks.m.to = e.max.getMonth() + 1, e.blocks.m.from === e.blocks.m.to && (e.blocks.d.from = e.min.getDate(), e.blocks.d.to = e.max.getDate())), Object.assign(e.blocks, this.blocks, t), Object.keys(e.blocks).forEach((n) => {
      const a = e.blocks[n];
      !("autofix" in a) && "autofix" in e && (a.autofix = e.autofix);
    }), super._update(e);
  }
  /**
    @override
  */
  doValidate() {
    const e = this.date;
    return super.doValidate(...arguments) && (!this.isComplete || this.isDateExist(this.value) && e != null && (this.min == null || this.min <= e) && (this.max == null || e <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(e) {
    return this.format(this.parse(e, this), this).indexOf(e) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(e) {
    this.typedValue = e;
  }
  /**
    @override
  */
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(e) {
    super.typedValue = e;
  }
  /**
    @override
  */
  maskEquals(e) {
    return e === Date || super.maskEquals(e);
  }
}
lt.DEFAULTS = {
  pattern: "d{.}`m{.}`Y",
  format: (r) => {
    if (!r)
      return "";
    const e = String(r.getDate()).padStart(2, "0"), t = String(r.getMonth() + 1).padStart(2, "0"), n = r.getFullYear();
    return [e, t, n].join(".");
  },
  parse: (r) => {
    const [e, t, n] = r.split(".");
    return new Date(n, t - 1, e);
  }
};
lt.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: Dt,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: Dt,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: Dt,
    from: 1900,
    to: 9999
  }
});
N.MaskedDate = lt;
class ia {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let e;
    try {
      e = this._unsafeSelectionStart;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let e;
    try {
      e = this._unsafeSelectionEnd;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely sets element selection */
  select(e, t) {
    if (!(e == null || t == null || e === this.selectionStart && t === this.selectionEnd))
      try {
        this._unsafeSelect(e, t);
      } catch {
      }
  }
  /** Should be overriden in subclasses */
  _unsafeSelect(e, t) {
  }
  /** Should be overriden in subclasses */
  get isActive() {
    return !1;
  }
  /** Should be overriden in subclasses */
  bindEvents(e) {
  }
  /** Should be overriden in subclasses */
  unbindEvents() {
  }
}
N.MaskElement = ia;
class ft extends ia {
  /** Mapping between HTMLElement events and mask internal events */
  /** HTMLElement to use mask on */
  /**
    @param {HTMLInputElement|HTMLTextAreaElement} input
  */
  constructor(e) {
    super(), this.input = e, this._handlers = {};
  }
  /** */
  // $FlowFixMe https://github.com/facebook/flow/issues/2839
  get rootElement() {
    var e, t, n;
    return (e = (t = (n = this.input).getRootNode) === null || t === void 0 ? void 0 : t.call(n)) !== null && e !== void 0 ? e : document;
  }
  /**
    Is element in focus
    @readonly
  */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /**
    Returns HTMLElement selection start
    @override
  */
  get _unsafeSelectionStart() {
    return this.input.selectionStart;
  }
  /**
    Returns HTMLElement selection end
    @override
  */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /**
    Sets HTMLElement selection
    @override
  */
  _unsafeSelect(e, t) {
    this.input.setSelectionRange(e, t);
  }
  /**
    HTMLElement value
    @override
  */
  get value() {
    return this.input.value;
  }
  set value(e) {
    this.input.value = e;
  }
  /**
    Binds HTMLElement events to mask internal events
    @override
  */
  bindEvents(e) {
    Object.keys(e).forEach((t) => this._toggleEventHandler(ft.EVENTS_MAP[t], e[t]));
  }
  /**
    Unbinds HTMLElement events to mask internal events
    @override
  */
  unbindEvents() {
    Object.keys(this._handlers).forEach((e) => this._toggleEventHandler(e));
  }
  /** */
  _toggleEventHandler(e, t) {
    this._handlers[e] && (this.input.removeEventListener(e, this._handlers[e]), delete this._handlers[e]), t && (this.input.addEventListener(e, t), this._handlers[e] = t);
  }
}
ft.EVENTS_MAP = {
  selectionChange: "keydown",
  input: "input",
  drop: "drop",
  click: "click",
  focus: "focus",
  commit: "blur"
};
N.HTMLMaskElement = ft;
class un extends ft {
  /**
    Returns HTMLElement selection start
    @override
  */
  get _unsafeSelectionStart() {
    const e = this.rootElement, t = e.getSelection && e.getSelection(), n = t && t.anchorOffset, a = t && t.focusOffset;
    return a == null || n == null || n < a ? n : a;
  }
  /**
    Returns HTMLElement selection end
    @override
  */
  get _unsafeSelectionEnd() {
    const e = this.rootElement, t = e.getSelection && e.getSelection(), n = t && t.anchorOffset, a = t && t.focusOffset;
    return a == null || n == null || n > a ? n : a;
  }
  /**
    Sets HTMLElement selection
    @override
  */
  _unsafeSelect(e, t) {
    if (!this.rootElement.createRange)
      return;
    const n = this.rootElement.createRange();
    n.setStart(this.input.firstChild || this.input, e), n.setEnd(this.input.lastChild || this.input, t);
    const a = this.rootElement, i = a.getSelection && a.getSelection();
    i && (i.removeAllRanges(), i.addRange(n));
  }
  /**
    HTMLElement value
    @override
  */
  get value() {
    return this.input.textContent;
  }
  set value(e) {
    this.input.textContent = e;
  }
}
N.HTMLContenteditableMaskElement = un;
const ll = ["mask"];
class cl {
  /**
    View element
    @readonly
  */
  /**
    Internal {@link Masked} model
    @readonly
  */
  /**
    @param {MaskElement|HTMLInputElement|HTMLTextAreaElement} el
    @param {Object} opts
  */
  constructor(e, t) {
    this.el = e instanceof ia ? e : e.isContentEditable && e.tagName !== "INPUT" && e.tagName !== "TEXTAREA" ? new un(e) : new ft(e), this.masked = qe(t), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  /** Read or update mask */
  get mask() {
    return this.masked.mask;
  }
  maskEquals(e) {
    var t;
    return e == null || ((t = this.masked) === null || t === void 0 ? void 0 : t.maskEquals(e));
  }
  set mask(e) {
    if (this.maskEquals(e))
      return;
    if (!(e instanceof N.Masked) && this.masked.constructor === rn(e)) {
      this.masked.updateOptions({
        mask: e
      });
      return;
    }
    const t = qe({
      mask: e
    });
    t.unmaskedValue = this.masked.unmaskedValue, this.masked = t;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(e) {
    this.value !== e && (this.masked.value = e, this.updateControl(), this.alignCursor());
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(e) {
    this.unmaskedValue !== e && (this.masked.unmaskedValue = e, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(e) {
    this.masked.typedValueEquals(e) || (this.masked.typedValue = e, this.updateControl(), this.alignCursor());
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /**
    Starts listening to element events
    @protected
  */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange
    });
  }
  /**
    Stops listening to element events
    @protected
   */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /**
    Fires custom event
    @protected
   */
  _fireEvent(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
      n[a - 1] = arguments[a];
    const i = this._listeners[e];
    i && i.forEach((s) => s(...n));
  }
  /**
    Current selection start
    @readonly
  */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(e) {
    !this.el || !this.el.isActive || (this.el.select(e, e), this._saveSelection());
  }
  /**
    Stores current selection
    @protected
  */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl() {
    const e = this.masked.unmaskedValue, t = this.masked.value, n = this.displayValue, a = this.unmaskedValue !== e || this.value !== t;
    this._unmaskedValue = e, this._value = t, this.el.value !== n && (this.el.value = n), a && this._fireChangeEvents();
  }
  /** Updates options with deep equal check, recreates @{link Masked} model if mask type changes */
  updateOptions(e) {
    const {
      mask: t
    } = e, n = ut(e, ll), a = !this.maskEquals(t), i = !Lt(this.masked, n);
    a && (this.mask = t), i && this.masked.updateOptions(n), (a || i) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(e) {
    e != null && (this.cursorPos = e, this._delayUpdateCursor(e));
  }
  /**
    Delays cursor update to support mobile browsers
    @private
  */
  _delayUpdateCursor(e) {
    this._abortUpdateCursor(), this._changingCursorPos = e, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /**
    Fires custom events
    @protected
  */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /**
    Aborts delayed cursor update
    @private
  */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, S.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(e, t) {
    return this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(t), this;
  }
  /** Removes custom event listener */
  off(e, t) {
    if (!this._listeners[e])
      return this;
    if (!t)
      return delete this._listeners[e], this;
    const n = this._listeners[e].indexOf(t);
    return n >= 0 && this._listeners[e].splice(n, 1), this;
  }
  /** Handles view input event */
  _onInput(e) {
    if (this._inputEvent = e, this._abortUpdateCursor(), !this._selection)
      return this.updateValue();
    const t = new al(
      // new state
      this.el.value,
      this.cursorPos,
      // old state
      this.displayValue,
      this._selection
    ), n = this.masked.rawInputValue, a = this.masked.splice(t.startChangePos, t.removed.length, t.inserted, t.removeDirection, {
      input: !0,
      raw: !0
    }).offset, i = n === this.masked.rawInputValue ? t.removeDirection : S.NONE;
    let s = this.masked.nearestInputPos(t.startChangePos + a, i);
    i !== S.NONE && (s = this.masked.nearestInputPos(s, S.NONE)), this.updateControl(), this.updateCursor(s), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(e) {
    e.preventDefault(), e.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(e) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(e) {
    this.alignCursorFriendly();
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
N.InputMask = cl;
class dl extends Ce {
  /**
    @override
    @param {Object} opts
  */
  _update(e) {
    e.enum && (e.mask = "*".repeat(e.enum[0].length)), super._update(e);
  }
  /**
    @override
  */
  doValidate() {
    return this.enum.some((e) => e.indexOf(this.unmaskedValue) >= 0) && super.doValidate(...arguments);
  }
}
N.MaskedEnum = dl;
class De extends be {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  constructor(e) {
    super(Object.assign({}, De.DEFAULTS, e));
  }
  /**
    @override
  */
  _update(e) {
    super._update(e), this._updateRegExps();
  }
  /** */
  _updateRegExps() {
    let e = "^" + (this.allowNegative ? "[+|\\-]?" : ""), t = "\\d*", n = (this.scale ? "(".concat(Ut(this.radix), "\\d{0,").concat(this.scale, "})?") : "") + "$";
    this._numberRegExp = new RegExp(e + t + n), this._mapToRadixRegExp = new RegExp("[".concat(this.mapToRadix.map(Ut).join(""), "]"), "g"), this._thousandsSeparatorRegExp = new RegExp(Ut(this.thousandsSeparator), "g");
  }
  /** */
  _removeThousandsSeparators(e) {
    return e.replace(this._thousandsSeparatorRegExp, "");
  }
  /** */
  _insertThousandsSeparators(e) {
    const t = e.split(this.radix);
    return t[0] = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), t.join(this.radix);
  }
  /**
    @override
  */
  doPrepare(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    e = this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    (t.input && t.raw || !t.input && !t.raw) ? e.replace(this._mapToRadixRegExp, this.radix) : e);
    const [n, a] = _t(super.doPrepare(e, t));
    return e && !n && (a.skip = !0), [n, a];
  }
  /** */
  _separatorsCount(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = 0;
    for (let a = 0; a < e; ++a)
      this._value.indexOf(this.thousandsSeparator, a) === a && (++n, t && (e += this.thousandsSeparator.length));
    return n;
  }
  /** */
  _separatorsCountFromSlice() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._value;
    return this._separatorsCount(this._removeThousandsSeparators(e).length, !0);
  }
  /**
    @override
  */
  extractInput() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, n = arguments.length > 2 ? arguments[2] : void 0;
    return [e, t] = this._adjustRangeWithSeparators(e, t), this._removeThousandsSeparators(super.extractInput(e, t, n));
  }
  /**
    @override
  */
  _appendCharRaw(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.thousandsSeparator)
      return super._appendCharRaw(e, t);
    const n = t.tail && t._beforeTailState ? t._beforeTailState._value : this._value, a = this._separatorsCountFromSlice(n);
    this._value = this._removeThousandsSeparators(this.value);
    const i = super._appendCharRaw(e, t);
    this._value = this._insertThousandsSeparators(this._value);
    const s = t.tail && t._beforeTailState ? t._beforeTailState._value : this._value, o = this._separatorsCountFromSlice(s);
    return i.tailShift += (o - a) * this.thousandsSeparator.length, i.skip = !i.rawInserted && e === this.thousandsSeparator, i;
  }
  /** */
  _findSeparatorAround(e) {
    if (this.thousandsSeparator) {
      const t = e - this.thousandsSeparator.length + 1, n = this.value.indexOf(this.thousandsSeparator, t);
      if (n <= e)
        return n;
    }
    return -1;
  }
  _adjustRangeWithSeparators(e, t) {
    const n = this._findSeparatorAround(e);
    n >= 0 && (e = n);
    const a = this._findSeparatorAround(t);
    return a >= 0 && (t = a + this.thousandsSeparator.length), [e, t];
  }
  /**
    @override
  */
  remove() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
    [e, t] = this._adjustRangeWithSeparators(e, t);
    const n = this.value.slice(0, e), a = this.value.slice(t), i = this._separatorsCount(n.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(n + a));
    const s = this._separatorsCountFromSlice(n);
    return new te({
      tailShift: (s - i) * this.thousandsSeparator.length
    });
  }
  /**
    @override
  */
  nearestInputPos(e, t) {
    if (!this.thousandsSeparator)
      return e;
    switch (t) {
      case S.NONE:
      case S.LEFT:
      case S.FORCE_LEFT: {
        const n = this._findSeparatorAround(e - 1);
        if (n >= 0) {
          const a = n + this.thousandsSeparator.length;
          if (e < a || this.value.length <= a || t === S.FORCE_LEFT)
            return n;
        }
        break;
      }
      case S.RIGHT:
      case S.FORCE_RIGHT: {
        const n = this._findSeparatorAround(e);
        if (n >= 0)
          return n + this.thousandsSeparator.length;
      }
    }
    return e;
  }
  /**
    @override
  */
  doValidate(e) {
    let t = !!this._removeThousandsSeparators(this.value).match(this._numberRegExp);
    if (t) {
      const n = this.number;
      t = t && !isNaN(n) && // check min bound for negative values
      (this.min == null || this.min >= 0 || this.min <= this.number) && // check max bound for positive values
      (this.max == null || this.max <= 0 || this.number <= this.max);
    }
    return t && super.doValidate(e);
  }
  /**
    @override
  */
  doCommit() {
    if (this.value) {
      const e = this.number;
      let t = e;
      this.min != null && (t = Math.max(t, this.min)), this.max != null && (t = Math.min(t, this.max)), t !== e && (this.unmaskedValue = this.doFormat(t));
      let n = this.value;
      this.normalizeZeros && (n = this._normalizeZeros(n)), this.padFractionalZeros && this.scale > 0 && (n = this._padFractionalZeros(n)), this._value = n;
    }
    super.doCommit();
  }
  /** */
  _normalizeZeros(e) {
    const t = this._removeThousandsSeparators(e).split(this.radix);
    return t[0] = t[0].replace(/^(\D*)(0*)(\d*)/, (n, a, i, s) => a + s), e.length && !/\d$/.test(t[0]) && (t[0] = t[0] + "0"), t.length > 1 && (t[1] = t[1].replace(/0*$/, ""), t[1].length || (t.length = 1)), this._insertThousandsSeparators(t.join(this.radix));
  }
  /** */
  _padFractionalZeros(e) {
    if (!e)
      return e;
    const t = e.split(this.radix);
    return t.length < 2 && t.push(""), t[1] = t[1].padEnd(this.scale, "0"), t.join(this.radix);
  }
  /** */
  doSkipInvalid(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
    const a = this.scale === 0 && e !== this.thousandsSeparator && (e === this.radix || e === De.UNMASKED_RADIX || this.mapToRadix.includes(e));
    return super.doSkipInvalid(e, t, n) && !a;
  }
  /**
    @override
  */
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, De.UNMASKED_RADIX);
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  /**
    @override
  */
  get typedValue() {
    return this.doParse(this.unmaskedValue);
  }
  set typedValue(e) {
    this.rawInputValue = this.doFormat(e).replace(De.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(e) {
    this.typedValue = e;
  }
  /**
    Is negative allowed
    @readonly
  */
  get allowNegative() {
    return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  /**
    @override
  */
  typedValueEquals(e) {
    return (super.typedValueEquals(e) || De.EMPTY_VALUES.includes(e) && De.EMPTY_VALUES.includes(this.typedValue)) && !(e === 0 && this.value === "");
  }
}
De.UNMASKED_RADIX = ".";
De.DEFAULTS = {
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [De.UNMASKED_RADIX],
  scale: 2,
  signed: !1,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: (r) => r.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
De.EMPTY_VALUES = [...be.EMPTY_VALUES, 0];
N.MaskedNumber = De;
class hl extends be {
  /**
    @override
    @param {Object} opts
  */
  _update(e) {
    e.mask && (e.validate = e.mask), super._update(e);
  }
}
N.MaskedFunction = hl;
const fl = ["compiledMasks", "currentMaskRef", "currentMask"], vl = ["mask"];
class Rt extends be {
  /** Currently chosen mask */
  /** Compliled {@link Masked} options */
  /** Chooses {@link Masked} depending on input value */
  /**
    @param {Object} opts
  */
  constructor(e) {
    super(Object.assign({}, Rt.DEFAULTS, e)), this.currentMask = null;
  }
  /**
    @override
  */
  _update(e) {
    super._update(e), "mask" in e && (this.compiledMasks = Array.isArray(e.mask) ? e.mask.map((t) => qe(t)) : []);
  }
  /**
    @override
  */
  _appendCharRaw(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this._applyDispatch(e, t);
    return this.currentMask && n.aggregate(this.currentMask._appendChar(e, this.currentMaskFlags(t))), n;
  }
  _applyDispatch() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    const a = t.tail && t._beforeTailState != null ? t._beforeTailState._value : this.value, i = this.rawInputValue, s = t.tail && t._beforeTailState != null ? (
      // $FlowFixMe - tired to fight with type system
      t._beforeTailState._rawInputValue
    ) : i, o = i.slice(s.length), u = this.currentMask, c = new te(), v = u == null ? void 0 : u.state;
    if (this.currentMask = this.doDispatch(e, Object.assign({}, t), n), this.currentMask)
      if (this.currentMask !== u) {
        if (this.currentMask.reset(), s) {
          const g = this.currentMask.append(s, {
            raw: !0
          });
          c.tailShift = g.inserted.length - a.length;
        }
        o && (c.tailShift += this.currentMask.append(o, {
          raw: !0,
          tail: !0
        }).tailShift);
      } else
        this.currentMask.state = v;
    return c;
  }
  _appendPlaceholder() {
    const e = this._applyDispatch(...arguments);
    return this.currentMask && e.aggregate(this.currentMask._appendPlaceholder()), e;
  }
  /**
   @override
  */
  _appendEager() {
    const e = this._applyDispatch(...arguments);
    return this.currentMask && e.aggregate(this.currentMask._appendEager()), e;
  }
  appendTail(e) {
    const t = new te();
    return e && t.aggregate(this._applyDispatch("", {}, e)), t.aggregate(this.currentMask ? this.currentMask.appendTail(e) : super.appendTail(e));
  }
  currentMaskFlags(e) {
    var t, n;
    return Object.assign({}, e, {
      _beforeTailState: ((t = e._beforeTailState) === null || t === void 0 ? void 0 : t.currentMaskRef) === this.currentMask && ((n = e._beforeTailState) === null || n === void 0 ? void 0 : n.currentMask) || e._beforeTailState
    });
  }
  /**
    @override
  */
  doDispatch(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    return this.dispatch(e, this, t, n);
  }
  /**
    @override
  */
  doValidate(e) {
    return super.doValidate(e) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(e)));
  }
  /**
    @override
  */
  doPrepare(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, [n, a] = _t(super.doPrepare(e, t));
    if (this.currentMask) {
      let i;
      [n, i] = _t(super.doPrepare(n, this.currentMaskFlags(t))), a = a.aggregate(i);
    }
    return [n, a];
  }
  /**
    @override
  */
  reset() {
    var e;
    (e = this.currentMask) === null || e === void 0 || e.reset(), this.compiledMasks.forEach((t) => t.reset());
  }
  /**
    @override
  */
  get value() {
    return this.currentMask ? this.currentMask.value : "";
  }
  set value(e) {
    super.value = e;
  }
  /**
    @override
  */
  get unmaskedValue() {
    return this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  /**
    @override
  */
  get typedValue() {
    return this.currentMask ? this.currentMask.typedValue : "";
  }
  // probably typedValue should not be used with dynamic
  set typedValue(e) {
    let t = String(e);
    this.currentMask && (this.currentMask.typedValue = e, t = this.currentMask.unmaskedValue), this.unmaskedValue = t;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  /**
    @override
  */
  get isComplete() {
    var e;
    return !!(!((e = this.currentMask) === null || e === void 0) && e.isComplete);
  }
  /**
    @override
  */
  get isFilled() {
    var e;
    return !!(!((e = this.currentMask) === null || e === void 0) && e.isFilled);
  }
  /**
    @override
  */
  remove() {
    const e = new te();
    return this.currentMask && e.aggregate(this.currentMask.remove(...arguments)).aggregate(this._applyDispatch()), e;
  }
  /**
    @override
  */
  get state() {
    var e;
    return Object.assign({}, super.state, {
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((t) => t.state),
      currentMaskRef: this.currentMask,
      currentMask: (e = this.currentMask) === null || e === void 0 ? void 0 : e.state
    });
  }
  set state(e) {
    const {
      compiledMasks: t,
      currentMaskRef: n,
      currentMask: a
    } = e, i = ut(e, fl);
    this.compiledMasks.forEach((s, o) => s.state = t[o]), n != null && (this.currentMask = n, this.currentMask.state = a), super.state = i;
  }
  /**
    @override
  */
  extractInput() {
    return this.currentMask ? this.currentMask.extractInput(...arguments) : "";
  }
  /**
    @override
  */
  extractTail() {
    return this.currentMask ? this.currentMask.extractTail(...arguments) : super.extractTail(...arguments);
  }
  /**
    @override
  */
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  /**
    @override
  */
  nearestInputPos() {
    return this.currentMask ? this.currentMask.nearestInputPos(...arguments) : super.nearestInputPos(...arguments);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : super.overwrite;
  }
  set overwrite(e) {
    console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : super.eager;
  }
  set eager(e) {
    console.warn('"eager" option is not available in dynamic mask, use this option in siblings');
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : super.skipInvalid;
  }
  set skipInvalid(e) {
    (this.isInitialized || e !== be.DEFAULTS.skipInvalid) && console.warn('"skipInvalid" option is not available in dynamic mask, use this option in siblings');
  }
  /**
    @override
  */
  maskEquals(e) {
    return Array.isArray(e) && this.compiledMasks.every((t, n) => {
      if (!e[n])
        return;
      const a = e[n], {
        mask: i
      } = a, s = ut(a, vl);
      return Lt(t, s) && t.maskEquals(i);
    });
  }
  /**
    @override
  */
  typedValueEquals(e) {
    var t;
    return !!(!((t = this.currentMask) === null || t === void 0) && t.typedValueEquals(e));
  }
}
Rt.DEFAULTS = {
  dispatch: (r, e, t, n) => {
    if (!e.compiledMasks.length)
      return;
    const a = e.rawInputValue, i = e.compiledMasks.map((s, o) => {
      const u = e.currentMask === s, c = u ? s.value.length : s.nearestInputPos(s.value.length, S.FORCE_LEFT);
      return s.rawInputValue !== a ? (s.reset(), s.append(a, {
        raw: !0
      })) : u || s.remove(c), s.append(r, e.currentMaskFlags(t)), s.appendTail(n), {
        index: o,
        weight: s.rawInputValue.length,
        totalInputPositions: s.totalInputPositions(0, Math.max(c, s.nearestInputPos(s.value.length, S.FORCE_LEFT)))
      };
    });
    return i.sort((s, o) => o.weight - s.weight || o.totalInputPositions - s.totalInputPositions), e.compiledMasks[i[0].index];
  }
};
N.MaskedDynamic = Rt;
const Kt = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function ln(r) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Kt.MASKED, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Kt.MASKED;
  const n = qe(r);
  return (a) => n.runIsolated((i) => (i[e] = a, i[t]));
}
function pl(r) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
    t[n - 1] = arguments[n];
  return ln(...t)(r);
}
N.PIPE_TYPE = Kt;
N.createPipe = ln;
N.pipe = pl;
try {
  globalThis.IMask = N;
} catch {
}
var cn = {
  // common
  mask: {},
  prepare: Function,
  validate: Function,
  commit: Function,
  overwrite: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  // pattern
  placeholderChar: String,
  lazy: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  definitions: Object,
  blocks: Object,
  // date
  pattern: String,
  format: Function,
  parse: Function,
  autofix: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  // number
  radix: String,
  thousandsSeparator: String,
  mapToRadix: Array,
  scale: Number,
  signed: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  normalizeZeros: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  padFractionalZeros: {
    type: Boolean,
    required: !1,
    default: void 0
  },
  min: [Number, Date],
  max: [Number, Date],
  // dynamic
  dispatch: Function
};
function ml(r) {
  let {
    emit: e,
    onAccept: t,
    onComplete: n
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  r = kn(r) ? r : y(r);
  const a = y(), i = y(), s = y(), o = y(), u = y();
  let c, v, g, f;
  function _() {
    f = u.value = i.value.typedValue, g = o.value = i.value.unmaskedValue, v = s.value = i.value.value, e && (e("accept", v), e("accept:masked", v), e("accept:typed", f), e("accept:unmasked", g)), t && t();
  }
  function b() {
    e && (e("complete", v), e("complete:masked", v), e("complete:typed", f), e("complete:unmasked", g)), n && n();
  }
  function D() {
    c = a.value;
    const m = r.value;
    !c || !(m != null && m.mask) || (i.value = N(c, m).on("accept", _).on("complete", b), _());
  }
  function p() {
    i.value && (i.value.destroy(), i.value = null);
  }
  return Ae(D), Ie(p), $e(o, () => {
    i.value && (g = i.value.unmaskedValue = o.value);
  }), $e(s, () => {
    i.value && (v = i.value.value = s.value);
  }), $e(u, () => {
    i.value && (f = i.value.typedValue = u.value);
  }), $e([a, r], () => {
    const m = a.value, w = r.value;
    (!(w != null && w.mask) || m !== c) && p(), m && (i.value ? i.value.updateOptions(w) : D());
  }), {
    el: a,
    mask: yn(i),
    masked: s,
    unmasked: o,
    typed: u
  };
}
const gl = ["typed", "unmasked", "value", "modelValue"];
function _l(r) {
  return r = Object.assign({}, r), Object.keys(r).filter((e) => r[e] === void 0).forEach((e) => {
    delete r[e];
  }), gl.forEach((e) => delete r[e]), r;
}
Object.assign({
  // plugin
  modelValue: String,
  value: String,
  unmasked: String,
  typed: {}
}, cn);
Object.assign({
  value: {},
  unmask: {
    validator: function(r) {
      return r === "typed" || typeof r == "boolean";
    }
  }
}, cn);
var bl = {
  name: "imask",
  beforeMount: (r, e) => {
    let {
      value: t
    } = e;
    t && Ea(r, t);
  },
  updated: (r, e) => {
    let {
      value: t
    } = e;
    t ? r.maskRef ? (r.maskRef.updateOptions(t), r.value !== r.maskRef.value && r.maskRef._onChange()) : Ea(r, t) : Ma(r);
  },
  unmounted: (r) => {
    Ma(r);
  }
};
function $a(r, e, t) {
  var n = document.createEvent("CustomEvent");
  n.initCustomEvent(e, !0, !0, t), r.dispatchEvent(n);
}
function Ea(r, e) {
  r.maskRef = N(r, e).on("accept", () => $a(r, "accept", r.maskRef)).on("complete", () => $a(r, "complete", r.maskRef));
}
function Ma(r) {
  r.maskRef && (r.maskRef.destroy(), delete r.maskRef);
}
const wl = (r) => (ne("data-v-0644588a"), r = r(), re(), r), kl = { class: "aeb-datepicker__label" }, yl = /* @__PURE__ */ wl(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("rect", {
    height: "14",
    rx: "1",
    stroke: "#27303E",
    "stroke-width": "2",
    width: "14",
    x: "5",
    y: "6"
  }),
  /* @__PURE__ */ l("rect", {
    fill: "#27303E",
    height: "4",
    rx: "2",
    width: "16",
    x: "4",
    y: "5"
  }),
  /* @__PURE__ */ l("rect", {
    fill: "#27303E",
    height: "2",
    rx: "1",
    transform: "rotate(90 9 3)",
    width: "3",
    x: "9",
    y: "3"
  }),
  /* @__PURE__ */ l("rect", {
    fill: "#27303E",
    height: "2",
    rx: "1",
    transform: "rotate(90 17 3)",
    width: "3",
    x: "17",
    y: "3"
  })
], -1)), Cl = [
  yl
], Dl = {
  name: "aeb-datepicker",
  directives: {
    clickOutside: dt,
    imask: bl
  }
}, $l = /* @__PURE__ */ A({
  ...Dl,
  props: {
    date: { type: Date },
    hasError: { type: Boolean },
    disabled: { type: Boolean, default: !1 },
    minDate: { type: Date, default: Qt(/* @__PURE__ */ new Date(), 100) },
    maxDate: { type: Date, default: Et(/* @__PURE__ */ new Date(), 50) },
    excludedDates: { type: Array, default: () => [] },
    minYear: { type: Date, default: Qt(/* @__PURE__ */ new Date(), 100) },
    maxYear: { type: Date, default: Et(/* @__PURE__ */ new Date(), 50) },
    withBackground: { type: Boolean, default: !0 },
    align: { type: String, default: "right" },
    placeholder: { type: String, default: "Введите дату" },
    collapseOnChange: { type: Boolean, default: !0 },
    withoutDays: { type: Boolean, default: !1 }
  },
  emits: ["onChange"],
  setup(r, { emit: e }) {
    const t = r, n = e, a = y(!1), i = y(t.date ? t.date : /* @__PURE__ */ new Date()), s = y(t.date ? Da(i.value) : ""), o = y(), u = y(""), c = y(!1), v = y(), g = y(), f = y(
      t.withoutDays ? i.value.getFullYear() : (/* @__PURE__ */ new Date()).getFullYear()
    ), _ = y(
      t.withoutDays ? i.value.getMonth() : (/* @__PURE__ */ new Date()).getMonth()
    ), b = y(), D = {
      mask: Date,
      ...t.withoutDays && {
        pattern: "m.Y",
        format: (L) => gt(L, "MM.yyyy"),
        parse: (L) => zt(L, "MM.yyyy", /* @__PURE__ */ new Date())
      },
      min: t.minDate,
      max: t.maxDate
    }, p = () => {
      const L = m(v.value);
      L && L.addEventListener("scroll", w), document.addEventListener("scroll", w);
    }, m = (L) => L === null ? null : L.scrollHeight > L.clientHeight ? L : m(L.parentNode), w = () => {
      if (v.value && g.value.coreRef) {
        const { height: L } = g.value.coreRef.getBoundingClientRect(), ve = document.documentElement.offsetHeight, {
          left: W,
          top: Q,
          width: me,
          height: Ze,
          right: Re
        } = v.value.getBoundingClientRect(), Ee = L + Q + 66 > ve, vt = Q - L - 20, Ve = vt < 0, wt = Q - L / 2 + Ze / 2, Qe = 296, Xe = Re + Qe + 10, oe = Ee ? Ve ? wt : vt : Q + 66, ee = Xe < window.innerWidth ? W + me + 10 : W - Qe - 10, _e = t.align === "right" ? `left: ${W + me - Qe}px; top: ${oe}px` : `left: ${W}px; top: ${oe}px`, Ke = `left: ${ee}px; top: ${oe}px`;
        b.value = Ee && Ve ? Ke : _e;
      }
    }, E = (L) => {
      a.value && (a.value = !1, u.value === "" && (o.value.resetValue(), c.value = !1), s.value = u.value);
    }, C = () => {
      a.value || (w(), a.value = !0);
    }, Y = () => {
      a.value || w(), a.value = !a.value;
    }, O = (L) => {
      t.disabled || (L ? c.value = !0 : (s.value = "", c.value = !1), i.value = L || /* @__PURE__ */ new Date(), n("onChange", L));
    }, $ = (L) => {
      L ? _.value === 11 ? (_.value = 0, f.value = f.value + 1) : _.value = _.value + 1 : _.value === 0 ? (_.value = 11, f.value = f.value - 1) : _.value = _.value - 1;
    }, T = (L) => {
      const [ve, W] = L;
      _.value = ve;
      const Q = `${String(_.value + 1).length === 1 ? `0${_.value + 1}` : _.value + 1}.${f.value}`;
      W || (s.value = Q, u.value = s.value, O(new Date(f.value, _.value, 1))), t.collapseOnChange && (a.value = !1);
    }, j = (L) => {
      const [ve, W] = L;
      f.value = ve;
      let Q = `${String(_.value + 1).length === 1 ? `0${_.value + 1}` : _.value + 1}.${f.value}`;
      Pt(t.minDate, Ca(`01.${Q}`)) ? (_.value = new Date(t.minDate).getMonth(), g.value.setMonth(_.value)) : At(t.maxDate, Ca(`01.${Q}`)) && (_.value = new Date(t.maxDate).getMonth(), g.value.setMonth(_.value)), W || (s.value = Q, u.value = s.value, O(new Date(f.value, _.value, 1))), t.collapseOnChange && (a.value = !1);
    }, fe = (L) => {
      s.value = Da(L), u.value = s.value, c.value = !0, i.value = L, O(L), t.collapseOnChange && (a.value = !1);
    }, we = (L) => {
      const ve = L.target;
      s.value = ve.value, ve.value !== "" && (c.value = !1);
    }, ke = (L) => {
      var Q;
      const ve = L.detail, W = zt(
        ve.value,
        t.withoutDays ? "MM.yyyy" : "dd.MM.yyyy",
        /* @__PURE__ */ new Date()
      );
      St(W, i.value) || ((Q = t.excludedDates) != null && Q.some((me) => St(me, W)) ? s.value = u.value : (u.value = ve.value, i.value = W, n("onChange", i.value), g.value.setAll(i.value.getMonth(), i.value.getFullYear())));
    };
    return Ae(() => {
      p(), w();
    }), Ie(() => {
      const L = m(v.value);
      document.removeEventListener("scroll", w), L && L.removeEventListener("scroll", w);
    }), (L, ve) => {
      const W = qt("imask"), Q = qt("click-outside");
      return Ye((d(), h("div", {
        ref_key: "containerRef",
        ref: v,
        class: P([{ "aeb-datepicker--disabled": r.disabled }, "aeb-datepicker"])
      }, [
        ae(st, {
          ref_key: "formFieldRef",
          ref: o,
          class: P([{
            "aeb-datepicker__field--onerror": r.hasError,
            "has-value": c.value
          }, "aeb-datepicker__field"])
        }, {
          label: se(() => [
            l("label", kl, k(r.placeholder), 1)
          ]),
          default: se(() => [
            Ye(ae(bt, {
              value: s.value,
              class: "aeb-datepicker__input",
              maxlength: "10",
              type: "text",
              onInput: we,
              onClick: C,
              onComplete: ke
            }, null, 8, ["value"]), [
              [W, D]
            ]),
            l("div", {
              class: "aeb-datepicker__calendar-icon",
              onClick: Y
            }, Cl)
          ]),
          _: 1
        }, 8, ["class"]),
        ae(nn, {
          ref_key: "coreRef",
          ref: g,
          align: r.align,
          class: P([{ "aeb-datepicker-core--disabled": !a.value }, "aeb-datepicker-core"]),
          date: i.value,
          excludedDates: r.excludedDates,
          maxDate: r.maxDate,
          maxYear: r.maxYear,
          minDate: r.minDate,
          minYear: r.minYear,
          style: pe(b.value),
          withBackground: r.withBackground,
          withoutDays: r.withoutDays,
          onOnDateChange: fe,
          onWoDaysMonth: T,
          onWoDaysMonthSubInc: $,
          onWoDaysYear: j
        }, null, 8, ["align", "class", "date", "excludedDates", "maxDate", "maxYear", "minDate", "minYear", "style", "withBackground", "withoutDays"])
      ], 2)), [
        [Q, E]
      ]);
    };
  }
}), El = /* @__PURE__ */ B($l, [["__scopeId", "data-v-0644588a"]]), Ml = (r) => (ne("data-v-f7f9a776"), r = r(), re(), r), Tl = { class: "aeb-dropdown__input-wrapper" }, xl = /* @__PURE__ */ Ml(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M6.85718 9.42854L12 14.5714L17.1429 9.42854",
    stroke: "#94A8BE",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.6"
  })
], -1)), Fl = [
  xl
], Pl = {
  key: 0,
  class: "aeb-dropdown__items"
}, Al = ["onClick"], Sl = {
  name: "aeb-dropdown"
}, Ll = /* @__PURE__ */ A({
  ...Sl,
  props: {
    options: { default: () => [] },
    label: {},
    hasError: { type: Boolean },
    disabled: { type: Boolean },
    filter: { type: Boolean, default: !0 },
    value: {}
  },
  emits: ["change", "select"],
  setup(r, { emit: e }) {
    const t = r, n = e, a = y(!1);
    let i = y(t.options);
    const s = y(), o = y(), u = y(), c = () => {
      a.value && (a.value = !1, s.value && s.value.classList.remove("aeb-dropdown__input--lock"));
    }, v = () => {
      t.disabled || (a.value && s.value && s.value.classList.remove("aeb-dropdown__input--lock"), a.value = !a.value);
    }, g = () => {
      t.disabled || a.value || (a.value = !0, s.value && s.value.classList.add("aeb-dropdown__input--lock"));
    }, f = (p) => {
      if (t.disabled)
        return;
      const m = p.target;
      if (u.value = m.value, n("change", m.value), !m.value) {
        i.value = t.options;
        return;
      }
      _(m.value);
    }, _ = (p) => {
      t.filter && (i.value = (t.options || []).filter((m) => m.label.slice(0, p.length).toLocaleLowerCase() === p.toLocaleLowerCase()));
    }, b = (p) => {
      t.disabled || (u.value = p.label, o.value = p, _(p.label), n("change", p.label), s.value && s.value.classList.remove("aeb-dropdown__input--lock"), a.value = !1);
    }, D = () => {
      o.value = null, i.value = t.options;
    };
    return mt(() => {
      t.value || D(), u.value = t.value;
    }), mt(() => {
      i.value = t.options;
    }), mt(() => {
      o.value && n("select", o.value);
    }), (p, m) => Ye((d(), h("div", {
      class: P([{
        "aeb-dropdown--on-error": p.hasError,
        "aeb-dropdown--disabled": p.disabled
      }, "aeb-dropdown"])
    }, [
      l("div", Tl, [
        l("div", {
          ref_key: "input",
          ref: s,
          class: P([{
            "aeb-dropdown__input--isOpen": a.value
          }, "aeb-dropdown__input"]),
          onClick: g
        }, [
          ae(st, null, {
            label: se(() => [
              ue(k(p.label), 1)
            ]),
            default: se(() => [
              ae(bt, {
                value: u.value,
                type: "text",
                onInput: f
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ], 2),
        l("div", {
          class: P([{
            "aeb-dropdown__icon--isOpen": a.value
          }, "aeb-dropdown__icon"]),
          onClick: v
        }, Fl, 2)
      ]),
      a.value ? (d(), h("div", Pl, [
        (d(!0), h(R, null, X(H(i), (w) => (d(), h("div", {
          key: w.toString(),
          class: "aeb-dropdown__option",
          onClick: () => b(w)
        }, k(w.label), 9, Al))), 128))
      ])) : F("", !0)
    ], 2)), [
      [H(dt), c]
    ]);
  }
}), Ol = /* @__PURE__ */ B(Ll, [["__scopeId", "data-v-f7f9a776"]]), nt = {
  ru: "ru-RU",
  en: "en-EN"
}, Bl = {
  ru: Ft,
  en: aa
}, rt = (r, e, t = 1, n = 0, a = 0, i = "decimal") => (r || (r = 0), new Intl.NumberFormat(
  nt[e],
  {
    style: i,
    minimumIntegerDigits: t,
    minimumFractionDigits: n,
    maximumFractionDigits: a
  }
).format(r)), Il = (r, e, t, n = "ru") => {
  if (!r)
    return "";
  if (e === "date")
    return gt(new Date(r), t || "P", {
      locale: Bl[n]
    });
  if (e === "number") {
    const a = String(t).split(/\.|-/), i = rt(
      Number(r),
      n,
      +a[0],
      +a[1],
      +a[2]
    ).split(",");
    return `<b>${i[0]}, </b>${i[1]}`;
  }
  return r;
}, Rl = { class: "field-slider" }, Vl = { class: "field-slider__line" }, Nl = { class: "field-slider__limits" }, Hl = {
  name: "aeb-field-slider"
}, Yl = /* @__PURE__ */ A({
  ...Hl,
  props: {
    label: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: "₽"
    },
    min: {
      type: Number,
      default: 1e3
    },
    max: {
      type: Number,
      default: 5e6
    },
    step: {
      type: Number,
      default: 1e3
    },
    value: {
      type: Number
    },
    valueSeparator: {
      type: String,
      default: " "
    },
    isPressed: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["value-change"],
  setup(r, { emit: e }) {
    const t = r, n = e, a = ($, T, j) => !$ || !T || !j ? $ : $.replace(new RegExp(T, "g"), j), i = y(t.max / 2), s = y(t.isPressed), o = y(), u = y("string"), c = y(null), v = y(null), g = ($) => {
      u.value = "string";
      const T = new Intl.NumberFormat("ru-RU").format(
        $ || i.value
      );
      o.value = T + " " + t.prefix;
    }, f = () => {
      const $ = (i.value - t.min) / (t.max - t.min) * 100;
      return $ < 0 ? 0 : $ > 100 ? 100 : $;
    }, _ = ($) => {
      u.value = "number", o.value = $ || String(i.value), n("value-change", i.value);
    }, b = ($) => {
      i.value = $, _($);
    }, D = ($) => {
      const T = parseInt($.target.value, 10);
      if (T < t.min || isNaN(T))
        b(t.min);
      else if (T > t.max)
        b(t.max);
      else if (T % t.step !== 0) {
        const j = Math.round(T / t.step) * t.step;
        b(j);
      } else
        b(T);
    }, p = ($) => {
      $.preventDefault(), $.clientX && C($.clientX);
    }, m = ($) => {
      $.preventDefault(), s.value = !1, n("value-change", i.value), document.removeEventListener("mousemove", p), document.removeEventListener("mouseup", m);
    }, w = ($) => {
      if ($.preventDefault(), $.touches && $.touches.length) {
        const T = $.touches[0];
        C(T.clientX);
      }
    }, E = ($) => {
      $.preventDefault(), s.value = !1, n("value-change", i.value), document.removeEventListener("touchmove", w), document.removeEventListener("touchend", E), document.removeEventListener("touchcancel", E);
    }, C = ($) => {
      var ke, L;
      s.value = !0;
      const T = (ke = c.value) == null ? void 0 : ke.getBoundingClientRect().left, j = (L = c.value) == null ? void 0 : L.getBoundingClientRect().width;
      let fe = $ - T;
      fe < 0 && (fe = 0), fe > j && (fe = j);
      const we = fe / j * (t.max - t.min);
      i.value = Math.round(we / t.step) * t.step + t.min, g(
        Math.round(we / t.step) * t.step + t.min
      );
    }, Y = ($) => {
      $.preventDefault(), v.value.$el.blur(), p($), document.addEventListener("mousemove", p, !1), document.addEventListener("mouseup", m, !1);
    }, O = ($) => {
      $.preventDefault(), v.value.$el.blur(), w($), document.addEventListener("touchmove", w, {
        passive: !1
      }), document.addEventListener("touchend", E), document.addEventListener("touchcancel", E);
    };
    return Ae(() => {
      var $, T;
      i.value = t.value && Number.isInteger(t.value) ? t.value : t.max / 2, g(), ($ = c.value) == null || $.addEventListener("mousedown", Y), (T = c.value) == null || T.addEventListener("touchstart", O);
    }), Ie(() => {
      var $, T;
      ($ = c.value) == null || $.removeEventListener("mousedown", Y), (T = c.value) == null || T.removeEventListener("touchstart", O);
    }), ($, T) => (d(), h("div", Rl, [
      ae(st, {
        class: P(["field-slider__field-wrapper", {
          "has-value": i.value
        }])
      }, {
        label: se(() => [
          ue(k(r.label), 1)
        ]),
        default: se(() => [
          ae(bt, {
            ref_key: "input",
            ref: v,
            type: u.value,
            value: o.value,
            onBlur: T[0] || (T[0] = () => g()),
            onChange: T[1] || (T[1] = (j) => D(j)),
            onFocus: T[2] || (T[2] = () => _())
          }, null, 8, ["type", "value"])
        ]),
        _: 1
      }, 8, ["class"]),
      l("div", {
        ref_key: "slider",
        ref: c,
        class: "field-slider__line-wrapper"
      }, [
        l("div", Vl, [
          l("div", {
            class: P([{ pressed: r.isPressed }, "field-slider__line-position"]),
            style: pe({ width: f() + "%" })
          }, null, 6)
        ])
      ], 512),
      l("div", Nl, [
        l("div", null, k(a(
          H(rt)(r.min, H(nt).en),
          ",",
          r.valueSeparator
        )) + " " + k(r.prefix), 1),
        l("div", null, k(a(
          H(rt)(r.max, H(nt).en),
          ",",
          r.valueSeparator
        )) + " " + k(r.prefix), 1)
      ])
    ]));
  }
}), Ta = (r, e) => {
  r.preventDefault(), r.stopPropagation();
  const t = r.dataTransfer.files;
  t.length > 0 && e.value.chooseFile(t[0]), e.value.checkFileInFocus(!1);
}, xa = (r, e) => {
  r.preventDefault(), r.stopPropagation(), e.value.checkFileInFocus(!0);
}, Fa = (r, e) => {
  r.preventDefault(), r.stopPropagation(), e.value.checkFileInFocus(!1);
}, dn = {
  beforeMount: (r, e) => {
    r.addEventListener("drop", (t) => Ta(t, e)), r.addEventListener(
      "dragover",
      (t) => xa(t, e)
    ), r.addEventListener(
      "dragleave",
      (t) => Fa(t, e)
    );
  },
  beforeUnmounted: (r, e) => {
    r.removeEventListener("drop", (t) => Ta(t, e)), r.removeEventListener(
      "dragover",
      (t) => xa(t, e)
    ), r.removeEventListener(
      "dragleave",
      (t) => Fa(t, e)
    );
  }
}, Ul = "data:image/svg+xml,%3csvg%20width='22'%20height='22'%20viewBox='0%200%2022%2022'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M21%2010.376L11.5445%2019.2938C10.3861%2020.3862%208.81499%2021%207.1768%2021C5.53861%2021%203.96752%2020.3862%202.80914%2019.2938C1.65077%2018.2013%201%2016.7195%201%2015.1745C1%2013.6295%201.65077%2012.1477%202.80914%2011.0553L12.2647%202.1375C13.0369%201.40917%2014.0843%201%2015.1765%201C16.2686%201%2017.316%201.40917%2018.0882%202.1375C18.8605%202.86583%2019.2943%203.85365%2019.2943%204.88366C19.2943%205.91367%2018.8605%206.9015%2018.0882%207.62983L8.6224%2016.5476C8.23627%2016.9118%207.71257%2017.1163%207.16651%2017.1163C6.62045%2017.1163%206.09675%2016.9118%205.71063%2016.5476C5.3245%2016.1834%205.10758%2015.6895%205.10758%2015.1745C5.10758%2014.6595%205.3245%2014.1656%205.71063%2013.8014L14.4459%205.57263'%20stroke='%232F88F0'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", hn = (r) => (ne("data-v-be831362"), r = r(), re(), r), Wl = {
  key: 0,
  class: "attach__title"
}, ql = {
  key: 1,
  class: "attach__passport-wrapper"
}, Gl = /* @__PURE__ */ Ge('<div class="attach__passport-item" data-v-be831362><div class="attach__passport-icon attach__passport-icon--primary" data-v-be831362></div><div class="attach__passport-title" data-v-be831362> Паспорт (разворот с подписью и фотографией) </div></div><div class="attach__passport-item" data-v-be831362><div class="attach__passport-icon attach__passport-icon--secondary" data-v-be831362></div><div class="attach__passport-title" data-v-be831362> Паспорт (страница с последней регистрацией) </div></div>', 2), jl = [
  Gl
], Zl = {
  key: 2,
  class: "attach__doclist"
}, zl = {
  key: 3,
  class: "attach__upload-icon"
}, Ql = /* @__PURE__ */ hn(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "60",
  viewBox: "0 0 70 60",
  width: "70",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M56.9299 17.0405C56.1814 12.5554 53.979 8.46218 50.6107 5.356C46.8682 1.90145 42.0029 0 36.9361 0C33.0208 0 29.2063 1.13216 25.9387 3.26585C23.2182 5.03667 20.9583 7.43163 19.3605 10.2475C18.6695 10.1169 17.9498 10.0443 17.2301 10.0443C11.1125 10.0443 6.13202 15.0665 6.13202 21.2353C6.13202 22.0336 6.21838 22.8029 6.36233 23.5577C2.40387 26.4607 0 31.1345 0 36.1131C0 40.1337 1.48262 44.0382 4.18877 47.1299C6.96689 50.2941 10.6375 52.1665 14.5527 52.3843C14.5959 52.3843 14.6247 52.3843 14.6679 52.3843H27.0471C28.1267 52.3843 28.9903 51.5134 28.9903 50.4247C28.9903 49.3361 28.1267 48.4652 27.0471 48.4652H14.7255C8.83817 48.1024 3.88649 42.4561 3.88649 36.0985C3.88649 31.9908 6.07444 28.1589 9.60107 26.0833C10.4215 25.6043 10.767 24.6027 10.4503 23.7028C10.1625 22.919 10.0185 22.0917 10.0185 21.2063C10.0185 17.2001 13.2572 13.9343 17.2301 13.9343C18.0794 13.9343 18.9143 14.0794 19.6915 14.3697C20.6416 14.7181 21.6924 14.2827 22.1242 13.3682C24.816 7.6058 30.6313 3.88999 36.9504 3.88999C45.4431 3.88999 52.4532 10.3056 53.2593 18.8113C53.3457 19.6967 54.0078 20.4079 54.8715 20.5531C61.277 21.6562 66.1135 27.6218 66.1135 34.4293C66.1135 41.6432 60.4853 47.9137 53.5472 48.4507H42.9385C41.8589 48.4507 40.9953 49.3216 40.9953 50.4102C40.9953 51.4988 41.8589 52.3697 42.9385 52.3697H53.6192C53.6623 52.3697 53.7055 52.3697 53.7631 52.3697C58.1534 52.0504 62.2558 50.0183 65.3074 46.6218C68.3447 43.2544 70 38.9289 70 34.4293C69.9856 26.2865 64.4725 19.0435 56.9299 17.0405Z",
    fill: "#F0F0F0"
  }),
  /* @__PURE__ */ l("path", {
    d: "M46.6828 36.5255C47.4469 35.8634 47.4469 34.8014 46.6828 34.1393L36.3754 25.2068C36.015 24.8944 35.5104 24.707 35.0059 24.707C34.5013 24.707 33.9967 24.8819 33.6363 25.2068L23.3289 34.1393C22.5648 34.8014 22.5648 35.8634 23.3289 36.5255C23.7037 36.8503 24.2083 37.0252 24.6984 37.0252C25.1886 37.0252 25.6931 36.8628 26.0679 36.5255L33.0597 30.4663V58.3134C33.0597 59.2504 33.9247 60 35.0059 60C36.0871 60 36.952 59.2504 36.952 58.3134V30.4663L43.9438 36.5255C44.6934 37.1876 45.9188 37.1876 46.6828 36.5255Z",
    fill: "#F0F0F0"
  })
], -1)), Xl = [
  Ql
], Kl = {
  key: 4,
  class: "attach__info-txt"
}, Jl = {
  key: 0,
  class: "attach__btn-left"
}, ec = { class: "attach__file-message" }, tc = { key: 0 }, ac = { key: 1 }, nc = /* @__PURE__ */ hn(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M5 10.7609L11.0268 4.73413",
    stroke: "#27303E",
    "stroke-linecap": "round"
  }),
  /* @__PURE__ */ l("path", {
    d: "M11.0268 10.7609L5 4.73413",
    stroke: "#27303E",
    "stroke-linecap": "round"
  })
], -1)), rc = [
  nc
], sc = {
  name: "aeb-file-attach",
  directives: {
    aebDragAndDrop: dn
  }
}, ic = /* @__PURE__ */ A({
  ...sc,
  props: {
    title: {
      type: String,
      default: ""
    },
    layoutMod: {
      type: String,
      default: "salaryPortal"
    },
    documentList: {
      type: String,
      default: ""
    },
    maxFilesLength: {
      type: Number,
      default: 10
    },
    showPassportInput: {
      type: Boolean,
      default: !0
    },
    showDocumentList: {
      type: Boolean,
      default: !0
    },
    fileTypeMessage: {
      type: String,
      default: ""
    }
  },
  emits: ["changeListEvent", "maxFilesLengthError"],
  setup(r, { emit: e }) {
    const t = r, n = e, a = y(null), i = y([]), s = y(!1), o = () => {
      i.value = [], n("changeListEvent");
    }, u = (f) => {
      const _ = i.value.length, b = [2, 0, 1, 1, 1, 2];
      return f[_ % 100 > 4 && _ % 100 < 20 ? 2 : b[_ % 10 < 5 ? _ % 10 : 5]];
    }, c = (f) => {
      f && (i.value.length > t.maxFilesLength ? n("maxFilesLengthError") : (i.value = [...i.value, f], n("changeListEvent", i.value)));
    }, v = (f) => {
      s.value = f;
    }, g = () => {
      var f;
      (f = a.value) == null || f.click();
    };
    return (f, _) => {
      var D, p, m, w;
      const b = qt("aeb-drag-and-drop");
      return Ye((d(), h("div", {
        class: P([{
          "attach--file-in-focus": s.value,
          "attach--salary-portal": r.layoutMod === "salaryPortal",
          "attach--simple": r.layoutMod === "simple"
        }, "attach"])
      }, [
        r.layoutMod !== "simple" ? (d(), h("div", Wl, k(r.title), 1)) : F("", !0),
        r.showPassportInput && r.layoutMod !== "salaryPortal" && r.layoutMod !== "simple" ? (d(), h("div", ql, jl)) : F("", !0),
        r.showDocumentList && r.layoutMod !== "salaryPortal" && r.layoutMod !== "simple" ? (d(), h("div", Zl, k(r.documentList), 1)) : F("", !0),
        r.layoutMod === "salaryPortal" ? (d(), h("div", zl, Xl)) : F("", !0),
        r.layoutMod === "salaryPortal" ? (d(), h("div", Kl, " Перетащите файл сюда ")) : F("", !0),
        l("div", {
          class: P({
            "attach__button-wrapper--simple": r.layoutMod === "simple",
            "attach__button-wrapper": r.layoutMod !== "simple"
          })
        }, [
          r.layoutMod === "salaryPortal" ? (d(), h("div", Jl, " или ")) : F("", !0),
          ae(Ue, {
            iconSource: {
              left: H(Ul)
            },
            onClick: g
          }, {
            default: se(() => [
              ue(" Выберите файлы ")
            ]),
            _: 1
          }, 8, ["iconSource"]),
          l("input", {
            ref_key: "fileInputRef",
            ref: a,
            style: { display: "none" },
            type: "file",
            onChange: _[0] || (_[0] = (E) => c(E.target.files[0]))
          }, null, 544),
          l("div", ec, [
            ((D = i.value) == null ? void 0 : D.length) === 0 ? (d(), h("span", tc, k(r.fileTypeMessage), 1)) : F("", !0),
            ((p = i.value) == null ? void 0 : p.length) > 0 ? (d(), h("span", ac, k(((m = i.value) == null ? void 0 : m.length) === 1 ? "Выбран" : "Выбрано") + " " + k(i.value.length) + " " + k(u(["файл", "файла", "файлов"])), 1)) : F("", !0),
            ((w = i.value) == null ? void 0 : w.length) > 0 ? (d(), h("div", {
              key: 2,
              class: "attach__remove-icon",
              onClick: o
            }, rc)) : F("", !0)
          ])
        ], 2)
      ], 2)), [
        [b, { chooseFile: c, checkFileInFocus: v }]
      ]);
    };
  }
}), oc = /* @__PURE__ */ B(ic, [["__scopeId", "data-v-be831362"]]), uc = {
  name: "aeb-filter-tag"
}, lc = /* @__PURE__ */ A({
  ...uc,
  props: {
    active: { type: Boolean, default: !1 },
    value: {}
  },
  emits: ["clickHandler"],
  setup(r, { emit: e }) {
    const t = e;
    return (n, a) => (d(), h("div", {
      class: P([{
        "aeb-filter-tag--active": n.active
      }, "aeb-filter-tag"]),
      onClick: a[0] || (a[0] = (i) => t("clickHandler", n.value))
    }, [
      U(n.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), fn = /* @__PURE__ */ B(lc, [["__scopeId", "data-v-5d54d09e"]]), cc = { class: "aeb-filter-tags" }, dc = {
  name: "aeb-filter-tags"
}, hc = /* @__PURE__ */ A({
  ...dc,
  props: {
    tags: {},
    filterValue: { default: () => [] }
  },
  emits: ["onChange"],
  setup(r, { emit: e }) {
    const t = r, n = e, a = (i) => {
      n(
        "onChange",
        t.filterValue.includes(i) ? t.filterValue.filter((s) => s !== i) : [...t.filterValue, i]
      );
    };
    return (i, s) => (d(), h("div", cc, [
      (d(!0), h(R, null, X(i.tags, (o, u) => (d(), ct(fn, {
        key: u,
        active: i.filterValue.includes(o.value),
        value: o.value,
        onClickHandler: a
      }, {
        default: se(() => [
          ue(k(o.label), 1)
        ]),
        _: 2
      }, 1032, ["active", "value"]))), 128))
    ]));
  }
}), fc = /* @__PURE__ */ B(hc, [["__scopeId", "data-v-df1a7bc6"]]), vc = (r) => (ne("data-v-2fb7435d"), r = r(), re(), r), pc = {
  key: 0,
  class: "aeb-footer-top"
}, mc = { class: "aeb-footer-top__wrapper" }, gc = /* @__PURE__ */ Ge('<div class="aeb-footer-top__column" data-v-2fb7435d><div class="aeb-footer-top__row" data-v-2fb7435d><div class="aeb-footer-top__head" data-v-2fb7435d>Бесплатная горячая линия</div><a class="aeb-footer-top__cell" href="tel:78001003422" data-v-2fb7435d>8 800 100-34-22</a></div></div><div class="aeb-footer-top__column" data-v-2fb7435d><div class="aeb-footer-top__row" data-v-2fb7435d><div class="aeb-footer-top__head" data-v-2fb7435d>Телефон</div><a class="aeb-footer-top__cell" href="tel:84112342222" data-v-2fb7435d>8 (4112) 34-22-22</a></div></div><div class="aeb-footer-top__column" data-v-2fb7435d><div class="aeb-footer-top__row" data-v-2fb7435d><div class="aeb-footer-top__head" data-v-2fb7435d>Электронная почта</div><a class="aeb-footer-top__cell" href="mailto:bank@albank.ru" data-v-2fb7435d>bank@albank.ru</a></div></div>', 3), _c = {
  key: 0,
  class: "aeb-footer-top__column"
}, bc = /* @__PURE__ */ vc(() => /* @__PURE__ */ l("div", { class: "aeb-footer-top__row" }, [
  /* @__PURE__ */ l("div", { class: "aeb-footer-top__head" }, "Наш адрес"),
  /* @__PURE__ */ l("div", { class: "aeb-footer-top__cell" }, " г. Якутск, ул. Ленина, 1 ")
], -1)), wc = [
  bc
], kc = /* @__PURE__ */ Ge('<div class="aeb-footer-top__app" data-v-2fb7435d><a class="aeb-footer-top__mobile-icon" data-v-2fb7435d><svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg" data-v-2fb7435d><rect fill="#2F88F0" height="48" rx="8" width="48" data-v-2fb7435d></rect><path clip-rule="evenodd" d="M26.5406 25.319L25.3223 26.5376L26.1321 28.4946L28.4972 26.129L26.5406 25.319ZM24.8708 26.724H23.1436L22.3337 28.681H25.6735L24.8708 26.724ZM26.7342 23.1398V24.8602L28.6835 25.6702V22.3297L26.7342 23.1398ZM22.6849 26.5376L21.4665 25.319L19.5171 26.129L21.8822 28.4946L22.6849 26.5376ZM26.1321 19.5054L25.3223 21.4624L26.5406 22.681L28.4972 21.871L26.1321 19.5054ZM23.1436 21.2688H24.8708L25.6735 19.319H22.3337L23.1436 21.2688ZM21.2802 24.8602V23.1398L19.3308 22.3297V25.6702L21.2802 24.8602ZM21.4665 22.681L22.6849 21.4624L21.8822 19.5054L19.5171 21.871L21.4665 22.681ZM22.7566 18.0358H34.5675C34.976 18.0358 35.3845 18.1935 35.6999 18.509C36.0152 18.8244 36.1729 19.233 36.1729 19.6416C36.1729 20.0502 36.0152 20.466 35.6999 20.7814L38.409 23.491C39.4697 22.4301 40 21.0323 40 19.6416C40 18.2509 39.4697 16.8602 38.409 15.7993C37.3483 14.7384 35.9579 14.2079 34.5675 14.2079H26.5837L22.7566 18.0358ZM27.3362 18.8961L35.6856 27.2545C35.9794 27.5412 36.1586 27.9427 36.1586 28.3871C36.1586 28.8315 35.9794 29.233 35.6856 29.5269C35.3989 29.8136 34.9975 29.9928 34.5532 29.9928V33.828C36.0511 33.828 37.4128 33.2186 38.3946 32.2366C39.3836 31.2473 39.9857 29.8925 39.9857 28.3871C39.9857 26.8889 39.3765 25.5269 38.3946 24.5376L32.7543 18.8961H27.3362ZM29.9664 22.7455V34.5591C29.9664 34.9677 29.8087 35.3835 29.4934 35.6989C29.1781 36.0072 28.7695 36.1649 28.361 36.1649C27.9525 36.1649 27.5368 36.0072 27.2287 35.6989L24.5124 38.4086C25.5803 39.4695 26.9707 40 28.361 40C29.7514 40 31.1418 39.4695 32.2096 38.4086C33.2703 37.3477 33.8007 35.9498 33.8007 34.5591L33.7935 26.5806L29.9664 22.7455ZM29.1064 27.3262L20.757 35.6846C20.4632 35.9713 20.0618 36.1505 19.6175 36.1505C19.1731 36.1505 18.7789 35.9713 18.4851 35.6846C18.1913 35.3907 18.0121 34.9892 18.0121 34.5448H14.1778C14.1778 36.0502 14.787 37.405 15.776 38.3943C16.7579 39.3763 18.1196 39.9857 19.6175 39.9857C21.1225 39.9857 22.477 39.3763 23.4661 38.3943L29.1064 32.7455V27.3262ZM25.2578 29.957H13.4468C13.0383 29.957 12.6226 29.7993 12.3144 29.491C11.9991 29.1756 11.8414 28.767 11.8414 28.3513C11.8414 27.9427 11.9991 27.534 12.3144 27.2186L9.60538 24.509C8.53751 25.5699 8.00717 26.9606 8.00717 28.3513C8.00717 29.7419 8.53751 31.1398 9.60538 32.2007C10.6661 33.2616 12.0564 33.7921 13.4468 33.7921H21.4307L25.2578 29.957ZM20.6567 29.0466L12.3073 20.6953C12.0134 20.4014 11.8343 20 11.8343 19.5556C11.8343 19.1111 12.0134 18.7097 12.3073 18.4229C12.594 18.129 12.9953 17.9498 13.4396 17.9498V14.1219C11.9418 14.1219 10.5801 14.7312 9.59821 15.7133C8.60918 16.6953 8 18.0573 8 19.5556C8 21.0609 8.60918 22.4158 9.59821 23.405L15.2385 29.0466H20.6567ZM18.0479 25.2473V13.4337C18.0479 13.0251 18.2056 12.6165 18.5209 12.3011C18.8291 11.9857 19.2448 11.8351 19.6533 11.828C20.0618 11.828 20.4703 11.9857 20.7857 12.3011L23.5019 9.5914C22.434 8.53047 21.0437 8 19.6533 8C18.2629 8 16.8726 8.53047 15.8047 9.5914C14.744 10.6523 14.2137 12.043 14.2137 13.4409V21.4194L18.0479 25.2473ZM18.908 20.6667L27.2573 12.3154C27.5512 12.0215 27.9525 11.8495 28.3969 11.8495C28.8412 11.8495 29.2354 12.0287 29.5292 12.3154C29.8231 12.6093 30.0022 13.0036 30.0022 13.4552H33.8365C33.8365 11.9498 33.2202 10.5878 32.2383 9.60573C31.2564 8.62366 29.8947 8.01434 28.3969 8.01434C26.8918 8.01434 25.5301 8.62366 24.5483 9.60573L18.908 15.2473V20.6667ZM24.9639 26.3082L26.3113 24.9534V23.0394L24.9639 21.6918H23.0504L21.6959 23.0394V24.9534L23.0504 26.3082H24.9639ZM21.8965 29.0968L18.908 26.1147V21.8853L21.8965 18.8961H26.1178L29.1064 21.8853V26.1147L26.1178 29.0968H21.8965Z" fill="white" fill-rule="evenodd" data-v-2fb7435d></path></svg></a><div class="aeb-footer-top__row" data-v-2fb7435d><div class="aeb-footer-top__head" data-v-2fb7435d> Приложение для iOS и Android </div><div class="aeb-footer-top__cell" data-v-2fb7435d>АЭБ Онлайн 3.0</div></div></div>', 1), yc = {
  name: "aeb-footer-top"
}, Cc = /* @__PURE__ */ A({
  ...yc,
  props: {
    onlyPhone: { type: Boolean, default: !1 }
  },
  setup(r) {
    return (e, t) => (d(), h(R, null, [
      U(e.$slots, "default", {}, void 0, !0),
      e.$slots.default ? F("", !0) : (d(), h("div", pc, [
        l("div", mc, [
          gc,
          e.onlyPhone ? F("", !0) : (d(), h("div", _c, wc)),
          kc
        ])
      ]))
    ], 64));
  }
}), vn = /* @__PURE__ */ B(Cc, [["__scopeId", "data-v-2fb7435d"]]), Dc = [
  {
    name: "Информация о максимальных процентных ставках по вкладам физических лиц",
    link: "https://www.albank.ru/ru/interest-rates/"
  },
  {
    name: "Раскрытие информации профессиональным участником рынка ценных бумаг",
    link: "https://www.albank.ru/ru/disclosure/"
  },
  {
    name: "Раскрытие информации на сайте информационного агенства АО «СКРИН»",
    link: "https://disclosure.skrin.ru/disclosure/1435138944"
  },
  {
    name: "Информация о лицах, под контролем либо значительным влиянием которых находится банк",
    link: "https://www.albank.ru/local/templates/Aeb/assets/docs/RB2602_20201116.pdf"
  }
], $c = [
  {
    name: "Офисы",
    link: "https://www.albank.ru/ru/offices/"
  },
  {
    name: "Курсы валют",
    link: "https://www.albank.ru/ru/more/info/exchange/"
  },
  {
    name: "Новости",
    link: "https://www.albank.ru/ru/more/info/news/"
  },
  {
    name: "Программа лояльности «Свои»",
    link: "https://svoi.albank.ru/rus"
  },
  {
    name: "Продажа имущества",
    link: "https://www.albank.ru/ru/more/sale/"
  },
  {
    name: "Связь с Банком",
    link: "https://www.albank.ru/ru/feedback/"
  }
], Ec = {
  key: 0,
  class: "aeb-footer-menu"
}, Mc = { class: "aeb-footer-menu__wrapper" }, Tc = ["href"], xc = {
  name: "aeb-footer-menu"
}, Fc = /* @__PURE__ */ A({
  ...xc,
  props: {
    items: { default: () => $c }
  },
  setup(r) {
    return (e, t) => (d(), h(R, null, [
      U(e.$slots, "default", {}, void 0, !0),
      e.$slots.default ? F("", !0) : (d(), h("div", Ec, [
        l("div", Mc, [
          (d(!0), h(R, null, X(e.items, (n, a) => (d(), h("a", {
            key: a,
            href: n.link,
            class: "aeb-footer-menu__item"
          }, k(" " + n.name + " "), 9, Tc))), 128))
        ])
      ]))
    ], 64));
  }
}), pn = /* @__PURE__ */ B(Fc, [["__scopeId", "data-v-7724d2d7"]]), Pc = {
  key: 0,
  class: "aeb-footer-bottom"
}, Ac = /* @__PURE__ */ Ge('<div class="aeb-footer-bottom__rights" data-v-cf86661c> © 2024 АКБ «Алмазэргиэнбанк» АО. Генеральная лицензия ЦБ РФ №2602 от 08.06.2015 </div><div class="aeb-footer-bottom__soc-networks" data-v-cf86661c><a class="aeb-footer-bottom__soc-icon" href="https://t.me/albankykt" data-v-cf86661c><svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-cf86661c><path fill-rule="evenodd" clip-rule="evenodd" d="M17 1C25.8303 1 33 8.16968 33 17C33 25.8303 25.8303 33 17 33C8.16969 33 1 25.8303 1 17C1 8.16968 8.16969 1 17 1Z" stroke="white" stroke-width="2" data-v-cf86661c></path><path fill-rule="evenodd" clip-rule="evenodd" d="M21.7075 24.8233C21.9651 25.0057 22.2971 25.0513 22.5931 24.9393C22.8891 24.8265 23.1067 24.5737 23.1723 24.2673C23.8675 21.0001 25.5539 12.7305 26.1867 9.75852C26.2347 9.53452 26.1547 9.30172 25.9787 9.15212C25.8027 9.00252 25.5587 8.95932 25.3411 9.04012C21.9867 10.2817 11.6563 14.1577 7.43392 15.7201C7.16592 15.8193 6.99152 16.0769 7.00032 16.3593C7.00992 16.6425 7.20032 16.8881 7.47472 16.9705C9.36832 17.5369 11.8539 18.3249 11.8539 18.3249C11.8539 18.3249 13.0155 21.8329 13.6211 23.6169C13.6971 23.8409 13.8723 24.0169 14.1035 24.0777C14.3339 24.1377 14.5803 24.0745 14.7523 23.9121C15.7251 22.9937 17.2291 21.5737 17.2291 21.5737C17.2291 21.5737 20.0867 23.6689 21.7075 24.8233V24.8233ZM12.8995 17.8817L14.2427 22.3121L14.5411 19.5065C14.5411 19.5065 19.7307 14.8257 22.6891 12.1577C22.7755 12.0793 22.7875 11.9481 22.7155 11.8561C22.6443 11.7641 22.5131 11.7425 22.4147 11.8049C18.9859 13.9945 12.8995 17.8817 12.8995 17.8817Z" fill="white" data-v-cf86661c></path></svg></a><a class="aeb-footer-bottom__soc-icon" href="https://vk.com/albankykt" data-v-cf86661c><svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-cf86661c><path fill-rule="evenodd" clip-rule="evenodd" d="M17.6878 23.481C18.3615 23.481 18.3615 22.5126 18.3615 22.1362C18.3615 21.4634 19.0327 20.7922 19.7064 20.7922C20.38 20.7922 21.5329 21.9442 22.3969 22.8082C23.0706 23.4819 23.0706 23.4819 23.7426 23.4819H25.7611C25.7611 23.4819 27.1068 23.4288 27.1068 22.1354C27.1068 21.716 26.6453 21.0036 25.0883 19.4465C23.7426 18.1025 23.052 18.7964 25.0883 16.0848C26.3278 14.4343 27.2306 12.9379 27.0765 12.5059C26.9274 12.0932 23.479 11.4381 23.0706 12.0511C21.7249 14.0671 21.4773 14.5623 21.052 15.412C20.38 16.7568 20.3127 17.4297 19.7064 17.4297C19.095 17.4297 19.0327 16.1244 19.0327 15.412C19.0327 13.1905 19.356 11.6183 18.3607 11.3783H16.3422C15.2592 11.3783 14.3245 12.052 14.3245 12.052C14.3245 12.052 13.4891 12.7021 13.6508 12.7231C13.852 12.7509 14.9965 12.4452 14.9965 13.396V14.7408C14.9965 14.7408 15.0032 17.4297 14.3245 17.4297C13.6508 17.4297 12.3059 14.7408 10.9603 12.7223C10.4323 11.9316 10.2866 12.0511 9.61542 12.0511C8.89458 12.0511 8.26974 12.0789 7.59605 12.0789C6.92405 12.0789 6.83731 12.5067 6.92405 12.7231C8.26974 16.0848 9.23563 18.196 11.7914 20.8562C14.1375 23.2958 15.703 23.4246 17.0158 23.4802C17.3518 23.4945 17.0158 23.4802 17.6878 23.4802V23.481Z" fill="white" data-v-cf86661c></path><path fill-rule="evenodd" clip-rule="evenodd" d="M17 1C25.8303 1 33 8.16968 33 17C33 25.8303 25.8303 33 17 33C8.16968 33 1 25.8303 1 17C1 8.16968 8.16968 1 17 1Z" stroke="white" stroke-width="2" data-v-cf86661c></path></svg></a></div>', 2), Sc = ["href"], Lc = {
  name: "aeb-footer-bottom"
}, Oc = /* @__PURE__ */ A({
  ...Lc,
  props: {
    links: { default: () => Dc }
  },
  setup(r) {
    return (e, t) => (d(), h(R, null, [
      U(e.$slots, "default", {}, void 0, !0),
      e.$slots.default ? F("", !0) : (d(), h("div", Pc, [
        Ac,
        (d(!0), h(R, null, X(e.links, (n, a) => (d(), h("a", {
          key: a,
          href: n.link,
          class: "aeb-footer-bottom__link"
        }, k(n.name), 9, Sc))), 128))
      ]))
    ], 64));
  }
}), mn = /* @__PURE__ */ B(Oc, [["__scopeId", "data-v-cf86661c"]]), Bc = {
  key: 0,
  class: "aeb-footer"
}, Ic = { class: "aeb-footer__content" }, Rc = {
  key: 1,
  class: "aeb-footer"
}, Vc = { class: "aeb-footer__content" }, Nc = {
  name: "aeb-footer"
}, Hc = /* @__PURE__ */ A({
  ...Nc,
  setup(r) {
    return (e, t) => e.$slots.default ? (d(), h("footer", Bc, [
      l("div", Ic, [
        U(e.$slots, "default", {}, void 0, !0)
      ])
    ])) : (d(), h("footer", Rc, [
      l("div", Vc, [
        ae(vn),
        ae(pn),
        ae(mn)
      ])
    ]));
  }
}), Yc = /* @__PURE__ */ B(Hc, [["__scopeId", "data-v-114145f8"]]), Uc = {
  name: "aeb-header"
}, Wc = /* @__PURE__ */ A({
  ...Uc,
  props: {
    white: { type: Boolean, default: !1 }
  },
  setup(r) {
    return (e, t) => (d(), h("header", {
      class: P([{ white: e.white }, "aeb-header"])
    }, [
      U(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), qc = /* @__PURE__ */ B(Wc, [["__scopeId", "data-v-a361ec2e"]]), Gc = {
  name: "aeb-logo"
}, jc = (r) => (ne("data-v-9183cf1e"), r = r(), re(), r), Zc = { class: "aeb-header-logo" }, zc = /* @__PURE__ */ jc(() => /* @__PURE__ */ l("div", { class: "aeb-header-logo-icon" }, [
  /* @__PURE__ */ l("svg", {
    fill: "none",
    height: "26",
    viewBox: "0 0 26 26",
    width: "26",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ l("path", {
      "clip-rule": "evenodd",
      d: "M0 0H6V6H0V0ZM0 10H6V16H0V10ZM6 20H0V26H6V20ZM10 0H16V6H10V0ZM16 10H10V16H16V10ZM10 20H16V26H10V20ZM26 0H20V6H26V0ZM20 10H26V16H20V10ZM26 20H20V26H26V20Z",
      fill: "#2F88F0",
      "fill-rule": "evenodd"
    })
  ])
], -1)), Qc = { class: "aeb-header-logo-text" };
function Xc(r, e, t, n, a, i) {
  return d(), h("div", Zc, [
    zc,
    l("div", Qc, [
      U(r.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const Kc = /* @__PURE__ */ B(Gc, [["render", Xc], ["__scopeId", "data-v-9183cf1e"]]), Jc = { class: "aeb-heading" }, ed = {
  name: "aeb-heading"
}, td = /* @__PURE__ */ A({
  ...ed,
  props: {
    text: {}
  },
  setup(r) {
    return (e, t) => (d(), h("h1", Jc, k(e.text), 1));
  }
}), ad = /* @__PURE__ */ B(td, [["__scopeId", "data-v-58b07112"]]), nd = (r) => (ne("data-v-6ca3cc97"), r = r(), re(), r), rd = { class: "aeb-breadcrumbs" }, sd = ["onClick"], id = {
  key: 0,
  class: "aeb-breadcrumbs__icon"
}, od = /* @__PURE__ */ nd(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "6",
  viewBox: "0 0 3 6",
  width: "3",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M3 3L-6.28109e-09 5.59808L2.2085e-07 0.401924L3 3Z",
    fill: "#A3AAAE"
  })
], -1)), ud = [
  od
], ld = {
  name: "aeb-breadcrumbs"
}, cd = /* @__PURE__ */ A({
  ...ld,
  props: {
    routeSequence: { default: () => [] }
  },
  emits: ["optionClick"],
  setup(r, { emit: e }) {
    const t = e;
    return (n, a) => (d(), h("div", rd, [
      (d(!0), h(R, null, X(n.routeSequence, (i, s) => (d(), h("div", {
        key: s,
        class: "aeb-breadcrumbs__item",
        onClick: (o) => t("optionClick", s)
      }, [
        ue(k(" " + i + " ") + " ", 1),
        s !== n.routeSequence.length - 1 ? (d(), h("span", id, ud)) : F("", !0)
      ], 8, sd))), 128))
    ]));
  }
}), dd = /* @__PURE__ */ B(cd, [["__scopeId", "data-v-6ca3cc97"]]), hd = (r) => (ne("data-v-f7ed73d8"), r = r(), re(), r), fd = { class: "aeb-product-title" }, vd = { class: "aeb-product-title__title" }, pd = /* @__PURE__ */ hd(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "42",
  viewBox: "0 0 42 42",
  width: "42",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("rect", {
    fill: "white",
    height: "42",
    rx: "10",
    width: "42"
  }),
  /* @__PURE__ */ l("line", {
    stroke: "#2F88F0",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    x1: "13",
    x2: "29",
    y1: "21",
    y2: "21"
  }),
  /* @__PURE__ */ l("path", {
    d: "M18 14L12 21L18 28",
    stroke: "#2F88F0",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })
], -1)), md = [
  pd
], gd = { class: "aeb-product-title__heading" }, _d = {
  name: "aeb-product-title"
}, bd = /* @__PURE__ */ A({
  ..._d,
  props: {
    title: {}
  },
  emits: ["backHandler"],
  setup(r, { emit: e }) {
    const t = e;
    return (n, a) => (d(), h("div", fd, [
      l("div", vd, [
        l("div", {
          class: "aeb-product-title__back",
          onClick: a[0] || (a[0] = (i) => t("backHandler"))
        }, md),
        l("div", gd, k(n.title), 1)
      ]),
      U(n.$slots, "default", {}, void 0, !0)
    ]));
  }
}), wd = /* @__PURE__ */ B(bd, [["__scopeId", "data-v-f7ed73d8"]]), kd = {
  name: "aeb-label"
}, yd = (r) => (ne("data-v-2d66d6c5"), r = r(), re(), r), Cd = { class: "aeb-label" }, Dd = { class: "aeb-label-text" }, $d = /* @__PURE__ */ yd(() => /* @__PURE__ */ l("div", { class: "aeb-label-icon-close" }, [
  /* @__PURE__ */ l("svg", {
    fill: "none",
    height: "14",
    viewBox: "0 0 14 14",
    width: "14",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ l("path", {
      "clip-rule": "evenodd",
      d: "M14 1.4L12.6 0L7 5.6L1.4 0L0 1.4L5.6 7L0 12.6L1.4 14L7 8.4L12.6 14L14 12.6L8.4 7L14 1.4Z",
      fill: "#2F88F0",
      "fill-rule": "evenodd"
    })
  ])
], -1));
function Ed(r, e, t, n, a, i) {
  return d(), h("div", Cd, [
    l("div", Dd, [
      U(r.$slots, "default", {}, void 0, !0)
    ]),
    $d
  ]);
}
const Md = /* @__PURE__ */ B(kd, [["render", Ed], ["__scopeId", "data-v-2d66d6c5"]]), Td = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20%3e%3cpath%20d='M7.50757%207.50769L24.4922%2024.4923'%20stroke='%2327303E'%20stroke-width='2'%20stroke-linecap='round'%20/%3e%3cpath%20d='M24.4922%207.50769L7.50753%2024.4923'%20stroke='%2327303E'%20stroke-width='2'%20stroke-linecap='round'%20/%3e%3c/svg%3e", xd = (r) => (ne("data-v-1c2683c7"), r = r(), re(), r), Fd = {
  key: 0,
  class: "aeb-modal"
}, Pd = /* @__PURE__ */ xd(() => /* @__PURE__ */ l("img", {
  class: "aeb-modal__close-btn-icon",
  src: Td,
  alt: "close"
}, null, -1)), Ad = [
  Pd
], Sd = {
  key: 1,
  class: "aeb-modal__btn-group"
}, Ld = {
  name: "aeb-modal",
  components: { AebButton: Ue }
}, Ct = {
  leftBtn: {
    variant: "secondary",
    text: "Отмена",
    warning: !1,
    disabled: !1,
    hidden: !1
  },
  rightBtn: {
    variant: "primary",
    text: "Сохранить",
    warning: !1,
    disabled: !1,
    hidden: !1
  },
  closeBtn: {
    hidden: !1
  }
}, Od = /* @__PURE__ */ A({
  ...Ld,
  props: {
    isOpen: { type: Boolean },
    size: { default: "S" },
    controlsConfig: { default: () => Ct }
  },
  emits: ["leftBtnClick", "rightBtnClick", "closeBtnClick"],
  setup(r, { emit: e }) {
    const n = y(r.controlsConfig);
    Ae(() => {
      for (let u in Ct)
        for (let c in Ct[u])
          n.value[u][c] = n.value[u][c] ?? Ct[u][c];
    });
    const a = e, i = () => {
      a("leftBtnClick");
    }, s = () => {
      a("rightBtnClick");
    }, o = () => {
      a("closeBtnClick");
    };
    return (u, c) => {
      var v, g;
      return u.isOpen ? (d(), h("div", Fd, [
        l("div", {
          class: P(["aeb-modal__window", ["aeb-modal__window--" + u.size]])
        }, [
          (g = (v = u.controlsConfig) == null ? void 0 : v.closeBtn) != null && g.hidden ? F("", !0) : (d(), h("button", {
            key: 0,
            class: "aeb-modal__close-btn",
            onClick: c[0] || (c[0] = (f) => o())
          }, Ad)),
          U(u.$slots, "default", {}, void 0, !0),
          !n.value.leftBtn.hidden && !n.value.rightBtn.hidden ? (d(), h("span", Sd, [
            ae(Ue, Wt({ fill: !0 }, n.value.leftBtn, {
              onClick: c[1] || (c[1] = (f) => i())
            }), {
              default: se(() => [
                ue(k(n.value.leftBtn.text), 1)
              ]),
              _: 1
            }, 16),
            ae(Ue, Wt({ fill: !0 }, n.value.rightBtn, {
              onClick: c[2] || (c[2] = (f) => s())
            }), {
              default: se(() => [
                ue(k(n.value.rightBtn.text), 1)
              ]),
              _: 1
            }, 16)
          ])) : F("", !0)
        ], 2)
      ])) : F("", !0);
    };
  }
}), Bd = /* @__PURE__ */ B(Od, [["__scopeId", "data-v-1c2683c7"]]), Id = { class: "aeb-news-card" }, Rd = { class: "aeb-news-card__date" }, Vd = { class: "aeb-news-card__content" }, Nd = {
  name: "aeb-news-card"
}, Hd = /* @__PURE__ */ A({
  ...Nd,
  props: {
    date: {}
  },
  setup(r) {
    return (e, t) => (d(), h("div", Id, [
      l("div", Rd, k(e.date), 1),
      l("div", Vd, [
        U(e.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}), Yd = /* @__PURE__ */ B(Hd, [["__scopeId", "data-v-574121ac"]]), Ud = (r) => (ne("data-v-0224f4e2"), r = r(), re(), r), Wd = {
  key: 0,
  class: "aeb-new-notifications"
}, qd = { class: "aeb-new-notifications__icon" }, Gd = ["src"], jd = { class: "aeb-new-notifications__info" }, Zd = { class: "aeb-new-notifications__header" }, zd = { class: "aeb-new-notifications__msg" }, Qd = ["onClick"], Xd = /* @__PURE__ */ Ud(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M5.63086 5.63074L18.3693 18.3692",
    stroke: "white",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }),
  /* @__PURE__ */ l("path", {
    d: "M18.3691 5.63074L5.63065 18.3692",
    stroke: "white",
    "stroke-linecap": "round",
    "stroke-width": "2"
  })
], -1)), Kd = [
  Xd
], Jd = {
  name: "aeb-notifications"
}, eh = /* @__PURE__ */ A({
  ...Jd,
  props: {
    notifications: { default: () => [] }
  },
  emits: ["handleClose"],
  setup(r, { emit: e }) {
    const t = e, n = (a) => {
      t("handleClose", a);
    };
    return (a, i) => a.notifications.length ? (d(), h("div", Wd, [
      (d(!0), h(R, null, X(a.notifications, (s, o) => (d(), h("div", {
        key: o,
        class: "aeb-new-notifications__item"
      }, [
        l("div", qd, [
          l("img", {
            src: s.iconPath,
            alt: "picture"
          }, null, 8, Gd)
        ]),
        l("div", jd, [
          l("div", Zd, k(s.header), 1),
          l("div", zd, k(s.message), 1)
        ]),
        l("div", {
          class: "aeb-new-notifications__close",
          onClick: (u) => n(s.id)
        }, Kd, 8, Qd)
      ]))), 128))
    ])) : F("", !0);
  }
}), th = /* @__PURE__ */ B(eh, [["__scopeId", "data-v-0224f4e2"]]), oa = (r) => (ne("data-v-96d41c08"), r = r(), re(), r), ah = { class: "aeb-dropdown aeb-dropdown-inner" }, nh = { key: 0 }, rh = {
  key: 0,
  fill: "none",
  height: "20",
  viewBox: "0 0 24 24",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, sh = /* @__PURE__ */ oa(() => /* @__PURE__ */ l("rect", {
  height: "16",
  rx: "3",
  stroke: "#A3AAAE",
  "stroke-width": "2",
  width: "18",
  x: "3",
  y: "7"
}, null, -1)), ih = /* @__PURE__ */ oa(() => /* @__PURE__ */ l("path", {
  d: "M8.24682 7C8.08719 6.59903 8 6.16547 8 5.713C8 3.66237 9.79086 2 12 2C14.2091 2 16 3.66237 16 5.713C16 6.16547 15.9128 6.59903 15.7532 7",
  stroke: "#A3AAAE",
  "stroke-width": "2"
}, null, -1)), oh = [
  sh,
  ih
], uh = {
  key: 1,
  fill: "none",
  height: "20",
  viewBox: "0 0 20 20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, lh = /* @__PURE__ */ oa(() => /* @__PURE__ */ l("path", {
  d: "M6.05037 9.36385C5.4204 8.73388 5.86657 7.65674 6.75748 7.65674H13.2428C14.1337 7.65674 14.5798 8.73388 13.9499 9.36385L10.7072 12.6065C10.3167 12.997 9.68353 12.997 9.29301 12.6065L6.05037 9.36385Z",
  fill: "#9CA8AF"
}, null, -1)), ch = [
  lh
], dh = ["onClick"], hh = {
  name: "aeb-select"
}, fh = /* @__PURE__ */ A({
  ...hh,
  props: {
    hasError: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    value: {},
    direction: { default: "bottom" }
  },
  emits: ["change"],
  setup(r, { emit: e }) {
    var b, D;
    const t = r, n = e, a = Ot(), i = y(!1), s = (b = a.default) == null ? void 0 : b.call(a), o = ((D = s[0].type) == null ? void 0 : D.name) === "aeb-option" ? s : s[0].children, u = Me(
      () => (o == null ? void 0 : o.map((p) => {
        var m, w, E;
        return {
          value: (m = p.props) == null ? void 0 : m.value,
          label: (E = (w = p.children) == null ? void 0 : w.default) == null ? void 0 : E.call(w)[0].children
        };
      })) || []
    ), c = y(null);
    mt(
      () => c.value = u.value.find(
        (p) => p.value === t.value
      ) || null
    );
    const v = () => {
      i.value = !1;
    }, g = () => {
      i.value && v();
    }, f = () => {
      t.disabled || (i.value ? v() : i.value = !0);
    }, _ = (p) => {
      t.value || (c.value = p), n("change", p.value), v();
    };
    return (p, m) => Ye((d(), h("div", ah, [
      l("div", {
        class: P([{
          error: p.hasError,
          placeholder: !c.value,
          open: i.value && c.value
        }, "aeb-dropdown-float-label"]),
        onClick: f
      }, [
        U(p.$slots, "label", {}, void 0, !0)
      ], 2),
      l("div", {
        class: P([{ open: i.value, error: p.hasError, top: p.direction === "top" }, "aeb-dropdown-selected-item"]),
        onClick: f
      }, [
        c.value ? (d(), h("div", nh, k(c.value ? c.value.label : ""), 1)) : F("", !0)
      ], 2),
      l("div", {
        class: P([{ active: i.value }, "aeb-dropdown-icon"])
      }, [
        p.disabled ? (d(), h("svg", rh, oh)) : (d(), h("svg", uh, ch))
      ], 2),
      l("div", {
        class: P([{
          open: i.value,
          error: p.hasError,
          top: p.direction === "top",
          bottom: p.direction === "bottom"
        }, "aeb-dropdown-menu"])
      }, [
        l("ul", null, [
          (d(!0), h(R, null, X(u.value, (w) => (d(), h("li", {
            key: w,
            class: "aeb-dropdown-item",
            onClick: (E) => _(w)
          }, k(w.label), 9, dh))), 128))
        ])
      ], 2)
    ])), [
      [H(dt), g]
    ]);
  }
}), ua = /* @__PURE__ */ B(fh, [["__scopeId", "data-v-96d41c08"]]), vh = A({
  name: "aeb-option"
});
function ph(r, e, t, n, a, i) {
  return d(), h("div", null, [
    U(r.$slots, "default")
  ]);
}
const la = /* @__PURE__ */ B(vh, [["render", ph]]), Vt = (r) => (ne("data-v-59415359"), r = r(), re(), r), mh = { class: "aeb-pagination" }, gh = /* @__PURE__ */ Vt(() => /* @__PURE__ */ l("div", { class: "aeb-pagination__arrow-icon aeb-pagination__arrow-icon--left" }, [
  /* @__PURE__ */ l("svg", {
    fill: "none",
    height: "10",
    viewBox: "0 0 6 10",
    width: "6",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ l("path", {
      d: "M1 9L4.92929 5.07071C4.96834 5.03166 4.96834 4.96834 4.92929 4.92929L1 1",
      stroke: "#2F88F0",
      "stroke-linecap": "round",
      "stroke-width": "2"
    })
  ])
], -1)), _h = /* @__PURE__ */ Vt(() => /* @__PURE__ */ l("span", { class: "aeb-pagination__button-label" }, "Назад", -1)), bh = [
  gh,
  _h
], wh = { class: "aeb-pagination__block" }, kh = {
  key: 1,
  class: "aeb-pagination__breaker"
}, yh = ["onClick"], Ch = {
  key: 2,
  class: "aeb-pagination__breaker"
}, Dh = { class: "aeb-pagination__block" }, $h = { class: "aeb-pagination__block" }, Eh = /* @__PURE__ */ Vt(() => /* @__PURE__ */ l("span", { class: "aeb-pagination__button-label" }, "Далее", -1)), Mh = /* @__PURE__ */ Vt(() => /* @__PURE__ */ l("div", { class: "aeb-pagination__arrow-icon aeb-pagination__arrow-icon--right" }, [
  /* @__PURE__ */ l("svg", {
    fill: "none",
    height: "10",
    viewBox: "0 0 6 10",
    width: "6",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ l("path", {
      d: "M1 9L4.92929 5.07071C4.96834 5.03166 4.96834 4.96834 4.92929 4.92929L1 1",
      stroke: "#2F88F0",
      "stroke-linecap": "round",
      "stroke-width": "2"
    })
  ])
], -1)), Th = [
  Eh,
  Mh
], xh = {
  key: 0,
  class: "aeb-pagination__amount"
}, Fh = {
  name: "aeb-pagination"
}, Ph = /* @__PURE__ */ A({
  ...Fh,
  props: {
    totalPages: { default: 200 },
    page: { default: 1 },
    amount: { default: 0 },
    amountOptions: { default: () => [
      {
        value: 10,
        label: "По 10 на стр."
      },
      {
        value: 20,
        label: "По 20 на стр."
      },
      {
        value: 30,
        label: "По 30 на стр."
      }
    ] }
  },
  emits: ["pageSelect", "amountChange"],
  setup(r, { emit: e }) {
    const t = r, n = e, a = y(7), i = y(null), s = y([]), o = y(null), u = y(t.page), c = (p) => {
      u.value = p, b(1), n("pageSelect", p);
    }, v = (p) => {
      u.value = p, b(p), n("pageSelect", p);
    }, g = (p) => {
      u.value = p, b(p), n("pageSelect", p);
    }, f = () => {
      if (u.value === 1)
        return;
      const p = u.value - 1;
      b(p), u.value = p, n("pageSelect", p);
    }, _ = () => {
      if (u.value === t.totalPages)
        return;
      const p = u.value + 1;
      u.value = p, b(p), n("pageSelect", p);
    }, b = (p) => {
      if (i.value = null, s.value = [], o.value = null, t.totalPages <= a.value)
        for (let m = 1; m <= t.totalPages; m++)
          s.value.push(m);
      else if (p <= 4) {
        for (let m = 1; m <= 5; m++)
          s.value.push(m);
        o.value = t.totalPages;
      } else if (p >= t.totalPages - 3) {
        i.value = 1;
        for (let m = t.totalPages - 4; m <= t.totalPages; m++)
          s.value.push(m);
      } else {
        i.value = 1;
        for (let m = p - 1; m <= p + 1; m++)
          s.value.push(m);
        o.value = t.totalPages;
      }
    }, D = (p) => {
      n("amountChange", p);
    };
    return Ae(() => {
      b(u.value);
    }), $e(u, () => {
      b(u.value);
    }), (p, m) => (d(), h("div", mh, [
      l("div", {
        class: P([{
          "aeb-pagination__button--disable": u.value === 1
        }, "aeb-pagination__button"]),
        onClick: f
      }, bh, 2),
      l("div", wh, [
        i.value ? (d(), h("div", {
          key: 0,
          class: "aeb-pagination__page",
          onClick: m[0] || (m[0] = (w) => c(i.value))
        }, k(i.value), 1)) : F("", !0),
        i.value ? (d(), h("div", kh, "...")) : F("", !0),
        (d(!0), h(R, null, X(s.value, (w, E) => (d(), h("div", {
          key: E,
          class: P([{
            "aeb-pagination__page--active": u.value === w
          }, "aeb-pagination__page"]),
          onClick: (C) => v(w)
        }, k(w), 11, yh))), 128)),
        o.value ? (d(), h("div", Ch, "...")) : F("", !0),
        o.value ? (d(), h("div", {
          key: 3,
          class: "aeb-pagination__page",
          onClick: m[1] || (m[1] = (w) => g(o.value))
        }, k(o.value), 1)) : F("", !0)
      ]),
      l("div", Dh, [
        l("div", $h, [
          l("div", {
            class: P([{
              "aeb-pagination__button--disable": u.value === p.totalPages
            }, "aeb-pagination__button aeb-pagination__button--right"]),
            onClick: m[2] || (m[2] = (w) => _())
          }, Th, 2)
        ]),
        p.amount ? (d(), h("div", xh, [
          ae(ua, {
            direction: "top",
            value: p.amount,
            onChange: m[3] || (m[3] = (w) => D(w))
          }, {
            default: se(() => [
              (d(!0), h(R, null, X(p.amountOptions, (w, E) => (d(), ct(la, {
                key: E,
                value: w.value
              }, {
                default: se(() => [
                  ue(k(w.label), 1)
                ]),
                _: 2
              }, 1032, ["value"]))), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ])) : F("", !0)
      ])
    ]));
  }
}), Ah = /* @__PURE__ */ B(Ph, [["__scopeId", "data-v-59415359"]]), Nt = (r) => (ne("data-v-336261cd"), r = r(), re(), r), Sh = { class: "aeb-pagination-old" }, Lh = /* @__PURE__ */ Nt(() => /* @__PURE__ */ l("div", { class: "aeb-pagination-old__arrow-icon aeb-pagination-old__arrow-icon--left" }, [
  /* @__PURE__ */ l("svg", {
    fill: "none",
    height: "10",
    viewBox: "0 0 6 10",
    width: "6",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ l("path", {
      d: "M1 9L4.92929 5.07071C4.96834 5.03166 4.96834 4.96834 4.92929 4.92929L1 1",
      stroke: "#2F88F0",
      "stroke-linecap": "round",
      "stroke-width": "2"
    })
  ])
], -1)), Oh = /* @__PURE__ */ Nt(() => /* @__PURE__ */ l("span", { class: "aeb-pagination-old__button-label" }, "Назад", -1)), Bh = [
  Lh,
  Oh
], Ih = { class: "aeb-pagination-old__block" }, Rh = ["onClick"], Vh = {
  key: 0,
  class: "aeb-pagination-old__breaker"
}, Nh = ["onClick"], Hh = {
  key: 1,
  class: "aeb-pagination-old__breaker"
}, Yh = ["onClick"], Uh = { class: "aeb-pagination-old__block" }, Wh = { class: "aeb-pagination-old__amount" }, qh = { class: "aeb-pagination-old__block" }, Gh = /* @__PURE__ */ Nt(() => /* @__PURE__ */ l("span", { class: "aeb-pagination-old__button-label" }, "Далее", -1)), jh = /* @__PURE__ */ Nt(() => /* @__PURE__ */ l("div", { class: "aeb-pagination-old__arrow-icon aeb-pagination-old__arrow-icon--right" }, [
  /* @__PURE__ */ l("svg", {
    fill: "none",
    height: "10",
    viewBox: "0 0 6 10",
    width: "6",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ l("path", {
      d: "M1 9L4.92929 5.07071C4.96834 5.03166 4.96834 4.96834 4.92929 4.92929L1 1",
      stroke: "#2F88F0",
      "stroke-linecap": "round",
      "stroke-width": "2"
    })
  ])
], -1)), Zh = [
  Gh,
  jh
], zh = {
  name: "aeb-pagination-old"
}, Qh = /* @__PURE__ */ A({
  ...zh,
  props: {
    totalPages: {
      type: Number,
      default: 1500
    },
    page: {
      type: Number,
      default: 1
    },
    amount: {
      type: Number,
      default: 10
    },
    amountOptions: {
      type: Array,
      default: () => [
        {
          value: 10,
          label: "По 10 на стр."
        },
        {
          value: 20,
          label: "По 20 на стр."
        },
        {
          value: 30,
          label: "По 30 на стр."
        }
      ]
    },
    adaptive: {
      type: Number
    }
  },
  emits: ["pageSelect", "amountChange"],
  setup(r, { emit: e }) {
    const t = {
      1150: 5,
      700: 3,
      600: 2
    }, n = r, a = e, i = y([]), s = y([]), o = y([]), u = y(13), c = y(n.page), v = (w) => {
      const E = [...new Array(u.value)].map((C, Y) => {
        const O = w + Y;
        return O <= n.totalPages ? O : 0;
      }).filter((C) => !!C);
      s.value = E, n.totalPages === 1 ? i.value = [] : i.value = [1, 2].filter((C) => !E.includes(C)), o.value = [...new Array(2)].map((C, Y) => n.totalPages - Y).filter((C) => !E.includes(C) && C > c.value).reverse();
    }, g = (w) => {
      c.value = w, a("pageSelect", c.value);
    }, f = () => {
      if (c.value === n.totalPages)
        return;
      const w = c.value + 1;
      c.value = w, s.value.includes(w) || v(w), a("pageSelect", c.value);
    }, _ = () => {
      if (c.value === 1)
        return;
      const w = c.value - 1;
      c.value = w, s.value.includes(w) || v(w - (u.value - 1)), a("pageSelect", w);
    }, b = (w) => {
      c.value = w, v(
        [...new Array(u.value)].map((E, C) => n.totalPages - C).reverse().filter((E) => !s.value.includes(E))[0]
      ), a("pageSelect", w);
    }, D = (w) => {
      c.value = w, v(1), a("pageSelect", w);
    }, p = (w) => {
      a("amountChange", w);
    }, m = () => {
      const w = +(window.innerWidth / 50).toFixed() * 50;
      t[w] ? (u.value = t[w], v(s.value[0])) : window.innerWidth > 1150 && (u.value = n.adaptive || 13, v(s.value[0]));
    };
    return Ae(() => {
      c.value = parseInt(c.value.toString(), 10), u.value = n.adaptive ? n.adaptive : u.value, window.innerWidth <= 600 ? u.value = 2 : window.innerWidth <= 700 ? u.value = 3 : window.innerWidth <= 1150 && (u.value = 5), s.value && (c.value = 1, v(1), a("pageSelect", 1)), window.addEventListener("resize", m);
    }), Ie(() => {
      window.removeEventListener("resize", m);
    }), $e(u, () => {
      v(c.value);
    }), $e(c, () => {
      c.value > s.value[s.value.length - 1] && v(c.value);
    }), (w, E) => (d(), h("div", Sh, [
      l("div", {
        class: P([{
          "aeb-pagination-old__button--disable": c.value === 1
        }, "aeb-pagination-old__button"]),
        onClick: _
      }, Bh, 2),
      l("div", Ih, [
        (d(!0), h(R, null, X(i.value, (C, Y) => (d(), h("div", {
          key: Y,
          class: "aeb-pagination-old__page",
          onClick: (O) => D(C)
        }, k(C), 9, Rh))), 128)),
        i.value.length ? (d(), h("div", Vh, " ... ")) : F("", !0),
        (d(!0), h(R, null, X(s.value, (C, Y) => (d(), h("div", {
          key: Y,
          class: P([{
            "aeb-pagination-old__page--active": c.value === C
          }, "aeb-pagination-old__page"]),
          onClick: (O) => g(C)
        }, k(C), 11, Nh))), 128)),
        o.value.length ? (d(), h("div", Hh, " ... ")) : F("", !0),
        (d(!0), h(R, null, X(o.value, (C, Y) => (d(), h("div", {
          key: Y,
          class: "aeb-pagination-old__page",
          onClick: (O) => b(C)
        }, k(C), 9, Yh))), 128))
      ]),
      l("div", Uh, [
        l("div", Wh, [
          ae(ua, {
            direction: "top",
            value: r.amount,
            onChange: E[0] || (E[0] = (C) => p(C))
          }, {
            default: se(() => [
              (d(!0), h(R, null, X(r.amountOptions, (C, Y) => (d(), ct(la, {
                key: Y,
                value: C.value
              }, {
                default: se(() => [
                  ue(k(C.label), 1)
                ]),
                _: 2
              }, 1032, ["value"]))), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        l("div", qh, [
          l("div", {
            class: P([{
              "aeb-pagination-old__button--disable": c.value === r.totalPages
            }, "aeb-pagination-old__button aeb-pagination-old__button--right"]),
            onClick: f
          }, Zh, 2)
        ])
      ])
    ]));
  }
}), Xh = /* @__PURE__ */ B(Qh, [["__scopeId", "data-v-336261cd"]]), Kh = {
  name: "aeb-pop-up"
}, Jh = /* @__PURE__ */ A({
  ...Kh,
  props: {
    position: {}
  },
  setup(r) {
    const e = r, t = y(null), n = y(null), a = {
      right: (s, o) => {
        const u = s.top + s.height / 2, c = o.offsetHeight / 2;
        return [s.right + 15, u - c];
      },
      bottom: (s, o) => {
        const u = s.right - s.width / 2, c = o.offsetWidth / 2;
        return [u - c, s.bottom + 15];
      },
      left: (s, o) => {
        const u = s.top + s.height / 2, c = o.offsetHeight / 2;
        return [
          s.left - o.offsetWidth - 15,
          u - c
        ];
      },
      top: (s, o) => {
        const u = s.right - s.width / 2, c = o.offsetWidth / 2;
        return [
          u - c,
          s.top - o.offsetHeight - 15
        ];
      }
    }, i = (s) => {
      var u, c;
      if (s.target !== ((u = t.value) == null ? void 0 : u.children[0]))
        return;
      const o = (c = n.value) == null ? void 0 : c.children[0];
      if (o) {
        o.style.opacity = "1", o.style.pointerEvents = "all";
        const v = t.value.getBoundingClientRect(), [g, f] = a[e.position](v, o);
        o.style.left = `${g}px`, o.style.top = `${f}px`, o.className = `aeb-pop-up aeb-pop-up--${e.position}`;
      }
    };
    return Ae(() => {
      var s;
      (s = t.value) == null || s.addEventListener("click", i);
    }), Ie(() => {
      var s;
      (s = t.value) == null || s.removeEventListener("click", i);
    }), (s, o) => (d(), h(R, null, [
      l("div", {
        ref_key: "popupRef",
        ref: t
      }, [
        U(s.$slots, "default", {}, void 0, !0)
      ], 512),
      l("div", {
        ref_key: "popupComponentRef",
        ref: n
      }, [
        U(s.$slots, "content", {}, void 0, !0)
      ], 512)
    ], 64));
  }
}), ef = /* @__PURE__ */ B(Jh, [["__scopeId", "data-v-033e4b35"]]), tf = (r) => (ne("data-v-add8f7c4"), r = r(), re(), r), af = { class: "aeb-pop-up__header" }, nf = { class: "aeb-pop-up__heading" }, rf = /* @__PURE__ */ tf(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M5.63086 5.63074L18.3693 18.3692",
    stroke: "#2F88F0",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }),
  /* @__PURE__ */ l("path", {
    d: "M18.3691 5.63074L5.63065 18.3692",
    stroke: "#2F88F0",
    "stroke-linecap": "round",
    "stroke-width": "2"
  })
], -1)), sf = [
  rf
], of = { class: "aeb-pop-up__container" }, uf = {
  name: "aeb-pop-up-component"
}, lf = /* @__PURE__ */ A({
  ...uf,
  props: {
    header: {}
  },
  setup(r) {
    const e = y(null), t = () => {
      e.value && (e.value.style.opacity = "0", e.value.style.pointerEvents = "none");
    };
    return (n, a) => (d(), h("div", {
      ref_key: "popUpRef",
      ref: e,
      class: "aeb-pop-up"
    }, [
      l("div", af, [
        l("div", nf, k(n.header), 1),
        l("div", {
          class: "aeb-pop-up__close-icon",
          onClick: t
        }, sf)
      ]),
      l("div", of, [
        U(n.$slots, "default", {}, void 0, !0)
      ])
    ], 512));
  }
}), cf = /* @__PURE__ */ B(lf, [["__scopeId", "data-v-add8f7c4"]]), df = { class: "aeb-radio-buttons__header" }, hf = ["onClick"], ff = { class: "aeb-radio-buttons__label" }, vf = {
  name: "aeb-radio-buttons"
}, pf = /* @__PURE__ */ A({
  ...vf,
  props: {
    options: { default: () => [] },
    header: {},
    onError: { type: Boolean, default: !1 },
    horizontal: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    value: { default: 0 }
  },
  emits: ["change"],
  setup(r, { emit: e }) {
    const t = r, n = e, a = y(), i = (s) => {
      t.disabled || (a.value = s, n("change", s));
    };
    return (s, o) => (d(), h("div", {
      class: P([{
        "aeb-radio-buttons--disabled": s.disabled,
        "aeb-radio-buttons--error": s.onError
      }, "aeb-radio-buttons"])
    }, [
      l("div", df, k(s.header), 1),
      l("div", {
        class: P([{ horizontal: s.horizontal }, "aeb-radio-buttons__items"])
      }, [
        (d(!0), h(R, null, X(s.options, (u) => (d(), h("div", {
          class: "aeb-radio-buttons__item",
          onClick: () => i(u.value)
        }, [
          l("div", {
            class: P([{
              "aeb-radio-buttons__circle--active": a.value === u.value
            }, "aeb-radio-buttons__circle"])
          }, null, 2),
          l("span", ff, k(u.label), 1)
        ], 8, hf))), 256))
      ], 2)
    ], 2));
  }
}), mf = /* @__PURE__ */ B(pf, [["__scopeId", "data-v-ba6cca00"]]), gn = (r) => (ne("data-v-5a46d59e"), r = r(), re(), r), gf = { class: "aeb-search__input-wrapper" }, _f = /* @__PURE__ */ gn(() => /* @__PURE__ */ l("div", { class: "aeb-search__search-icon" }, [
  /* @__PURE__ */ l("svg", {
    fill: "none",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ l("circle", {
      cx: "10.5",
      cy: "10.5",
      r: "6.5",
      stroke: "#2F88F0",
      "stroke-width": "2"
    }),
    /* @__PURE__ */ l("path", {
      d: "M15 15.5L19.5 20",
      stroke: "#2F88F0",
      "stroke-linecap": "round",
      "stroke-width": "2"
    })
  ])
], -1)), bf = ["placeholder", "value"], wf = {
  key: 0,
  class: "aeb-search__options"
}, kf = ["onClick"], yf = { class: "aeb-search__option" }, Cf = { class: "aeb-search__option-img" }, Df = ["src"], $f = { class: "aeb-search__option-content" }, Ef = ["innerHTML"], Mf = { class: "aeb-search__option-desc" }, Tf = {
  key: 0,
  class: "aeb-search__examples"
}, xf = ["onClick"], Ff = { key: 0 }, Pf = /* @__PURE__ */ gn(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M5.63074 5.63086L18.3692 18.3693",
    stroke: "#27303E",
    "stroke-linecap": "round",
    "stroke-width": "2"
  }),
  /* @__PURE__ */ l("path", {
    d: "M18.3693 5.63086L5.63077 18.3693",
    stroke: "#27303E",
    "stroke-linecap": "round",
    "stroke-width": "2"
  })
], -1)), Af = [
  Pf
], Sf = {
  name: "aeb-search"
}, Lf = /* @__PURE__ */ A({
  ...Sf,
  props: {
    withoutBg: { type: Boolean, default: !1 },
    placeholder: {},
    options: { default: () => [] },
    examples: { default: () => [] }
  },
  emits: ["onChange"],
  setup(r, { emit: e }) {
    const t = e;
    let n = y(""), a = Dn(!1);
    const i = () => {
      a.value = !1;
    }, s = (f) => {
      a.value = !0, n.value = f.target.value, t("onChange", n.value);
    }, o = () => {
      n.value = "", t("onChange", n.value);
    }, u = () => {
      n.value && (a.value = !0);
    }, c = (f) => {
      n.value = f, t("onChange", n.value);
    }, v = (f) => {
      n.value = f, a.value = !1, t("onChange", n.value);
    }, g = (f) => `${f.replace(
      RegExp(n.value),
      `<b>${n.value}</b>`
    )}`;
    return (f, _) => (d(), h("div", {
      class: P([{
        "aeb-search--plate": !f.withoutBg
      }, "aeb-search"])
    }, [
      l("div", gf, [
        _f,
        Ye(l("input", {
          class: P([{
            "aeb-search__input--expanded": H(a) && !!f.options.length
          }, "aeb-search__input"]),
          placeholder: f.placeholder,
          value: H(n),
          onFocus: u,
          onInput: s
        }, null, 42, bf), [
          [H(dt), i]
        ]),
        H(a) && f.options.length ? (d(), h("div", wf, [
          (d(!0), h(R, null, X(f.options, (b, D) => (d(), h("div", {
            class: "aeb-search__option-wrapper",
            onClick: (p) => v(b.value)
          }, [
            l("div", yf, [
              l("div", Cf, [
                b.image ? (d(), h("img", {
                  key: 0,
                  src: b.image,
                  alt: ""
                }, null, 8, Df)) : (d(), h(R, { key: 1 }, [
                  ue(k(b.value[0].toUpperCase()), 1)
                ], 64))
              ]),
              l("div", $f, [
                l("div", {
                  class: "aeb-search__option-value",
                  innerHTML: g(b.value)
                }, null, 8, Ef),
                l("div", Mf, k(b.description), 1)
              ])
            ])
          ], 8, kf))), 256))
        ])) : F("", !0),
        f.withoutBg ? F("", !0) : U(f.$slots, "default", { key: 1 }, () => [
          f.examples.length ? (d(), h("div", Tf, [
            ue(" Например: "),
            (d(!0), h(R, null, X(f.examples, (b, D) => (d(), h("span", {
              class: "aeb-search__example",
              onClick: (p) => c(b)
            }, [
              ue(k(b), 1),
              D !== f.examples.length - 1 ? (d(), h("span", Ff, ", ")) : F("", !0)
            ], 8, xf))), 256))
          ])) : F("", !0)
        ], !0),
        H(n) ? (d(), h("div", {
          key: 2,
          class: "aeb-search__close-icon",
          onClick: o
        }, Af)) : F("", !0)
      ])
    ], 2));
  }
}), Of = /* @__PURE__ */ B(Lf, [["__scopeId", "data-v-5a46d59e"]]), _n = (r) => (ne("data-v-b8bd11c3"), r = r(), re(), r), Bf = {
  key: 0,
  class: "aeb-sidebar-items"
}, If = {
  key: 1,
  class: "aeb-sidebar-burger"
}, Rf = /* @__PURE__ */ _n(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M1.71387 12H22.2853",
    stroke: "#27303E",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  }),
  /* @__PURE__ */ l("path", {
    d: "M1.71387 5.14258H22.2853",
    stroke: "#27303E",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  }),
  /* @__PURE__ */ l("path", {
    d: "M1.71387 18.8574H22.2853",
    stroke: "#27303E",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })
], -1)), Vf = [
  Rf
], Nf = {
  key: 2,
  class: "aeb-sidebar-items"
}, Hf = { class: "aeb-sidebar-content" }, Yf = {
  key: 3,
  class: "aeb-sidebar-footer"
}, Uf = /* @__PURE__ */ _n(() => /* @__PURE__ */ l("svg", {
  fill: "none",
  height: "28",
  viewBox: "0 0 28 28",
  width: "28",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    "clip-rule": "evenodd",
    d: "M15.5359 6.30688L21.7602 13.3677C21.9199 13.5493 22 13.7653 22 14C22 14.2106 21.9341 14.4606 21.7515 14.6422L15.5318 21.6978C15.3721 21.8793 15.1534 22 14.8856 22C14.6176 22 14.399 21.8794 14.2394 21.6977C13.927 21.3423 13.9119 20.7814 14.244 20.4287L19.9121 14L14.2398 7.56653C13.9272 7.21101 13.9119 6.64939 14.2444 6.29664C14.4095 6.11179 14.6412 6 14.8921 6C15.1445 6 15.3769 6.1135 15.5359 6.30688Z",
    fill: "#9CA8AF",
    "fill-rule": "evenodd"
  }),
  /* @__PURE__ */ l("path", {
    "clip-rule": "evenodd",
    d: "M7.53586 6.30688L13.7602 13.3677C13.9199 13.5493 14 13.7653 14 14C14 14.2106 13.9341 14.4606 13.7515 14.6422L7.53175 21.6978C7.37212 21.8793 7.15341 22 6.88558 22C6.61765 22 6.39904 21.8794 6.2394 21.6977C5.92703 21.3423 5.91188 20.7814 6.24398 20.4287L11.9121 14L6.23978 7.56653C5.92725 7.21101 5.91186 6.64939 6.24438 6.29664C6.4095 6.11179 6.64121 6 6.89212 6C7.14455 6 7.37688 6.1135 7.53586 6.30688Z",
    fill: "#9CA8AF",
    "fill-rule": "evenodd"
  })
], -1)), Wf = [
  Uf
], qf = {
  name: "aeb-sidebar"
}, Gf = /* @__PURE__ */ A({
  ...qf,
  props: {
    isRight: { type: Boolean, default: !1 },
    isOpen: { type: Boolean, default: !0 },
    layoutMod: {}
  },
  setup(r) {
    const t = y(r.isOpen);
    function n() {
      t.value = !t.value;
    }
    return (a, i) => (d(), h("div", {
      class: P([{
        right: a.isRight,
        open: t.value,
        "aeb-sidebar--burger": a.layoutMod === "burger"
      }, "aeb-sidebar"])
    }, [
      a.layoutMod ? F("", !0) : (d(), h("div", Bf, [
        U(a.$slots, "default", {}, void 0, !0)
      ])),
      a.layoutMod === "burger" ? (d(), h("div", If, [
        l("div", {
          class: "aeb-sidebar-burger__icon",
          onClick: n
        }, Vf)
      ])) : F("", !0),
      a.layoutMod === "burger" ? (d(), h("div", Nf, [
        l("div", Hf, [
          U(a.$slots, "default", {}, void 0, !0)
        ])
      ])) : F("", !0),
      t.value ? (d(), h("div", Yf)) : F("", !0),
      a.layoutMod ? F("", !0) : (d(), h("div", {
        key: 4,
        class: "aeb-sidebar-toggle-icon",
        onClick: n
      }, Wf))
    ], 2));
  }
}), jf = /* @__PURE__ */ B(Gf, [["__scopeId", "data-v-b8bd11c3"]]), Zf = { class: "slider" }, zf = { class: "label" }, Qf = { class: "value" }, Xf = { class: "slider-line" }, Kf = { class: "slider-limits" }, Jf = {
  name: "aeb-slider"
}, e1 = /* @__PURE__ */ A({
  ...Jf,
  props: {
    label: {},
    prefix: {},
    min: {},
    max: {},
    step: {},
    value: {},
    valueSeparator: { default: " " },
    isPressed: { type: Boolean, default: !1 }
  },
  emits: ["value-change"],
  setup(r, { emit: e }) {
    const t = e, n = r, a = (m, w, E) => !m || !w || !E ? m : m.replace(new RegExp(w, "g"), E), i = (m) => m.reduce((w, E) => w + E, 0) / m.length, s = y(
      n.value || i([n == null ? void 0 : n.min, n == null ? void 0 : n.max])
    ), o = y(n.isPressed), u = y(null), c = () => {
      const m = (s.value - (n == null ? void 0 : n.min)) / ((n == null ? void 0 : n.max) - (n == null ? void 0 : n.min)) * 100;
      return m < 0 ? 0 : m > 100 ? 100 : m;
    }, v = (m) => {
      m.preventDefault(), m.clientX && f(m.clientX);
    }, g = (m) => {
      if (m.preventDefault(), m.touches && m.touches.length) {
        const w = m.touches[0];
        f(w.clientX);
      }
    }, f = (m) => {
      var O, $;
      o.value = !0;
      const w = (O = u == null ? void 0 : u.value) == null ? void 0 : O.getBoundingClientRect().left, E = ($ = u == null ? void 0 : u.value) == null ? void 0 : $.getBoundingClientRect().width;
      let C = m - w;
      C < 0 && (C = 0), C > E && (C = E);
      const Y = C / E * (n.max - n.min);
      s.value = Math.round(Y / n.step) * n.step + n.min;
    }, _ = (m) => {
      m.preventDefault(), o.value = !1, document.removeEventListener("mousemove", v), document.removeEventListener("mouseup", _), t("value-change", s.value);
    }, b = (m) => {
      m.preventDefault(), o.value = !1, document.removeEventListener("touchmove", g), document.removeEventListener("touchend", b), document.removeEventListener("touchcancel", b), t("value-change", s.value);
    }, D = (m) => {
      m.preventDefault(), v(m), document.addEventListener("mousemove", v, !1), document.addEventListener("mouseup", _, !1);
    }, p = (m) => {
      m.preventDefault(), g(m), document.addEventListener("touchmove", g, {
        passive: !1
      }), document.addEventListener("touchend", b), document.addEventListener("touchcancel", b);
    };
    return Ae(() => {
      var m, w;
      (m = u.value) == null || m.addEventListener(
        "mousedown",
        (E) => D(E)
      ), (w = u.value) == null || w.addEventListener(
        "touchstart",
        (E) => p(E)
      );
    }), Ie(() => {
      var m, w;
      (m = u.value) == null || m.removeEventListener(
        "mousedown",
        (E) => D(E)
      ), (w = u.value) == null || w.removeEventListener(
        "touchstart",
        (E) => p(E)
      );
    }), (m, w) => (d(), h("div", null, [
      l("div", Zf, [
        l("div", zf, k(m.label), 1),
        l("div", Qf, k(a(
          H(rt)(s.value, H(nt).en),
          ",",
          m.valueSeparator
        )) + " " + k(m.prefix), 1)
      ]),
      l("div", {
        ref_key: "slider",
        ref: u,
        class: "slider-line-wrapper"
      }, [
        l("div", Xf, [
          l("div", {
            class: P([{ pressed: o.value }, "slider-line-position"]),
            style: pe({
              width: c() + "%"
            })
          }, null, 6)
        ])
      ], 512),
      l("div", Kf, [
        l("div", null, k(a(
          H(rt)(m.min, H(nt).en),
          ",",
          m.valueSeparator
        )) + " " + k(m.prefix), 1),
        l("div", null, k(a(
          H(rt)(m.max, H(nt).en),
          ",",
          m.valueSeparator
        )) + " " + k(m.prefix), 1)
      ])
    ]));
  }
}), t1 = {
  name: "aeb-spinner"
}, a1 = { class: "spinner-wrap" }, n1 = /* @__PURE__ */ Ge('<div class="spinner-circle" data-v-dad75f1f><svg class="spinner-circle-border" viewBox="0 0 50 50" data-v-dad75f1f><circle class="path" cx="25" cy="25" fill="none" r="20" stroke-width="2" data-v-dad75f1f></circle></svg><svg class="spinner-circle-border rotate" viewBox="0 0 50 50" data-v-dad75f1f><circle class="path" cx="25" cy="25" fill="none" r="20" stroke-width="2" data-v-dad75f1f></circle></svg><svg class="spinner-circle-diamond" fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg" data-v-dad75f1f><path clip-rule="evenodd" d="M19.2101 16.1713L16.2663 19.0952L18.223 23.7905L23.9375 18.1148L19.2101 16.1713ZM15.1754 19.5423H11.0021L9.0454 24.2376H17.1148L15.1754 19.5423ZM19.6776 10.9428V15.0706L24.3877 17.0141V8.9994L19.6776 10.9428ZM9.8939 19.0952L6.9501 16.1713L2.24 18.1148L7.9544 23.7905L9.8939 19.0952ZM18.223 2.223L16.2663 6.9183L19.2101 9.8421L23.9375 7.8986L18.223 2.223ZM11.0021 6.4539H15.1754L17.1148 1.7758H9.0454L11.0021 6.4539ZM6.4999 15.0706V10.9428L1.7898 8.9994V17.0141L6.4999 15.0706ZM6.9501 9.8421L9.8939 6.9183L7.9544 2.223L2.24 7.8986L6.9501 9.8421ZM15.4005 18.5448L18.656 15.2942V10.7021L15.4005 7.4687H10.777L7.5042 10.7021V15.2942L10.777 18.5448H15.4005ZM7.9891 25.2352C5.2011 24.2154 1.7898 20.6463 0.768129 18.0804C-0.253521 15.5145 -0.258561 10.9428 0.768129 7.933C1.7948 4.9232 4.875 1.7758 7.9891 0.761051C11.1031 -0.253679 15.5877 -0.253689 18.1884 0.761051C20.7891 1.7758 24.896 5.9272 25.4094 7.933C25.9227 9.9389 26.431 15.5145 25.4094 18.0804C24.3877 20.6463 20.7213 24.2154 18.1884 25.2352C15.6556 26.2549 10.777 26.2549 7.9891 25.2352Z" fill="url(#paint0_linear)" fill-rule="evenodd" data-v-dad75f1f></path><defs data-v-dad75f1f><linearGradient id="paint0_linear" gradientUnits="userSpaceOnUse" x1="13.9013" x2="13.9013" y1="26" y2="0" data-v-dad75f1f><stop stop-color="#00B8FF" data-v-dad75f1f></stop><stop offset="1" stop-color="#0079D6" data-v-dad75f1f></stop></linearGradient></defs></svg></div>', 1), r1 = [
  n1
];
function s1(r, e, t, n, a, i) {
  return d(), h("div", a1, r1);
}
const i1 = /* @__PURE__ */ B(t1, [["render", s1], ["__scopeId", "data-v-dad75f1f"]]), o1 = { class: "table" }, u1 = ["align"], l1 = ["align"], c1 = { key: 0 }, d1 = { class: "table-action" }, h1 = ["src", "onClick"], f1 = { key: 1 }, v1 = ["onClick"], p1 = ["src"], m1 = ["onClick", "innerHTML"], g1 = {
  name: "aeb-table"
}, _1 = /* @__PURE__ */ A({
  ...g1,
  props: {
    tableConfig: {},
    tableContent: {}
  },
  emits: ["action"],
  setup(r, { emit: e }) {
    const t = r, n = e, a = (i, s) => {
      n("action", {
        actionToPerform: i,
        id: s
      });
    };
    return (i, s) => {
      var o;
      return d(), h("table", o1, [
        l("thead", null, [
          l("tr", null, [
            (d(!0), h(R, null, X((o = t.tableConfig) == null ? void 0 : o.columns, (u, c) => (d(), h("th", {
              key: c,
              align: (u == null ? void 0 : u.align) || "left",
              class: "table-title"
            }, k(u.title), 9, u1))), 128))
          ])
        ]),
        l("tbody", null, [
          (d(!0), h(R, null, X(t.tableContent, (u, c) => {
            var v;
            return d(), h("tr", { key: c }, [
              (d(!0), h(R, null, X((v = t.tableConfig) == null ? void 0 : v.columns, (g, f) => {
                var _, b, D, p, m;
                return d(), h("td", {
                  key: f,
                  align: g.align || "left"
                }, [
                  l("div", null, [
                    (g == null ? void 0 : g.dataField) === "ROW_ACTION" ? (d(), h("div", c1, [
                      l("div", d1, [
                        (d(!0), h(R, null, X((_ = i.tableConfig) == null ? void 0 : _.rowActions, (w, E) => (d(), h("div", { key: E }, [
                          l("img", {
                            src: w == null ? void 0 : w.logoImageUrl,
                            alt: "img",
                            onClick: (C) => a(
                              w.actionToPerform,
                              u.id
                            )
                          }, null, 8, h1)
                        ]))), 128))
                      ])
                    ])) : (g == null ? void 0 : g.dataField) === "STATUS" ? (d(), h("div", f1, [
                      l("div", null, [
                        (d(!0), h(R, null, X((b = t.tableConfig) == null ? void 0 : b.status, (w, E) => (d(), h(R, { key: E }, [
                          g.dataProperty && u[g.dataProperty] === E ? (d(), h("div", {
                            key: 0,
                            style: pe({ color: w.color }),
                            class: "table-status",
                            onClick: (C) => a(
                              g.action || "SHOW",
                              u.id
                            )
                          }, [
                            l("img", {
                              src: w == null ? void 0 : w.iconUrl
                            }, null, 8, p1),
                            l("span", null, k(w.label), 1)
                          ], 12, v1)) : F("", !0)
                        ], 64))), 128))
                      ])
                    ])) : (d(), h("div", {
                      key: 2,
                      onClick: (w) => a(
                        g.action || "SHOW",
                        u.id
                      ),
                      innerHTML: g != null && g.dataProperty ? H(Il)(
                        u[g.dataProperty],
                        (D = g.format) == null ? void 0 : D.type,
                        (p = g.format) == null ? void 0 : p.placeholder,
                        (m = g.format) == null ? void 0 : m.local
                      ) : ""
                    }, null, 8, m1))
                  ])
                ], 8, l1);
              }), 128))
            ]);
          }), 128))
        ])
      ]);
    };
  }
}), b1 = /* @__PURE__ */ B(_1, [["__scopeId", "data-v-ed8d5298"]]), w1 = { class: "aeb-tabs__wrapper" }, k1 = ["onClick"], y1 = {
  name: "aeb-tabs"
}, C1 = /* @__PURE__ */ A({
  ...y1,
  props: {
    layoutMod: { type: String, default: "compact" },
    collapsed: { type: Boolean, default: !1 },
    tab: { type: Number, default: 0 }
  },
  emits: ["change"],
  setup(r, { emit: e }) {
    var D;
    const t = r, n = e, a = Ot(), i = y(null), s = y(null), o = y(null), u = (D = a.default) == null ? void 0 : D.call(a), c = Aa(
      u.map((p) => ({
        name: p.dirs[0].value,
        template: p.children
      }))
    ), v = y(null), g = (p, m) => {
      const w = p.target;
      f(w), o.value = m, n("change", o.value.name);
    }, f = (p) => {
      if (i.value && s.value) {
        const m = p.getBoundingClientRect().left, w = s.value.getBoundingClientRect().left;
        i.value.style.width = `${p.offsetWidth}px`, i.value.style.left = `${m - w}px`;
      }
    }, _ = (p) => {
      o.value = c[p], v.value && f(v.value[p]);
    }, b = () => {
      const p = c.indexOf(o.value);
      v.value && f(v.value[p]);
    };
    return Ae(() => {
      setTimeout(() => {
        String(t.tab) && !t.collapsed && _(t.tab), window.addEventListener("resize", b);
      });
    }), Ie(() => {
      window.removeEventListener("resize", b);
    }), mt(() => {
      t.tab && c.length && _(t.tab);
    }), (p, m) => (d(), h(R, null, [
      l("div", {
        ref_key: "container",
        ref: s,
        class: P([{
          "aeb-tabs--compact": r.layoutMod === "compact"
        }, "aeb-tabs"])
      }, [
        l("div", w1, [
          (d(!0), h(R, null, X(c, (w, E) => (d(), h("div", {
            key: E,
            ref_for: !0,
            ref_key: "templateTabs",
            ref: v,
            class: P([{
              "aeb-tabs__tab--active": w === o.value
            }, "aeb-tabs__tab"]),
            onClick: (C) => g(C, w)
          }, k(w.name), 11, k1))), 128))
        ]),
        l("div", {
          ref_key: "thumb",
          ref: i,
          class: "aeb-tabs__thumb"
        }, null, 512)
      ], 2),
      o.value ? (d(!0), h(R, { key: 0 }, X(o.value.template, (w, E) => (d(), ct(Sa(w), { key: E }))), 128)) : F("", !0)
    ], 64));
  }
}), D1 = /* @__PURE__ */ B(C1, [["__scopeId", "data-v-201a2f44"]]), $1 = {
  name: "aeb-tag-tab"
}, E1 = /* @__PURE__ */ A({
  ...$1,
  props: {
    label: { default: "" },
    isActive: { type: Boolean, default: !1 }
  },
  setup(r) {
    return (e, t) => (d(), h("div", {
      class: P([{ "tag--active": e.isActive }, "tag"])
    }, k(e.label), 3));
  }
}), M1 = /* @__PURE__ */ B(E1, [["__scopeId", "data-v-cd609a7f"]]), T1 = A({
  name: "aeb-visa"
}), x1 = (r) => (ne("data-v-49c37e74"), r = r(), re(), r), F1 = { class: "aeb-visa" }, P1 = /* @__PURE__ */ x1(() => /* @__PURE__ */ l("h3", null, "Визы", -1)), A1 = { class: "aeb-visa-timeline" };
function S1(r, e, t, n, a, i) {
  return d(), h("div", F1, [
    P1,
    l("div", A1, [
      U(r.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const L1 = /* @__PURE__ */ B(T1, [["render", S1], ["__scopeId", "data-v-49c37e74"]]), O1 = A({
  name: "aeb-visa-item",
  props: {
    status: {
      type: String
    }
  }
}), B1 = { class: "aeb-visa-item" }, I1 = { class: "aeb-visa-icon" }, R1 = /* @__PURE__ */ Ge('<svg fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" fill="#FF3055" r="10"></circle><rect fill="white" height="12.5" rx="0.875" transform="rotate(-45 5 5.88379)" width="1.75" x="5" y="5.88379"></rect><rect fill="white" height="12.5" rx="0.875" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 14.7229 5.88379)" width="1.75"></rect></svg><div class="aeb-visa-progress"></div>', 2), V1 = /* @__PURE__ */ l("svg", {
  fill: "none",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    d: "M10.0283 0.0283264C4.5298 0.0127068 0.0439644 4.47313 0.0283447 9.97167C0.012725 15.4702 4.47315 19.9561 9.97169 19.9717C15.4702 19.9873 19.9561 15.5269 19.9717 10.0283C19.9873 4.52978 15.5269 0.0439461 10.0283 0.0283264Z",
    fill: "#00BF41"
  }),
  /* @__PURE__ */ l("path", {
    d: "M13.109 6.98264L9.52446 11.2591L7.67997 9.40447C7.35682 9.07906 6.82998 9.07756 6.50498 9.40114C6.17956 9.72471 6.17807 10.2507 6.50164 10.5761L8.98748 13.0761C9.14367 13.2328 9.35491 13.3206 9.5747 13.3213C9.58716 13.3213 9.60004 13.3213 9.61251 13.3205C9.84563 13.3108 10.0641 13.203 10.2141 13.0239L14.3832 8.04991C14.6779 7.69799 14.6316 7.17435 14.2801 6.87918C13.9282 6.58485 13.4037 6.63072 13.109 6.98264Z",
    fill: "white"
  })
], -1), N1 = /* @__PURE__ */ l("div", { class: "aeb-visa-progress agreed" }, null, -1), H1 = /* @__PURE__ */ Ge('<svg fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" fill="#E7EAEC" r="10"></circle><path d="M10 3C6.1402 3 3 6.1402 3 10C3 13.8598 6.1402 17 10 17C13.8598 17 17 13.8598 17 10C17 6.1402 13.8598 3 10 3ZM10 15.5105C6.96153 15.5105 4.48934 13.0386 4.48934 10C4.48934 6.96138 6.96153 4.48948 10 4.48948C13.0385 4.48948 15.5107 6.96138 15.5107 10C15.5107 13.0386 13.0385 15.5105 10 15.5105Z" fill="white"></path><path d="M13.4088 9.95425H10.1823V6.52288C10.1823 6.23412 9.91762 6 9.59116 6C9.26469 6 9 6.23412 9 6.52288V10.4771C9 10.7659 9.26469 11 9.59116 11H13.4088C13.7353 11 14 10.7659 14 10.4771C14 10.1884 13.7353 9.95425 13.4088 9.95425Z" fill="white" stroke="white" stroke-width="0.3"></path></svg><div class="aeb-visa-progress"></div>', 2);
function Y1(r, e, t, n, a, i) {
  return d(), h("div", B1, [
    l("div", I1, [
      r.status === "isReturned" ? (d(), h(R, { key: 0 }, [
        R1
      ], 64)) : F("", !0),
      r.status === "isAgreed" ? (d(), h(R, { key: 1 }, [
        V1,
        N1
      ], 64)) : F("", !0),
      r.status === "isProgress" ? (d(), h(R, { key: 2 }, [
        H1
      ], 64)) : F("", !0)
    ]),
    l("div", {
      class: P(`aeb-visa-status ${r.status}`)
    }, [
      U(r.$slots, "default")
    ], 2)
  ]);
}
const U1 = /* @__PURE__ */ B(O1, [["render", Y1]]), W1 = A({
  name: "aeb-span-title"
}), q1 = { class: "aeb-visa-title" };
function G1(r, e, t, n, a, i) {
  return d(), h("div", q1, [
    U(r.$slots, "default")
  ]);
}
const j1 = /* @__PURE__ */ B(W1, [["render", G1]]), Z1 = A({
  name: "aeb-span-subtitle"
}), z1 = { class: "aeb-visa-subtitle" };
function Q1(r, e, t, n, a, i) {
  return d(), h("div", z1, [
    U(r.$slots, "default")
  ]);
}
const X1 = /* @__PURE__ */ B(Z1, [["render", Q1]]), bn = (r) => (ne("data-v-d61312e1"), r = r(), re(), r), K1 = { class: "stepper" }, J1 = { class: "stepper-steps" }, e0 = { class: "stepper-step-index" }, t0 = { key: 0 }, a0 = /* @__PURE__ */ bn(() => /* @__PURE__ */ l("svg", {
  class: "check-icon",
  fill: "none",
  height: "28",
  viewBox: "0 0 28 28",
  width: "28",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ l("path", {
    "clip-rule": "evenodd",
    d: "M25.4674 5.47186C26.1505 6.12666 26.1805 7.21877 25.5345 7.91115L11.9594 22.4601C11.3279 23.1369 10.2805 23.1835 9.59296 22.5654L2.5728 16.2545C1.8694 15.6222 1.80492 14.5316 2.42878 13.8186C3.05264 13.1057 4.1286 13.0403 4.832 13.6726L10.6186 18.8746L23.0608 5.53988C23.7068 4.84751 24.7843 4.81705 25.4674 5.47186Z",
    fill: "#FAFAFA",
    "fill-rule": "evenodd"
  })
], -1)), n0 = [
  a0
], r0 = /* @__PURE__ */ bn(() => /* @__PURE__ */ l("span", { class: "stepper-step-index--prefix" }, "Шаг", -1)), s0 = { class: "stepper-step-index--postfix" }, i0 = { class: "stepper-steps-line" }, o0 = { class: "stepper-steps-content" }, u0 = {
  name: "aeb-stepper"
}, l0 = /* @__PURE__ */ A({
  ...u0,
  props: {
    isDisabled: { type: Boolean, default: !1 }
  },
  emits: ["onStepChanged"],
  setup(r, { expose: e, emit: t }) {
    var w, E;
    const n = t, a = Ot(), i = (w = a.default) == null ? void 0 : w.call(a), s = ((E = i[0].type) == null ? void 0 : E.name) === "aeb-stepper-step" ? i.map((C) => C.props) : i[0].children.map(
      (C) => C.props
    ), o = Aa(s), u = Me(
      () => o.filter((C) => C == null ? void 0 : C.isCompleted)
    ), c = Me(
      () => o.find((C) => C.isActive) || o[0]
    ), v = Me(() => o.indexOf(c.value)), g = Me(() => v.value < o.length - 1), f = Me(() => v.value > 0), _ = () => {
      g.value && (c.value.onNext && c.value.onNext(), b(o[v.value + 1]));
    }, b = (C) => {
      C !== c.value && (c.value.isActive = !1, C.isActive = !0, n("onStepChanged", C));
    };
    return e({
      goToNextStep: _,
      setActiveStep: b,
      goToPrevStep: () => {
        if (!f.value)
          return;
        if (!g.value && c.value.isCompleted) {
          c.value.isCompleted = !1;
          return;
        }
        const C = o[v.value - 1];
        C.isCompleted = !1, c.value.onPrev && c.value.onPrev(), b(C);
      },
      goToFirstStep: () => {
        f.value || b(o[0]);
      },
      onCompleteStep: () => {
        c.value.onComplete && c.value.onComplete(), c.value.isCompleted = !0, _();
      }
    }), (C, Y) => (d(), h("div", K1, [
      l("div", J1, [
        (d(!0), h(R, null, X(o, (O, $) => (d(), h("div", {
          key: $,
          class: P([{
            active: O.isActive,
            completed: O.isCompleted,
            disabled: C.isDisabled
          }, "stepper-step"]),
          style: pe({ width: 100 / o.length + "%" })
        }, [
          l("div", e0, [
            O.isCompleted ? (d(), h("div", t0, n0)) : (d(), h(R, { key: 1 }, [
              r0,
              l("span", null, " " + k($ + 1) + " ", 1),
              l("span", s0, "из " + k(o.length), 1)
            ], 64))
          ]),
          l("div", {
            class: P([{
              disabled: C.isDisabled
            }, "stepper-step-title"])
          }, k(O.title), 3)
        ], 6))), 128)),
        l("div", i0, [
          C.isDisabled === !1 ? (d(), h("div", {
            key: 0,
            style: pe({
              width: 100 / (o.length - 1) * u.value.length + "%"
            }),
            class: "stepper-steps-line-active"
          }, null, 4)) : F("", !0)
        ])
      ]),
      l("div", o0, [
        (d(!0), h(R, null, X(o, (O, $) => (d(), ct(Sa({ ...H(a).default()[$], props: O })))), 256))
      ])
    ]));
  }
}), c0 = /* @__PURE__ */ B(l0, [["__scopeId", "data-v-d61312e1"]]), d0 = { key: 0 }, h0 = {
  name: "aeb-stepper-step"
}, f0 = /* @__PURE__ */ A({
  ...h0,
  props: {
    isActive: { type: Boolean, default: !1 }
  },
  setup(r) {
    return (e, t) => e.isActive ? (d(), h("div", d0, [
      U(e.$slots, "default")
    ])) : F("", !0);
  }
}), v0 = ["src", "alt"], p0 = {
  name: "aeb-response"
}, m0 = /* @__PURE__ */ A({
  ...p0,
  props: {
    code: {},
    mode: { default: "light" }
  },
  setup(r) {
    return (e, t) => e.code ? (d(), h("img", {
      key: 0,
      src: "/images/responses/" + e.code + "-" + e.mode + ".svg",
      alt: e.code.toString()
    }, null, 8, v0)) : F("", !0);
  }
}), Pa = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Accordion: Pn,
  ActionBar: Ln,
  Breadcrumbs: dd,
  Button: Ue,
  ButtonOld: Wn,
  Checkbox: Jn,
  CheckboxOld: ur,
  ClickOutside: dt,
  CodeInput: kr,
  Comment: as,
  CreditItemCard: ys,
  DatePicker: El,
  DatePickerCore: nn,
  DatePickerMonth: an,
  DatePickerTiles: Xt,
  DragAndDrop: dn,
  Dropdown: Ol,
  FieldSlider: Yl,
  FileAttach: oc,
  FilterTag: fn,
  FilterTags: fc,
  Footer: Yc,
  FooterBottom: mn,
  FooterMenu: pn,
  FooterTop: vn,
  FormField: st,
  Header: qc,
  Heading: ad,
  Input: bt,
  Label: Md,
  Logo: Kc,
  Modal: Bd,
  NewsCard: Yd,
  Notifications: th,
  Option: la,
  Pagination: Ah,
  PaginationOld: Xh,
  PopUp: ef,
  PopUpComponent: cf,
  ProductTitle: wd,
  RadioButtons: mf,
  Response: m0,
  Search: Of,
  Select: ua,
  Sidebar: jf,
  Slider: e1,
  Spinner: i1,
  Stepper: c0,
  StepperStep: f0,
  Table: b1,
  Tabs: D1,
  TagTab: M1,
  Textarea: Ia,
  Tooltip: Ba,
  TooltipComponent: Oa,
  Visa: L1,
  VisaItem: U1,
  VisaSpanSubtitle: X1,
  VisaSpanTitle: j1
}, Symbol.toStringTag, { value: "Module" })), _0 = {
  install(r) {
    for (const e in Pa)
      r.component(Pa[e]);
  }
};
export {
  Pn as Accordion,
  Ln as ActionBar,
  dd as Breadcrumbs,
  Ue as Button,
  Wn as ButtonOld,
  Jn as Checkbox,
  ur as CheckboxOld,
  dt as ClickOutside,
  kr as CodeInput,
  as as Comment,
  ys as CreditItemCard,
  El as DatePicker,
  nn as DatePickerCore,
  an as DatePickerMonth,
  Xt as DatePickerTiles,
  dn as DragAndDrop,
  Ol as Dropdown,
  Yl as FieldSlider,
  oc as FileAttach,
  fn as FilterTag,
  fc as FilterTags,
  Yc as Footer,
  mn as FooterBottom,
  pn as FooterMenu,
  vn as FooterTop,
  st as FormField,
  qc as Header,
  ad as Heading,
  bt as Input,
  Md as Label,
  Kc as Logo,
  Bd as Modal,
  Yd as NewsCard,
  th as Notifications,
  la as Option,
  Ah as Pagination,
  Xh as PaginationOld,
  ef as PopUp,
  cf as PopUpComponent,
  wd as ProductTitle,
  mf as RadioButtons,
  m0 as Response,
  Of as Search,
  ua as Select,
  jf as Sidebar,
  e1 as Slider,
  i1 as Spinner,
  c0 as Stepper,
  f0 as StepperStep,
  b1 as Table,
  D1 as Tabs,
  M1 as TagTab,
  Ia as Textarea,
  Ba as Tooltip,
  Oa as TooltipComponent,
  L1 as Visa,
  U1 as VisaItem,
  X1 as VisaSpanSubtitle,
  j1 as VisaSpanTitle,
  _0 as default
};
